import { validation, validateForm, validateElement } from '/source/_patterns/01-components/form/form';
import { nextStep, prevStep, goToStep, orderError } from '/source/_patterns/01-components/demo/demo';
import { showSpinner, hideSpinner } from '/source/_patterns/01-components/spinner/spinner';
import { announcePolite, announceAssertive, announceCartUpdate } from '/source/js/utils/announceUtil';
import cartReviewProductLine from '/source/_patterns/01-components/cart/partials/cartReviewProductLine.hbs';
import cartReviewProductLineModernized from '/source/_patterns/01-components/cart/partials/cartReviewProductLineModernized.hbs';
import availableCouponsModal from '/source/_patterns/01-components/coupon-modal/partials/available-coupons-modal.hbs';
import * as cartService from '/source/js/services/cartService';
import * as checkoutService from '/source/js/services/checkoutService';
import * as toast from '/source/js/utils/toastUtil'; //eslint-disable-line
import { setMainErrorMessage, hideMainErrorMessage, hideMainPaymentErrorMessage, moveToNextCheckoutStep, loadAddress, addAddress, removeAddress, focusOnAnyErrors, checkoutPrev,
    checkCouponsModal, removeCoupon, updateAnchorsToCultureCode, configureAddressFieldInvalidCharsValidator, isRequiredField, getToastMessage,
    paymentFormDirty, isPaymentManageAutoship, focusOnAnyErrorsOnPage } from './checkout-shared';
import { updatePaymentContinueButtonVisibility } from './checkout-modernized';
import { addGtmTagTocheckout, setDataForAllProducts, addGtmTagToPurchase, addShippingInfo, addGtmTagForPaymentInfo, addGtmTagForReviewPage } from '/source/js/gtm/IsaGtmCommerce';
import * as autoshipService from '/source/js/services/autoshipService';
import * as recommendedCartService from '/source/js/services/recommendedCartService';
import * as modalUtil from '/source/js/utils/modal/modalUtil';
import { validCookieId } from '/source/js/utils/validCookie';
import { handleVIESErrorMessageIfAny } from './vat-info';
import { clearCouponFieldOnSuccess } from '../common/common';

const SUBSCRIPTION_CART = 'Subscription';
const BILLING_INFO = '.checkout__billing-information';
const SHIPPING_INFO = '.checkout__shipping-information';
const CREDIT_CARDS = '.credit-cards';
const CHECKOUT_SUBSCRIBE = '.checkout__subscribe';
const CHECKOUT_SAVE = '.checkout__save-block';
const PAYMENT_METHOD_CC = 'cc';
const PAYMENT_METHOD_PAYPAL = 'paypal';
const PAYMENT_METHOD_VENMO = 'venmo';
const PAYMENT_METHOD_SEPA = 'sepa';
const SHIPPING_TYPE_SHIPPING = 'shipping';
const SHIPPING_TYPE_PICKUP = 'pickup';
const FORM_PAYMENT = 'form#payment';
const CART_SHIPPING_TYPE = $('#shippingType').val();
const ISAWALLET = 'isawallet';
const BANCONTACT = 'bancontact';
const IDEAL = 'ideal';
const CASH = 'cash';
const DEBIT_CARD = 'debitCard';
const BancontactFallBackButtonText = 'Complete Payment';
const ERROR_TOAST_EXPIRATION_MS = 3000;
const PAYMETRIC_IFRAME_LOAD_TIMEOUT_MS = 12000;
const PAYMETRIC_IFRAME_MAX_RETRIES = 2;
const BUNDLE_REVIEW_PAGE = 'BundleReviewPage';
let INDEX_NAME;
let allFlowIsEnabled;
let applePayMsgVM;
let applePayDetailVM;
let paymetricIframeLoadTimeoutId = null;
let paymetricIframeRetryCount = 0;
let paymetricPreviousSavedPaymentId = null;
let melissa = {
    addresses: {},
    enteredAddress: {},
    selectedAddress: {},
    status: undefined,
    sameAddress: false
};

let addressState = {
    singleStateOptionSelected: false
};

// Address autocomplete state
let addressAutocomplete = {
    timeout: null,
    minChars: 3,
    debounceMs: 300,
    suggestions: [],
    selectedIndex: -1,
    isVisible: false
};

let paypalData = {};
let venmoData = {};

let savedAddresses = [];
let isSavedBillingInformation = false;
let isMelissaAddressEnabledForUser = true;
let saveChangesRedirectUrl = '/';
let nonDefaultAddressLines = ['2', '3'];
let marketAddressCheckoutSettings;
let hasInvalidPostalCode = false;

function placeOrder() {
    if($('#cart-max-td-error').length > 0 && !$('#cart-max-td-error').hasClass('d-none')) { return; }
    let $this = $(this);
    validateReviewForm($this);
}

function editStep() {
    let $this = $(this);
    let pageUrl = $this.data('pageurl');
    if (!!pageUrl) {//eslint-disable-line
        window.location.href = pageUrl;
    }
}

function syncShippingMethodSelection() {
    if(!$('.checkout-v2').length) {
        return $('#selectedShippingMethod').val() || '';
    }
    let $selectedRadio = $('#shippingMethodRadioList input[name="shippingOptionRadio"]:checked');
    let selectedValue = $selectedRadio.length ? $selectedRadio.val() : $('#shippingOption').val();
    if((!selectedValue || selectedValue === 'default') && $('#selectedShippingMethod').val()) {
        selectedValue = $('#selectedShippingMethod').val();
    }
    if(selectedValue && selectedValue !== 'default') {
        $('#shippingOption').val(selectedValue);
        $('#selectedShippingMethod').val(selectedValue);
    }
    return selectedValue;
}

// Called from paypalTokenizedPayment() after a successful client-side (no page
// reload) PayPal login. Legacy reveals its own summary via .form-block--paypal-info, which
// doesn't exist in the modernized markup - the modernized PayPal summary blocks (info row /
// divider / Secure PayPal Checkout box) are rendered with .checkout__payment-block.payment-paypal
// and start hidden (d-none) from the server, so nothing else reveals them without this call.
function revealPaypalSummaryModernized() {
    if(!$('.checkout-v2').length) return;
    $('.payment__providers').hide();
    $('.checkout__payment-block').addClass('d-none');
    $('.payment-paypal').removeClass('d-none').css('display', '');
    $('.form-block--change-payment').show();
    if($('.mod-payment-method-card').length > 0) {
        $('.mod-payment-selection').hide();
    }
    $('.mod-payment-selection__change-wrap').show();
}

// Called from venmoTokenizedPayment() after a successful client-side (no page reload) Venmo
// login. Legacy reveals its own summary via .form-block--venmo-info, which doesn't exist in the
// modernized markup - the modernized Venmo summary blocks (info row / Secure Venmo Checkout box)
// are rendered with .checkout__payment-block.payment-venmo and start hidden (d-none) from the
// server, so nothing else reveals them without this call. Mirrors revealPaypalSummaryModernized().
function revealVenmoSummaryModernized() {
    if(!$('.checkout-v2').length) return;
    $('.payment__providers').hide();
    $('.checkout__payment-block').addClass('d-none');
    $('.payment-venmo').removeClass('d-none').css('display', '');
    $('.form-block--change-payment').show();
    if($('.mod-payment-method-card').length > 0) {
        $('.mod-payment-selection').hide();
    }
    $('.mod-payment-selection__change-wrap').show();
}

function showItemsRemovedWarning() {
    let isShowItemsRemovedWarningSubscription = $('#ShowItemsRemovedWarning_subscription').val();
    let isShowItemsRemovedWarningTodays = $('#ShowItemsRemovedWarning_todays').val();
    if(isShowItemsRemovedWarningSubscription === 'True' || isShowItemsRemovedWarningTodays === 'True') {
        $('#ItemsRemovedFromRecommendedCartError').removeClass('d-none');
    }
}

async function submitForm($form, $element, failedCallback) {
    try {
        if($form[0] && $form[0].id === 'shipping' && $('.checkout-v2').length) {
            syncShippingMethodSelection();
        }
        if(isPaymentManageAutoship()) {
            await submitFormPaymentManageAutoship($form, $element, failedCallback);
        } else {
            let $show3ds = $('#hidden-show-3ds').val();
            let $3dsVerified = $('#hidden-3ds-verified').val();
            let $3dsVerifiedSubscriptionCart = $('#hidden-3ds-verified-subscription-cart').val();
            let $3dsSubscriptionCart = $('#hidden-3ds-subscription-cart').val();

            if($show3ds === 'true' && $3dsVerified === 'false') { // 3DS for today's Cart
                loadIFrame($3dsSubscriptionCart);
            } else if($show3ds === 'true' && $3dsVerifiedSubscriptionCart === 'false' && $('#verifyCVVSubscription').length) { // 3DS for Subscription Cart
                loadIFrame(true);
            } else {
                hideMainPaymentErrorMessage();
                hideMainErrorMessage();
                showSpinner('Submitting form started');
                let result = await $.ajax({
                    headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val(), CheckoutFlowCookieId: $('input[name="FlowRiderCookieId"]').val() },
                    type: 'POST',
                    url: $element.data('submiturl'),
                    data: $form.serialize()
                });
                result = validCookieId(result);

                if(result && result.IsSuccessful) {
                    if(isShippingManageAutoship()) {
                        updateCartMessage(result);
                    }

                    // if shipping, add gtm
                    if($form[0].id === 'shipping') {
                        // 'b146622d-dc86-48a3-b72a-05ee8ffd187a|Ground|Ground|Price'

                        let value = '';
                        var shippingType = $form[0].shippingType.value;
                        if(('#hidden-order-non-shippable-items').length === 0) {
                            if(shippingType === 'pickup') {
                                value = $form[0].pickupOption.selectedOptions[0].value;
                            } else {
                                value = $form[0].shippingOption.selectedOptions[0].value;
                            }
                        }
                        if(value) {
                            let values = value.split('|');

                            if(values.length < 4) {
                                console.log(`submitForm: Error on shipping value, it is less than 4. Value = ${value}`);
                            } else {
                                var shippingMethod = values[1];
                                var shippingCost = values[3];

                                addShippingInfo(shippingMethod, shippingCost);
                            }
                        } else {
                            console.log(`submitForm: Error on shipping value, value is null or undefined. shippingType: ${shippingType}`);
                        }
                    }

                    if($element.data('submiturl') && $element.data('submiturl').includes('checkoutpayment')) {
                        addGtmTagToFlowSteps('4');
                    }
                    if($element.data('submiturl') && $element.data('submiturl').includes('checkoutshipping')) {
                        addGtmTagToFlowSteps('3');
                    }
                    moveToNextCheckoutStep(result);
                } else {
                    if($3dsVerified !== undefined) { $('#hidden-3ds-verified').val('false'); }
                    if($3dsVerifiedSubscriptionCart !== undefined) { $('#hidden-3ds-verified-subscription-cart').val('false'); }
                    hideSpinner('Submitting fom halted');
                    if(handleVIESErrorMessageIfAny(result)) {
                        return;
                    }
                    if(failedCallback) {
                        failedCallback(result);
                    }

                    var $isReviewPage = $('#isReviewPage');
                    if($isReviewPage && $isReviewPage.length >= 1 && result.AuthorizePaymentFailedBraintree) {
                        // hide payment
                        let $paymentData = $('.paymentData');
                        let $paymentDataSubscription = $('.paymentDataSubscription');
                        let $addPaymentInfo = $('.addPaymentInfo');
                        let $addPaymentInfoSubscription = $('.addPaymentInfoSubscription');

                        // payment data NOT present
                        if($paymentData.length > 0) {
                            $paymentData.hide();
                        }
                        if($paymentDataSubscription.length > 0) {
                            $paymentDataSubscription.hide();
                        }
                        if($addPaymentInfo.length > 0) {
                            $addPaymentInfo.show();
                        }
                        if($addPaymentInfoSubscription.length > 0) {
                            $addPaymentInfoSubscription.show();
                        }
                    }
                }
            }
        }
        focusOnAnyErrorsOnPage();
    } catch (e) {
        hideSpinner('Submitting form failed');
        console.error(e);
    }
}

function isShippingManageAutoship() {
    let isManageAutoship = $('#isManageAutoship').val();
    return isManageAutoship && isManageAutoship.toLowerCase() === 'true' && $('form#shipping').length > 0;
}

async function submitFormPaymentManageAutoship($form, $element, failedCallback) {
    hideMainErrorMessage();
    showSpinner('manage autoship payment started');
    let result = await $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val(), CheckoutFlowCookieId: $('input[name="FlowRiderCookieId"]').val() },
        type: 'POST',
        url: $element.data('submiturl'),
        data: $form.serialize()
    });
    result = validCookieId(result);

    if(result && result.IsSuccessful) {
        if($('#paymentChanged').val() === 'false') {
            moveToNextCheckoutStep(result);
            return;
        }
        hideSpinner('manage autoship payment completed');
        let $show3ds = $('#hidden-show-3ds').val();
        let $3dsVerified = $('#hidden-3ds-verified').val();
        let $3dsSubscriptionCart = $('#hidden-3ds-subscription-cart').val();
        if($show3ds === 'true' && $3dsVerified === 'false') { // 3DS for today's Cart
            loadIFrame($3dsSubscriptionCart);
        } else {
            confirmPaymentChanges();
        }
    } else {
        if($('#hidden-3ds-verified') !== undefined) { $('#hidden-3ds-verified').val('false'); }
        hideSpinner('manage autoship payment halted');
        updateCartMessage(result);
        if(handleVIESErrorMessageIfAny(result)) {
            return;
        }
        if(failedCallback) {
            failedCallback(result);
        }
    }
}

async function confirmPaymentChanges() {  // eslint-disable-line
    if(!isPaymentManageAutoship() && $('#paymentChanged').val() === 'true') return;
    let $form = $('form#payment');
    showSpinner('confirming payment changes started');
    let result = await checkoutService.confirmPaymentChanges($form.serialize());
    if(result && result.IsSuccessful) {
        hideSpinner('confirming payment changes completed');
        updateCartMessage(result);
        moveToNextCheckoutStep(result);
    } else {
        if($('#hidden-3ds-verified') !== undefined) { $('#hidden-3ds-verified').val('false'); }
        hideSpinner('confirming payment changes halted');
        updateCartMessage(result);
        submitFailedCallback(result);
    }
}

function loadIFrame($isSubscription) {
    // Add the event listener
    window.addEventListener('message', window.receiveMessage, false);  // eslint-disable-line

    var iframe = $('#3dsIframe');
    var iFrameUrl = iframe.data('src');

    if($isSubscription === true || $isSubscription === 'true') {
        $('#cart-name').html($('#hidden-3ds-subscription-header').val());
        iframe.attr('src', iFrameUrl + '?isSubscriptionCart=true');
    } else {
        $('#cart-name').html($('#hidden-3ds-todays-header').val());
        iframe.attr('src', iFrameUrl + '?isSubscriptionCart=false');
    }

    $('#3DSModal').addClass('show');
    $('#3DSModal').css('display', 'block');
}

function updateShippingType($selectedTab) {
    let $activeShippingTab = $selectedTab ? $selectedTab : $('.checkout__tab-link.active, .mod-tabs__link.active');  // eslint-disable-line
    let id = $activeShippingTab.prop('id');
    let shippingType = SHIPPING_TYPE_SHIPPING;
    if(id && id.startsWith(SHIPPING_TYPE_PICKUP)) {
        shippingType = SHIPPING_TYPE_PICKUP;
    }
    $('#shippingType').val(shippingType);
    return shippingType;
}

async function validateShippingForm($element) {
    let shippingType = updateShippingType();
    let $form = $('form#shipping');

    if(!$form.length) return;

    let $phone = $('#phone');
    if($phone.val()) {
        let $phonetext = $phone.val().trim();
        $phone.val($phonetext);
    }

    let $zipCode = $('#zipCodeInput');
    if($zipCode.val()) {
        let $zipCodeText = $zipCode.val().replace(/\s+$/, '');
        $zipCode.val($zipCodeText);
    }

    if(shippingType === SHIPPING_TYPE_SHIPPING) {
        let shippingValid = validateForm($form, getFullShippingValidationConfiguration());
        focusOnAnyErrors();
        $('#email').blur();
        hideAddNewAddressValidationMessage();
        if(IsSameAddressFieldsAndSelectedAddress() || !isMelissaAddressEnabled()) {
            if(shippingValid) {
                submitForm($form, $element, submitFailedCallback);
            } else if(isOnlyPhoneInvalidForSavedAddress($form)) {
                // Wholesale/Subscription: saved address is otherwise valid - the phone field is
                // already shown below the read-only card, so don't fall back to the manual form.

            } else {
                showAddNewAddressValidationMessage();
            }
        } else {
            await verifyShippingAddress();
        }
    } else if(shippingType === SHIPPING_TYPE_PICKUP) {
        let pickupValid = validateForm($form, getPickupShippingValidationConfiguration());
        if(pickupValid) {
            submitForm($form, $element, submitFailedCallback);
        } else {
            let $pickupTermsError = $('#pickupTerms-error');
            if($pickupTermsError && $pickupTermsError.length > 0 && $pickupTermsError.css('display') !== 'none' && !$pickupTermsError.closest('.checkout-v2').length) {
                // pickup terms validation error is showing
                $pickupTermsError.css('position', 'absolute');
            }
        }
    }
}

async function validatePaymentForm($element) {
    let $form = $(FORM_PAYMENT);
    let paymentType = $form.data('payment-type');
    if(!$form.length) return;

    // Modernized checkout: while the payment-selection area is showing (i.e. no payment
    // has been set for today's order yet), require either a saved payment method or a
    // new payment method card to be selected before continuing.
    if($('.mod-payment-method-card').length > 0 && $('.mod-payment-selection').is(':visible')) {
        let hasSavedSelected = $('.mod-saved-payments__radio:checked').length > 0;
        let hasCardSelected = $('.mod-payment-method-card.is--selected').length > 0;
        if(!hasSavedSelected && !hasCardSelected) {
            setMainErrorMessage('Please select a payment method to continue.');
            return;
        }
    }

    let $zipCode = $('#zipCodeInput');
    if($zipCode.val()) {
        let $zipCodeText = $zipCode.val().replace(/\s+$/, '');
        $zipCode.val($zipCodeText);
    }

    if(paymentType === PAYMENT_METHOD_CC) {
        let paymentValid = validateForm($form, getPaymentValidationConfiguration());
        let cardPassedError = $('#cardPassed-error');
        if(cardPassedError) {
            cardPassedError.addClass('d-none');
        }
        if(paymentValid) {
            clearPaypalData();
            clearVenmoData();
            clearBancontact();
            clearIdealData();
            clearSepaData(true);
            clearIsaWallet();
            submitForm($form, $element, submitFailedCallback);
        } else {
            postPaymentSubmitCheck();
            $('html, body').animate({
                scrollTop: $('.cart-checkout__section').offset().top
            }, 800);
        }
    } else if(paymentType === PAYMENT_METHOD_PAYPAL) {
        checkPaypalPayment();
        // TODO: EU team will refactor stateInput since it makes validation fail for paypal
        $('#stateInput').prop('required', false);
        let paymentValid = validateForm($form, getPaypalPaymentValidationConfiguration());
        if(paymentValid) {
            hidePaypalInformationMessage();
            clearVenmoData();
            clearBancontact();
            clearIdealData();
            clearSepaData(true);
            clearIsaWallet();
            submitForm($form, $element, submitFailedCallback);
        } else {
            showPaypalInformationAsValidationMessage();
        }
    } else if(paymentType === PAYMENT_METHOD_VENMO) {
        checkVenmoPayment();
        $('#stateInput').prop('required', false);
        let paymentValid = validateForm($form, getVenmoPaymentValidationConfiguration());
        if(paymentValid) {
            hidePaypalInformationMessage();
            clearPaypalData();
            clearBancontact();
            clearIdealData();
            clearSepaData(true);
            clearIsaWallet();
            submitForm($form, $element, submitFailedCallback);
        } else {
            showVenmoInformationAsValidationMessage();
        }
    } else if(paymentType === PAYMENT_METHOD_SEPA) {
        clearPaypalData();
        clearVenmoData();
        clearBancontact();
        clearIdealData();
        clearIsaWallet();
        let sepaValid = validateForm($form, getSepaPaymentValidationConfiguration());
        if(sepaValid) {
            if($('#iban').is(':visible')) {
                let ibanResult = await ValidateIban($form);
                let ibanElement = $form[0]['iban'];
                let parent = $(ibanElement).closest('div.form-block');
                $(parent).children('span.error').remove();
                if(ibanResult !== '') {
                    $(ibanElement).attr('aria-invalid', 'true');
                    $(ibanElement).attr('aria-describedby', 'iban-error');
                    $(ibanElement).attr('data-iban-error', true);
                    $(ibanElement).attr('data-previous-iban', ibanElement.value);
                    $(ibanElement).attr('data-prev-iban-error-msg', ibanResult);
                    let templateString = `<span id="iban-error" class="error">${ibanResult}</span>`;
                    $(parent).addClass('is--error');
                    $(parent).append(templateString);
                    focusOnAnyErrors();
                    let grandParent = $(ibanElement).closest('.form-group.form-group--half');
                    grandParent.addClass('pb-3');
                    return;
                }
            }
            updatePaymentCTA({ show3DS: false });
            submitForm($form, $element, submitFailedCallback);
        }
    } else if(paymentType === ISAWALLET) {
        clearPaypalData();
        clearVenmoData();
        clearSepaData(true);
        $('.form-block--change-payment').show();
        clearBancontact();
        clearIdealData();
        if($('#isIsawallet').val() !== undefined && $('#isIsawallet').val() === 'false') {
            diplayErrorMessageForInvalidPaymentDetails(true);
            return false;
        }
        $('#isIsawallet').val('true');
        let paymentValid = true;
        if(paymentValid) {
            submitForm($form, $element, submitFailedCallback);
        }
    } else if(paymentType === CASH) {
        clearPaypalData();
        clearVenmoData();
        clearSepaData(true);
        $('.form-block--change-payment').show();
        clearBancontact();
        clearIdealData();
        $('#isIsawallet').val('false');
        $('#debitcardPayment').val('false');
        $('#cashPayment').val('true');
        $('#debitCardAuthorization').val('');
        let paymentValid = true;
        if(paymentValid) {
            submitForm($form, $element, submitFailedCallback);
        }
    } else if(paymentType === DEBIT_CARD) {
        let paymentValid = validateForm($form, getDebitCardValidationConfiguration());
        clearPaypalData();
        clearVenmoData();
        clearSepaData(true);
        $('.form-block--change-payment').show();
        clearBancontact();
        clearIdealData();
        $('#isIsawallet').val('false');
        $('#cashPayment').val('false');
        $('#debitcardPayment').val('true');
        if(paymentValid) {
            submitForm($form, $element, submitFailedCallback);
        } else {
            diplayErrorMessageForInvalidPaymentDetails(true);
        }
    } else if(paymentType === BANCONTACT) {
        clearPaypalData();
        clearVenmoData();
        clearSepaData(true);
        clearIdealData();
        clearIsaWallet();
        if($('#isBancontact').val() !== undefined && $('#isBancontact').val() === 'false') {
            diplayErrorMessageForInvalidPaymentDetails(true);
            return false;
        }
        $('#isBancontact').val('true');
        let paymentValid = true;
        if(paymentValid) {
            submitForm($form, $element, submitFailedCallback);
        }
    } else if(paymentType === IDEAL) {
        clearPaypalData();
        clearVenmoData();
        clearSepaData(true);
        clearBancontact();
        clearIsaWallet();
        $('.form-block--change-payment').show();
        $('#isIDeal').val('true');
        let paymentValid = true;
        if(paymentValid) {
            updatePaymentCTA({ show3DS: false });
            submitForm($form, $element, submitFailedCallback);
        }
    }
}

function validateReviewForm($element) {
    // addGtmTag();
    let $form = $('form#submitorder');
    if(validateOnlyReviewForm()) { submitForm($form, $element, submitCVVFailedCallback); }
}

function validateOnlyReviewForm() {
    let $submitform = $('form#submitorder');
    let $disclaimersform = $('form#checkoutDisclaimers');
    let $commonDisclaimersform = $('form#commonDisclaimerForm');
    if($submitform.length > 0) {
        let reviewValid = validateForm($submitform, getReviewValidationConfiguration());

        let disclaimersValid = true;
        if($disclaimersform.length > 0 && $('#checkout-disclaimers-content').is(':visible')) {
            disclaimersValid = validateForm($disclaimersform, getDisclaimersValidationConfiguration());
        }

        let commonDisclaimersValid = true;
        if($commonDisclaimersform.length > 0) {
            commonDisclaimersValid = validateForm($commonDisclaimersform, getCommonDisclaimersValidationConfiguration());
        }

        focusOnAnyErrors();
        return reviewValid && disclaimersValid && commonDisclaimersValid;
    }
    return false;
}

function showAddNewAddressValidationMessage() {
    let $shippingAddressMessage = $('.checkout-shipping-error');
    let $checkoutErrorText = $('.checkout-error__text');
    if($checkoutErrorText.text()) {
        $shippingAddressMessage.removeClass('d-none');
        $shippingAddressMessage.siblings('button').addClass('is--error');
    }
    $('.checkout__shipping-info-current').hide();
    $('.checkout__shipping-info-manual').show();
    moveSavedAddressPhoneToManualEntry();
}

function hideAddNewAddressValidationMessage() {
    let $shippingAddressMessage = $('.checkout-shipping-error');
    $shippingAddressMessage.addClass('d-none');
    $shippingAddressMessage.siblings('button').removeClass('is--error');
}

function showPaypalInformationAsValidationMessage() {
    $('.paypal-information-message').css('color', 'red');
}

function hidePaypalInformationMessage() {
    $('.paypal-information-message').addClass('d-none');
}

function showVenmoInformationAsValidationMessage() {
    $('.venmo-information-message').css('color', 'red');
}

function hideVenmoInformationMessage() {
    $('.venmo-information-message').addClass('d-none');
}

function submitFailedCallback(result) {
    if(result && result.Messages) {
        let msg = result.Messages.find(msg => msg.DisplayMessage === true);
        if(!msg) msg = result.Messages[0];
        setMainErrorMessage(msg.MessageText);
    }
}

function submitCVVFailedCallback(result) {
    if(result && result.CVVFailed) {
        let cvvElement = '#verifyCVV';
        if(result.SubscriptionCVVFailed) {
            cvvElement = '#verifyCVVSubscription';
        }
        let $verifyCVV = $(cvvElement);
        $verifyCVV.parent().addClass('is--error')
            .append(`<span id="verifyCVV-error" class="error">${result.MsgToDisplay}</span>`);
        focusOnAnyErrors();
        $('body').scrollTo($verifyCVV);
    } else {
        submitFailedCallback(result);
    }
}

function getFullShippingValidationConfiguration() {
    return {
        onfocusout: function (element) {
            this.element(element);
        },
        // Modernized markup wraps inputs in .mod-field; add mod-field--error there so the field gets the red-border error state. Fallback to legacy .is--error on the input's parent.
        highlight: function (element) {
            const $modField = $(element).closest('.mod-field');
            if($modField.length) {
                $modField.addClass('mod-field--error');
            } else {
                $(element).parent().addClass('is--error');
            }
        },
        unhighlight: function (element) {
            const $modField = $(element).closest('.mod-field');
            if($modField.length) {
                $modField.removeClass('mod-field--error');
            } else {
                $(element).parent().removeClass('is--error');
            }
        },
        ignore: null,
        errorElement: 'span',
        rules: {
            email: {
                required: true,
                matchesPattern: true
            },
            firstName: {
                required: true,
                checkInvalidChars: !isExistsInSavedAddresses()
            },
            lastName: {
                required: !isExistsInSavedAddresses(),
                checkInvalidChars: !isExistsInSavedAddresses()
            },
            cityInput: {
                required: true,
                checkAddressFieldInvalidChars: true
            },
            stateInput: {
                required: true,
                hasValidSelection: true
            },
            address1Input: {
                required: true,
                checkAddressFieldInvalidChars: true
            },
            address2Input: {
                required: isRequireddAddressLine(2),
                checkAddressFieldInvalidChars: true
            },
            address3Input: {
                required: false,
                checkAddressFieldInvalidChars: true
            },
            address4Input: {
                required: '#address4Input' && isRequireddAddressLine(4),
                checkAddressFieldInvalidChars: true
            },
            zipCodeInput: {
                required: true,
                matchesPattern: true
            },
            phoneCountryCode: {
                required: true,
                hasValidSelection: true
            },
            phone: {
                required: true,
                isFormatValid: true
            },
            shippingOption: {
                required: !$('.checkout-v2').length || $('#shippingOption option').length > 1,
                hasValidSelection: true
            },
            deliveryInstructions: {
                required: false,
                hasDeliveryInstructions: true
            }
        }
    };
}

function getPickupShippingValidationConfiguration() {
    return {
        onfocusout: function (element) {
            this.element(element);
        },
        // Modernized markup wraps inputs in .mod-field; add mod-field--error there so the field gets the red-border error state. Fallback to legacy .is--error on the input's parent.
        highlight: function (element) {
            const $modField = $(element).closest('.mod-field');
            const $modCheckbox = $(element).closest('.mod-checkbox');
            if($modField.length) {
                $modField.addClass('mod-field--error');
            } else if($modCheckbox.length) {
                $modCheckbox.addClass('mod-checkbox--error');
            } else {
                $(element).parent().addClass('is--error');
            }
        },
        unhighlight: function (element) {
            const $modField = $(element).closest('.mod-field');
            const $modCheckbox = $(element).closest('.mod-checkbox');
            if($modField.length) {
                $modField.removeClass('mod-field--error');
            } else if($modCheckbox.length) {
                $modCheckbox.removeClass('mod-checkbox--error');
            } else {
                $(element).parent().removeClass('is--error');
            }
        },
        ignore: null,
        errorElement: 'span',
        errorPlacement: function (error, element) {
            const $modCheckbox = $(element).closest('.mod-checkbox');
            if($modCheckbox.length) {
                error.addClass('mod-checkbox__error-msg').attr('role', 'alert');
                error.insertAfter($modCheckbox);
            } else {
                error.insertAfter(element);
            }
        },
        rules: {
            email: {
                required: true
            },
            firstNamePickup: {
                required: true,
                checkInvalidChars: true
            },
            lastNamePickup: {
                required: true,
                checkInvalidChars: true
            },
            phonePickup: {
                required: true,
                isFormatValid: true
            },
            phonePickupCountryCode: {
                required: true,
                hasValidSelection: true
            },
            pickupOption: {
                required: isPickupOptionSelectionRequired(),
                hasValidSelection: true
            },
            pickupTerms: {
                required: '#pickupTerms'
            }
        }
    };
}

function getDebitCardValidationConfiguration() {
    jQuery.validator.addMethod('alphanumeric', function(value, element) {
        return this.optional(element) || /^[a-zA-Z0-9]+$/i.test(value);
    });

    var authorizationCode = $('#authorizationCode').val();
    var invalidCode = $('#invalidCode').val();

    return {
        onfocusout: function (element) {
            this.element(element);
        },
        highlight: function (element) {
            $(element).parent().addClass('is--error');
        },
        unhighlight: function (element) {
            $(element).parent().removeClass('is--error');
        },
        ignore: null,
        errorElement: 'span',
        rules: {
            debitCardAuthorization: {
                required: true,
                alphanumeric: true,
                maxlength: 25
            }
        },
        messages: {
            debitCardAuthorization: {
                required: authorizationCode,
                alphanumeric: invalidCode,
                maxlength: invalidCode
            }
        }
    };
}
function getPaymentValidationConfiguration() {
    return {
        onfocusout: function (element) {
            this.element(element);
        },
        highlight: function (element) {
            if(element.id === 'verifyCVV') {
                $(element).parent().addClass('is--error');
            } else {
                scrollToErrorMessageAndFocus();
            }
        },
        unhighlight: function (element) {
            $(element).parent().removeClass('is--error');
        },
        ignore: null,
        errorElement: 'span',
        rules: {
            firstNameBilling: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation,
                checkInvalidChars: true
            },
            lastNameBilling: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation,
                checkInvalidChars: true
            },
            cardPassed: {
                isValueTrue: true
            },
            cityInput: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation,
                checkAddressFieldInvalidChars: true
            },
            stateInput: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation,
                hasValidSelection: true
            },
            address1Input: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation,
                checkAddressFieldInvalidChars: true
            },
            address2Input: {
                required: false,
                checkAddressFieldInvalidChars: true
            },
            address3Input: {
                required: false,
                checkAddressFieldInvalidChars: true
            },
            address4Input: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation && isRequireddAddressLine(4),
                checkAddressFieldInvalidChars: true
            },
            zipCodeInput: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation,
                matchesPattern: true
            },
            verifyCVV: {
                required: $('#verifyCVV').is(':visible'),
                isCVV: $('#verifyCVV').is(':visible')
            }
        }
    };
}

function scrollToErrorMessageAndFocus() {
    let sectionId = $('#checkout-cart__section');
    if(sectionId.length) {
        let errorMsgParent = $(sectionId).find('.checkout-error__message');
        if(errorMsgParent.length) {
            if(!errorMsgParent.hasClass('d-none')) {
                errorMsgParent.focus();
                $('html, body').animate({
                    scrollTop: errorMsgParent.offset().top - 100
                }, 100);
            }
        }
    }
}

function getPaypalPaymentValidationConfiguration() {
    return {
        onfocusout: function (element) {
            this.element(element);
        },
        highlight: function (element) {
            scrollToErrorMessageAndFocus();
        },
        unhighlight: function (element) {
            $(element).parent().removeClass('is--error');
        },
        errorPlacement: function (error, element) {
            console.log('element:', element);
            console.log('error:', error);
        },
        ignore: null,
        errorElement: 'span',
        rules: {
            paypalAuth: {
                required: true,
                hasNonce: true
            }
        }
    };
}

function getVenmoPaymentValidationConfiguration() {
    return {
        onfocusout: function (element) {
            this.element(element);
        },
        highlight: function (element) {
            scrollToErrorMessageAndFocus();
        },
        unhighlight: function (element) {
            $(element).parent().removeClass('is--error');
        },
        errorPlacement: function (error, element) {
            console.log('element:', element);
            console.log('error:', error);
        },
        ignore: null,
        errorElement: 'span',
        rules: {
            venmoAuth: {
                required: true,
                hasVenmoNonce: true
            }
        }
    };
}

function getSepaPaymentValidationConfiguration() {
    return {
        onfocusout: function (element) {
            this.element(element);
        },
        highlight: function (element) {
            scrollToErrorMessageAndFocus();
        },
        unhighlight: function (element) {
            $(element).parent().removeClass('is--error');
        },
        ignore: null,
        errorElement: 'span',
        rules: {
            sepaName: {
                required: $('#sepaName').is(':visible'),
                hasSepaName: true
            },
            iban: {
                required: $('#iban').is(':visible'),
                isValidIban: $('#iban').is(':visible')
            },
            sepaAgreement: {
                required: $('#sepaAgreement').is(':visible')
            },
            firstNameBilling: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation,
                checkInvalidChars: true
            },
            lastNameBilling: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation,
                checkInvalidChars: true
            },
            cityInput: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation,
                checkAddressFieldInvalidChars: true
            },
            stateInput: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation,
                hasValidSelection: true
            },
            address1Input: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation,
                checkAddressFieldInvalidChars: true
            },
            address2Input: {
                required: false,
                checkAddressFieldInvalidChars: true
            },
            address3Input: {
                required: false,
                checkAddressFieldInvalidChars: true
            },
            address4Input: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation,
                checkAddressFieldInvalidChars: true
            },
            zipCodeInput: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation,
                matchesPattern: true
            },
            countryBilling: {
                required: !$('#useShippingAddress').is(':checked') && !isSavedBillingInformation,
                valueNotEquals: 'default'
            }
        }
    };
}

async function ValidateIban($form) {
    let result = '';
    let ibanElement = $form[0]['iban'];
    if($form.length > 0 && $('#iban').is(':visible')) {
        let ibanInput = ibanElement.value;
        if(ibanInput === undefined) {
            return result;
        } else {
            let request = {
                Iban: ibanInput,
                IbanRegex: $(ibanElement).data('pattern'),
                FormatErrorMessage: $(ibanElement).data('format-error'),
                SupportedCountryList: $('#hdnIbanSupporedCountries').val(),
                UnsupportedCountryErrorMessage: $(ibanElement).data('unsupported-country-error'),
                DuplicateIbanErrorMessage: $(ibanElement).data('duplicate-iban-error')
            };
            result = await checkoutService.ValidateIban(request);
        }
        return result;
    }
    return result;
}

function getReviewValidationConfiguration() {
    return {
        onfocusout: function (element) {
            this.element(element);
        },
        highlight: function (element) {
            const $modCheckbox = $(element).closest('.mod-checkbox');
            if($modCheckbox.length) {
                $modCheckbox.addClass('mod-checkbox--error');
            } else {
                $(element).parent().addClass('is--error');
            }
        },
        unhighlight: function (element) {
            const $modCheckbox = $(element).closest('.mod-checkbox');
            if($modCheckbox.length) {
                $modCheckbox.removeClass('mod-checkbox--error');
            } else {
                $(element).parent().removeClass('is--error');
            }
        },
        ignore: null,
        errorElement: 'span',
        errorPlacement: function (error, element) {
            const $modCheckbox = $(element).closest('.mod-checkbox');
            if($modCheckbox.length) {
                error.addClass('mod-checkbox__error-msg').attr('role', 'alert');
                error.insertAfter($modCheckbox);
            } else {
                error.insertAfter(element);
            }
        },
        rules: {
            recommendedCartName: {
                required: $('#recommendedCartName').is(':visible')
            },
            confirmPlacement: {
                required: $('#confirmPlacement').is(':visible')
            },
            acknowledgment: {
                required: $('#acknowledgment').is(':visible')
            },
            verifyCVV: {
                required: $('#verifyCVV').is(':visible'),
                isCVV: true
            },
            verifyCVVSubscription: {
                required: $('#verifyCVVSubscription').is(':visible'),
                isCVV: true
            }
        }
    };
}

function getDisclaimersValidationConfiguration() {
    return {
        onfocusout: function (element) {
            this.element(element);
        },
        highlight: function (element) {
            $(element).parent().addClass('is--error');
        },
        unhighlight: function (element) {
            $(element).parent().removeClass('is--error');
        },
        ignore: null,
        errorElement: 'span',
        rules: {
            ageRestricted: {
                required: true
            }
        }
    };
}
function getCommonDisclaimersValidationConfiguration() {
    return {
        onfocusout: function (element) {
            this.element(element);
        },
        highlight: function (element) {
            $(element).parent().addClass('is--error');
        },
        unhighlight: function (element) {
            $(element).parent().removeClass('is--error');
        },
        ignore: null,
        errorElement: 'span',
        rules: {
            confirmdisclaimer: {
                required: true
            },
            confirmSubsdisclaimer: {
                required: true
            }
        }
    };
}

function updateShippingFormValidator() {
    let $form = $('form#shipping');
    if($form.length > 0) {
        let invalidCharsMsg = $form.data('msg-invalidchars');
        let invalidChars = $form.data('invalidchars');
        configureInvalidCharsValidator(invalidCharsMsg, invalidChars);
        configureAddressFieldInvalidCharsValidator(invalidCharsMsg);
        configureMatchesPatternFormValidator();
        configureSelectFieldFormValidator();
        configureValidFormatFormValidator();
        configureDeliveryInstructionsFormValidator();
    }
}

function updatePaymentFormValidator() {
    let $form = $('form#payment');
    if($form.length > 0) {
        let invalidCharsMsg = $form.data('msg-invalidchars');
        let invalidChars = $form.data('invalidchars');
        configureInvalidCharsValidator(invalidCharsMsg, invalidChars);
        configureAddressFieldInvalidCharsValidator(invalidCharsMsg);
        configureMatchesPatternFormValidator();
        configureFieldTrueValueFormValidator();
        configureSelectFieldFormValidator();
        configurePaypalNonceFormValidator();
        configureVenmoNonceFormValidator();
        configureSepaNameFormValidator();
        configureCVVFormValidator();
    }
}

function updateReviewFormValidator() {
    let $form = $('form#submitorder');
    if($form.length > 0) {
        configureCVVFormValidator();
        showCouponInputForm();
        // Modernized checkout-v2 markup: register validation only, don't validate on load so
        // required-checkbox errors don't show before the user interacts. Legacy layout keeps its
        // original behavior of validating these elements immediately.
        if($form.closest('.checkout-v2').length > 0) {
            $form.validate(getReviewValidationConfiguration());
            return;
        }
        if($('#confirmPlacement').length > 0) {
            validateElement('#confirmPlacement', $form, getReviewValidationConfiguration());
        }
        if($('#acknowledgment').length > 0) {
            validateElement('#acknowledgment', $form, getReviewValidationConfiguration());
        }
        if($('#isBundleReview').length > 0) {
            validateElement('#isBundleReview', $form, getReviewValidationConfiguration());
        }
    }
}

function updateCheckoutDisclaimersFormValidator() {
    let $form = $('form#checkoutDisclaimers');
    if($form.length > 0 && $('#checkout-disclaimers-content').is(':visible')) {
        if($('#agerestricted').length > 0) {
            validateElement('#agerestricted', $form, getDisclaimersValidationConfiguration());
        }
    }
}
function configureInvalidCharsValidator(msg, invalidChars) {
    $.validator.addMethod('checkInvalidChars', function (value, element) {
        let invalidCharsPattern = element.pattern || invalidChars;
        let invalidCharsRegex = new RegExp(invalidCharsPattern, 'g');
        let result = invalidCharsRegex.test(value);
        return this.optional(element) || !result;
    }, function (params, element) {
        let specificMsg = $(element).data('msg-invalidchars');
        return specificMsg || msg;
    });
}

function configureFieldTrueValueFormValidator() {
    $.validator.addMethod('isValueTrue', function (value, element) {
        let isCardPassed = $('#cardPassed').val();
        return isCardPassed === 'true';
    }, function (params, element) {
        diplayErrorMessageForInvalidPaymentDetails();
        return true;
    });
}

function configureMatchesPatternFormValidator() {
    $.validator.addMethod('matchesPattern', function (value, element) {
        const regex = new RegExp(element.pattern);
        const result = regex.test(value);
        const requiredFlag = isRequiredField(this, element);
        return this.optional(element) || !requiredFlag || result;
    }, function (params, element) {
        return $(element).attr('data-msg-required');
    });
}

function configureSelectFieldFormValidator() {
    $.validator.addMethod('hasValidSelection', function (value, element) {
        const requiredFlag = isRequiredField(this, element);
        return this.optional(element) || !requiredFlag || (element.selectedIndex > 0 && value !== 'default');
    }, function (params, element) {
        return $(element).attr('data-msg-required');
    });
}

function configureValidFormatFormValidator() {
    $.validator.addMethod('isFormatValid', function (value, element) {
        const requiredFlag = isRequiredField(this, element);
        const regex = new RegExp(element.pattern);
        const result = regex.test(value);
        return this.optional(element) || !requiredFlag || result;
    }, function (params, element) {
        return $(element).attr('data-msg-format');
    });
}

function diplayErrorMessageForInvalidPaymentDetails(shouldScroll = false) {
    let sectionId = $('#checkout-cart__section');
    let cardPassedError = $('#cardPassed-error');
    if(cardPassedError) {
        cardPassedError.addClass('d-none');
    }
    if(sectionId.length) {
        let errorMsgParent = $(sectionId).find('.checkout-error__message');
        if(errorMsgParent.length) {
            $(errorMsgParent).removeClass('d-none');
        }
    }
    if(shouldScroll) {
        scrollToErrorMessageAndFocus();
    }
}

function configureSepaNameFormValidator() {
    $.validator.addMethod('hasSepaName', function (value, element) {
        let sepaNameHdn = $('#sepaNameHdn').val();
        return !!sepaNameHdn;
    }, function (params, element) {
        diplayErrorMessageForInvalidPaymentDetails();
        return true;
    });
}

function configurePaypalNonceFormValidator() {
    $.validator.addMethod('hasNonce', function (value, element) {
        let nonce = $('#paypalNonce').val();
        return this.optional(element) || (value === 'true' && !!nonce);
    }, function (params, element) {
        diplayErrorMessageForInvalidPaymentDetails();
        return true;
    });
}

function configureVenmoNonceFormValidator() {
    $.validator.addMethod('hasVenmoNonce', function (value, element) {
        let nonce = $('#venmoNonce').val();
        return this.optional(element) || (value === 'true' && !!nonce);
    }, function (params, element) {
        diplayErrorMessageForInvalidPaymentDetails();
        return true;
    });
}

function configureDeliveryInstructionsFormValidator() {
    $.validator.addMethod('hasDeliveryInstructions', function (value, element) {
        // Legacy <input> exposes the regex via `pattern`; modernized <textarea> uses `data-pattern` because HTML5 pattern isn't valid on textarea.
        const patternAttr = element.getAttribute('data-pattern') || element.getAttribute('pattern');
        const cleaned = value && value.trim();
        if(!cleaned || !patternAttr) return true;
        const regex = new RegExp(patternAttr);
        return !regex.test(value);
    }, function (params, element) {
        return $(element).data('msg-format');
    });
}

// Maps the full card type names returned by the payment API (e.g. "Visa", "MasterCard",
// "Master_Card", "Discover", "AMEX", "American_Express", "American Express") to the short
// codes used by the CVV Regular Expression setting ("vi", "mc", "di", "ax").
function normalizeCardTypeToShortCode(cardType) {
    switch (cardType) {
        case 'Visa': return 'vi';
        case 'MasterCard':
        case 'Master_Card': return 'mc';
        case 'Discover': return 'di';
        case 'AMEX':
        case 'American_Express':
        case 'American Express': return 'ax';
        default: return cardType;
    }
}

// Returns true if value matches the CVV Regular Expression entry for the specific cardType
// (e.g. "vi", "mc", "ax", "di", or a full card type name which will be normalized). Mirrors
// legacy's isCVV validator logic exactly, for use post-tokenization on modernized checkout
// once the real card type is known.
function isCvvFormatValidForCardType(value, pattern, cardType) {
    if(!pattern || !cardType) return false;
    let normalizedCardType = normalizeCardTypeToShortCode(cardType);
    let matchedPattern = '';
    pattern.split('|').some(function (regexEntry) {
        let keyValue = regexEntry.split('=');
        if(keyValue.length === 2 && keyValue[0].includes(normalizedCardType)) {
            matchedPattern = keyValue[1];
            return true;
        }
        return false;
    });
    return !!matchedPattern && new RegExp(matchedPattern).test(value);
}

function configureCVVFormValidator() {
    $.validator.addMethod('isCVV', function (value, element) {
        if(element.pattern) {
            let pattern = '';
            let $element = $(element);
            let cardType = $element.data('cardtype');
            if(!cardType) return false;
            let regexEntries = element.pattern.split('|');
            regexEntries.forEach(function (regexEntry) {
                let keyValue = regexEntry.split('=');
                if(keyValue.length === 2) {
                    if(keyValue[0].includes(cardType)) {
                        pattern = keyValue[1];
                    }
                }
            });
            const regex = new RegExp(pattern);
            let result = regex.test(value);
            return this.optional(element) || result;
        }
        return false;
    }, function (params, element) {
        return $(element).attr('data-msg-required');
    });
}

$.validator.addMethod('isValidIban', function (value, element, param) {
    let ibanError = $(element).attr('data-iban-error');
    let currentIban = $(element).val();
    let previousIban = $(element).attr('data-previous-iban');
    let result = false;
    if(ibanError !== undefined && previousIban !== currentIban) {
        result = true;
    }
    if(previousIban === undefined && ibanError === undefined) {
        result = true;
    }
    return this.optional(element) || result;
}, function (params, element) {
    let grandParent = $(element).closest('.form-group.form-group--half');
    grandParent.addClass('pb-3');
    return $(element).data('prev-iban-error-msg');
});

let checkoutNextInFlight = false;

async function checkoutNext() {
    // Guard against duplicate submissions: the modernized shipping page renders two elements
    // matching '.checkout-next' (desktop-ctas and mobile-ctas footers). A programmatic
    // $('.checkout-next').trigger('click') (used by getShippingOptions()/verifyShippingAddress())
    // fires this handler once per matched element, which would otherwise submit CheckoutShipping
    // twice. Ignore any re-entrant invocation while one is already in flight.
    if(checkoutNextInFlight) return;
    checkoutNextInFlight = true;
    try {
        if($('#cart-max-td-error').length > 0 && !$('#cart-max-td-error').hasClass('d-none')) { return; }
        let $this = $(this);
        await validateShippingForm($this);
        if($('#useShippingAddress').length > 0) {
            toggleBillingAddressFormValues();
        }
        await validatePaymentForm($this);
    } finally {
        checkoutNextInFlight = false;
    }
}

async function DiscardSubscription() {
    try {
        hideMainErrorMessage();
        showSpinner('cancelling subscription started');
        let result = await checkoutService.cancelSubscription();

        if(result && result.IsSuccessful && result.RedirectString) {
            window.location.href = result.RedirectString;
        } else {
            hideSpinner('cancelling subscription failed');
            submitFailedCallback(result);
        }
    } catch (e) {
        console.error(e);
    }
}

async function DiscardSetupSubscription() {
    try {
        hideMainErrorMessage();
        showSpinner('cancelling setup subscription started');
        let result = await checkoutService.cancelSetUpSubscription();

        if(result && result.IsSuccessful && result.RedirectString) {
            hideSpinner('cancelling setup subscription succeeded');
            window.location.href = result.RedirectString;
        } else {
            hideSpinner('cancelling setup subscription failed');
            $('.cancelSetUpSubscriptionModalBackdrop').hide();
        }
    } catch (e) {
        console.error(e);
    }
}

async function DiscardChanges() {
    try {
        hideMainErrorMessage();
        showSpinner('discarding changes started');
        let result = await checkoutService.discardChanges();

        if(result && result.IsSuccessful) {
            hideSpinner('discarding changes succeeded');
            // reset subscription context
            // should auto redirect to manage
            let $this = $(this);
            // var manageSubscriptionData = $this.data('shoppingcontextinfo');
            await processManageSubscription($this);
        } else {
            hideSpinner('discarding changes failed');
            submitFailedCallback(result);
        }
    } catch (e) {
        console.error(e);
    }
}

async function SaveChanges() {
    try {
        let $show3ds = $('#hidden-show-3ds').val();
        let $3dsVerified = $('#hidden-3ds-verified').val();
        if($show3ds === 'true' && $3dsVerified === 'false') { // 3DS for today's Cart
            loadIFrame();
        } else {
            hideMainErrorMessage();
            showSpinner('saving changes started');
            let $form = $('form#submitorder');
            if($form.length > 0) {
                let reviewValid = validateForm($form, getReviewValidationConfiguration());
                focusOnAnyErrors();
                if(reviewValid) {
                    let result = await checkoutService.saveChanges($form.serialize());

                    if(result && result.IsSuccessful && result.RedirectString) {
                        $('.changesSavedModal').show();
                        saveChangesRedirectUrl = result.RedirectString;
                    } else {
                        if($3dsVerified !== undefined) { $('#hidden-3ds-verified').val('false'); }
                        submitFailedCallback(result);
                    }
                }
            }
            hideSpinner('saving changes completed');
        }
    } catch (e) {
        console.error(e);
        hideSpinner('saving changes failed');
    }
}

function updateShippingOptions(data) {
    if(data) {
        if(data.ShippingOptionsList) {
            let selectedShippingMethod = syncShippingMethodSelection() || '';
            clearShippingOptions();
            let $shippingOptions = $('#shippingOption');
            let isModernizedCheckout = $('.checkout-v2').length > 0;
            let freeShippingText = $shippingOptions.data('free-shipping-text') || '';
            let oneOption = data.ShippingOptionsList.length === 1;
            let defaultSelected = false;
            let selectedShippingMethodId = selectedShippingMethod.split('|')[0];
            let selectedMethodIsAvailable = data.ShippingOptionsList.some(function (shippingOption) {
                return shippingOption.Id === selectedShippingMethodId;
            });
            let selectedShippingMethodIdToApply = selectedMethodIsAvailable
                ? selectedShippingMethodId
                : data.CartShippingMethodId;
            let isaDeliveryShippingMethods = getIsaDeliveryShippingOptions();
            $.each(data.ShippingOptionsList, function (key, value) {
                let $option = $('<option></option>');
                $option.prop('value', `${value.Id}|${value.ServiceName}|${value.ServiceDisplayName}|${value.ShippingCharge}`);
                if(isModernizedCheckout) {
                    // Modernized radio list reads text() as the plain name and data-price separately.
                    let priceDisplay = value.ShippingCharge > 0 ? value.ShippingChargeForDisplay : freeShippingText;
                    $option.text(value.ServiceDisplayName).data('price', priceDisplay);
                } else {
                    $option.text(value.DisplayName);
                }
                if(oneOption || (selectedShippingMethodIdToApply && selectedShippingMethodIdToApply === value.Id)) {
                    $option.prop('selected', true);
                    defaultSelected = true;
                }
                let isaDeliveryMethod = isaDeliveryShippingMethods.find(sm => sm === value.Id);
                if(isaDeliveryMethod) {
                    $option.data('isadelivery', true);
                    if($('#shippingType').val() === SHIPPING_TYPE_PICKUP) $option.prop('selected', true);
                } else {
                    $option.data('isadelivery', false);
                }
                $shippingOptions.append($option);
            });
            if(defaultSelected) {
                $shippingOptions.valid();
            }
            $shippingOptions.trigger('change');
            if(oneOption) {
                $shippingOptions.prop('disabled', true);
            } else {
                $shippingOptions.prop('disabled', false);
            }
            $('.checkout-v2 .mod-checkout__delivery-instructions').toggleClass('d-none', data.ShippingOptionsList.length === 0);
        }
        updateCoolerSection(data);
    }
}

function updateCoolerSection(data) {
    if(data.ShowCoolerInformation) {
        $('.checkout__cooler-text--note').text(data.Cooler.CoolerNoteDisplay);
        $('.checkout__cooler-text--delivery').text(data.Cooler.CoolerDeliveryInstructionDisplay);
        let $coolerList = $('.checkout__cooler-list');
        $coolerList.empty();
        data.Cooler.Cartlines.forEach(function (item) {
            let $listItem = $('<li></li>');
            $listItem.text(`- ${item.ProductName}`);
            $coolerList.append($listItem);
        });
    } else {
        $('.checkout__cooler-list').empty();
        $('.checkout__cooler-text--note').text('');
        $('.checkout__cooler-text--delivery').text('');
    }
}

function getIsaDeliveryShippingOptions() {
    let $isaDeliveryShippingMethods = $('#isaDeliveryShippingMethods');
    if($isaDeliveryShippingMethods.length > 0) {
        let data = $isaDeliveryShippingMethods.val();
        if(data) {
            return data.toString().split('|');
        }
    }
    return [];
}

const toggleSubscriptionOrderFormBlock = (mode = 'show') => {
    const $SubscriptionOrderFormBlock = $('.subscription-order-form-label');
    if(mode === 'show') {
        // the <hr> here shares the .mod-billing-address__divider class with the Billing
        // Address divider, so other payment-method flows can leave a stale inline
        // display:none on it via .hide() - removeClass alone can't clear that, so also
        // reset the inline display.
        $SubscriptionOrderFormBlock.removeClass('d-none').css('display', '');
    } else {
        $SubscriptionOrderFormBlock.addClass('d-none');
    }
};

function showHideCheckoutDisclaimers() {
    let $disclaimers = $('#checkout-disclaimers-content');
    if($('#ageRestrictedCheckSubscription').val() === '1' ||
        $('#ageRestrictedCheck').val() === '1') {
        $disclaimers.removeClass('d-none');
    } else {
        $disclaimers.addClass('d-none');
    }
}

function showHideIsaDelivery() {
    let $option = $('#shippingOption option:selected');
    let $modernizedIsaDeliveryAlerts = $('.checkout-v2 [data-isa-delivery-alert="true"]');
    let $legacyIsaDeliveryText = $('.checkout__isadelivery-text--note').filter(function () {
        return !$(this).closest('.checkout-v2').length;
    });
    if($option.length < 1) {
        $modernizedIsaDeliveryAlerts.addClass('d-none');
        $legacyIsaDeliveryText.hide();
        return;
    }
    let isIsaDeliveryOption = $option.data('isadelivery') === true || $option.attr('data-isadelivery') === 'true';
    if(isIsaDeliveryOption) {
        $legacyIsaDeliveryText.show();
        $modernizedIsaDeliveryAlerts.removeClass('d-none');
    } else {
        $legacyIsaDeliveryText.hide();
        $modernizedIsaDeliveryAlerts.addClass('d-none');
    }
}

function clearShippingOptions(clearSelectedShippingMethod) {
    $('#shippingOption option:gt(0)').remove();
    $('.checkout-v2 #shippingOption').removeClass('error');
    $('.checkout-v2 #shippingOption-error').remove();
    $('.checkout-v2 .mod-checkout__delivery-instructions').addClass('d-none');
    if(!$('.checkout-v2').length) return;

    if(clearSelectedShippingMethod) {
        $('#selectedShippingMethod').val('');
    }
    var $shippingMethodList = $('#shippingMethodRadioList');
    if($shippingMethodList.length && $shippingMethodList.is('ul')) {
        var placeholder = $('form#shipping').data('shipping-method-placeholder') || '';
        $shippingMethodList.replaceWith('<p class="mod-checkout__shipping-placeholder" id="shippingMethodRadioList">' + $('<div>').text(placeholder).html() + '</p>');
    }
}

function shippingOptionChanged() {
    let $this = $(this);
    $('#selectedShippingMethod').val($this.val());
    showHideIsaDelivery();
}

function pickupOptionChanged() {
    let $this = $(this);
    var $selectedOption = $this.find('option:selected');
    if($selectedOption && $selectedOption.length > 0) { $('.pickupAddressHtml').html($selectedOption.data('pickupaddress')); }
}

async function getShippingOptions() {
    try {
        let hasStateValue = true;
        if($('#stateInput').length > 0) {
            let $stateInputValue = $('#stateInput').val();
            hasStateValue = $stateInputValue && $stateInputValue !== 'default';
        }

        let hasAddress2Value = (isRequireddAddressLine(2) && $('#address2Input').val()) || true;
        let hasAddress4Value = (isRequireddAddressLine(4) && $('#address4Input').val()) || true;
        let hasRequiredValues = $('#cityInput').val() && hasStateValue && $('#address1Input').val() &&
            hasAddress2Value && hasAddress4Value && $('#zipCodeInput').val();
        if(!hasRequiredValues) return;
        let $form = $('form#shipping');
        showSpinner('loading shipping options started');
        let formSerialize = $form.serialize();
        // -- Disabling the inputs to eliminate redundent API calls
        const FORM_INPUT = '.form-input';
        $(FORM_INPUT).attr('disabled', 'disabled');
        let result = await checkoutService.getShippingOptions(formSerialize);
        // -- Enabling again the inputs
        $(FORM_INPUT).removeAttr('disabled');
        let $checkoutErrorText = $('.checkout-error__text');
        let isModernized = $('.checkout-v2').length > 0;
        if(result && result.IsSuccessful) {
            updateShippingOptions(result);
            if(melissa.sameAddress) {
                // Consume the flag so later, unrelated getShippingOptions() calls (e.g. from
                // field blur/change handlers) don't keep re-triggering an automatic submission.
                melissa.sameAddress = false;
                $('.checkout-next').trigger('click');
            }
            if(isModernized) {
                // hide the whole error container, not just its body, so it doesn't linger empty
                $('.checkout-v2 .checkout-error__msg').addClass('d-none');
                $checkoutErrorText.html('');
            } else {
                $checkoutErrorText.parent().addClass('d-none');
                $checkoutErrorText.html('');
            }
            hideSpinner('loading shipping options completed');
        } else {
            clearShippingOptions();
            hideSpinner('loading shipping options failed');
        }
        if(result && result.Messages) {
            let msgText;
            let msgs = result.Messages.filter(msg => msg.DisplayMessage === true);
            if(msgs && msgs.length > 0) {
                msgs.forEach(function (item) {
                    if(msgText) {
                        msgText = msgText + ` <span> ${item.MessageText} </span>`;
                    } else {
                        msgText = item.MessageText;
                    }
                });
                if(msgText) {
                    $checkoutErrorText.html(msgText);
                }
            }
            if($checkoutErrorText.text()) {
                $checkoutErrorText.parent().removeClass('d-none');
                if(isModernized) {
                    // modernized markup nests the text in .mod-error__body inside .checkout-error__msg
                    $checkoutErrorText.closest('.checkout-error__msg').removeClass('d-none');
                }
                $checkoutErrorText.siblings('button').addClass('is--error');
            }
            focusOnAnyErrorsOnPage();
            console.dir(result);
        }
    } catch (e) {
        console.error(e);
    }
}

async function getPaymetricParams() {
    try {
        let $paymetricData = $('#paymetricdata');
        let requested = $paymetricData.data('requested');
        if(!requested) return;
        let hasInlinePaymetricSection = $('#paymetric-inline-section').length > 0;
        let shouldUseModernizedEndpoint = $('.checkout-v2').length > 0 && hasInlinePaymetricSection;
        let result = shouldUseModernizedEndpoint
            ? await checkoutService.getPaymetricParametersModernized()
            : await checkoutService.getPaymetricParameters();

        // Some checkout-v2 pages still use the legacy modal flow.
        // If the modernized endpoint fails there, recover with legacy params.
        if((!result || !result.IsSuccessful) && shouldUseModernizedEndpoint) {
            result = await checkoutService.getPaymetricParameters();
        }

        if(result && result.IsSuccessful) {
            setPaymetricIframeSource(result.PaymetricUrl);
        } else {
            handlePaymetricIframeLoadFailure('session-init-failed');
            console.dir(result);
        }
    } catch (e) {
        handlePaymetricIframeLoadFailure('session-init-exception');
        console.error(e);
    }
}

async function getPaymentDetails(skipCvvReveal = false, skipIframeRefresh = false) {
    try {
        let $paymetricData = $('#paymetricdata');
        let expirationLabel = $paymetricData.data('cardexpiration');
        showSpinner('loading payment details started');
        let result = await checkoutService.getPaymentDetails();
        if(result && result.IsSuccessful) {
            hideSpinner('loading payment details completed');
            setCardInfo(result, expirationLabel, !skipCvvReveal);
            $('.form-block--cc-info').removeClass('d-none');
            if(!skipIframeRefresh) {
                getPaymetricParams();
            }
        } else {
            hideSpinner('loading payment details failed');
            console.dir(result);
        }
        return result;
    } catch (e) {
        console.error(e);
        hideSpinner('loading payment details failed');
    }
}

function setCardInfo(result, expLabel, checkCVV, selectedPaymentData) {
    let expMonth = result.ExpirationMonth < 10 ? '0' + result.ExpirationMonth : result.ExpirationMonth;
    if(result.CardLastDigits.length > 4) {
        $('.cc-masked').text(`${result.CardLastDigits}`);
    } else {
        $('.cc-masked').text(`•••• •••• •••• ${result.CardLastDigits}`);
    }
    $('.cc-expiry').text(` ${expLabel} ${expMonth}/${result.ExpirationYear}`);
    setCardTypeLogo(result.CardType);
    if(checkCVV) {
        if(!selectedPaymentData) {
            displayAndEnableCVV(result);
        }
        updatePaymentCTA({ show3DS: true });
    }
}

function displayAndEnableCVV(data) {
    // In modernized checkout, CVV is handled inside the inline add-card section only.
    if($('.checkout-v2').length > 0) return;
    $('.checkout-error__message').addClass('d-none');
    $('#verifyCVV').data('cardtype', data.CardType);
    $('.verify-cvv-container').addClass('d-flex').show();
}

function isSavedCreditCardContext() {
    const paymentType = $(FORM_PAYMENT).data('payment-type');
    if(paymentType !== PAYMENT_METHOD_CC) {
        return false;
    }

    const hasSavedBillingInformation = $('#savedBillingInformation:visible').length > 0;
    const hasSavedCreditCardSelection = isSavedCreditCardSelected();
    const savedCreditCardId = ($('#savedCCId').val() || '').toString();
    const paymentHandleId = ($('#paymentHandleId').val() || '').toString();

    return hasSavedBillingInformation || hasSavedCreditCardSelection || savedCreditCardId.length > 0 || paymentHandleId.length > 0;
}

function isSavedCreditCardImageSrc(imageSrc) {
    if(!imageSrc || typeof imageSrc !== 'string') {
        return false;
    }

    const normalizedImageSrc = imageSrc.toLowerCase();
    return !normalizedImageSrc.includes('paypal') &&
        !normalizedImageSrc.includes('venmo') &&
        !normalizedImageSrc.includes('sepa') &&
        !normalizedImageSrc.includes('ideal');
}

function isSavedCreditCardSelected() {
    const $savedPayment = $('#savedPayment');
    if(!$savedPayment.length) {
        return false;
    }

    const selectedValue = $('.dd-selected-value').val() || $savedPayment.val();
    if(!selectedValue || selectedValue === 'default') {
        return false;
    }

    const selectedImageSrc = $('.dd-selected-image').prop('src') ||
        $savedPayment.find('option:selected').data('imagesrc');

    return isSavedCreditCardImageSrc(selectedImageSrc);
}

function clearAndHideCVV() {
    $('#verifyCVV').val('');
    $('.verify-cvv-container').hide().removeClass('d-flex');
}

// Hides the CVV container WITHOUT clearing #verifyCVV's value. Used after a
// successful modernized inline add-card tokenization: the member already typed
// their CVV into #verifyCVV as part of the inline add-card form, and that value
// must survive (hidden, not re-shown) so it's still serialized/POSTed with
// form#payment - otherwise the server never stores a CVV in session and the
// Review page's DisplayCvv flag stays true, forcing a second CVV entry.
function hideCvvContainerPreservingValue() {
    $('.verify-cvv-container').hide().removeClass('d-flex');
}

function syncCvvVisibilityForSavedCardContext() {
    if($('.checkout-v2').length > 0) return;

    if($('#savedBillingInformation:visible').length > 0) {
        clearAndHideCVV();
    }
}

function initCvvOnPaymentLoad() {
    // Preserve legacy behavior: do not auto-show CVV on payment page load.
    // CVV should appear only as part of the explicit add-new-card flow.
    if($('.checkout-v2').length > 0) return;

    clearAndHideCVV();
    syncCvvVisibilityForSavedCardContext();
}

function updatePaymentCTA(options) {
    let isManageAutoship = $('#isManageAutoship').val();
    if(isManageAutoship && isManageAutoship.toLowerCase() === 'true' && $('#paymentChanged').val() === 'true') {
        let $nextBtn = $('.checkout-next');
        $nextBtn.text($nextBtn.data('savetext'));
        if(options && options.show3DS) {
            $('#hidden-show-3ds').val('true');
        } else {
            $('#hidden-show-3ds').val('false');
        }
    }
}

function setCardTypeLogo(type) {
    let cardType = type;

    if(cardType === 'MasterCard') {
        cardType = 'mc';
    }
    if(cardType === 'Visa') {
        cardType = 'vi';
    }

    let path = '';
    switch (cardType) {
        case 'mc': path = '/assets/images/icons/payment/mastercard.svg'; break;
        case 'vi': path = '/assets/images/icons/payment/visa.svg'; break;
        case 'ax': path = '/assets/images/icons/payment/amex.svg'; break;
        case 'di': path = '/assets/images/icons/payment/discover.svg'; break;
    }
    let $cardTypeImage = $('.checkout__payment-card');
    if(cardType.length > 2) {
        $cardTypeImage.prop('src', cardType);
        return;
    }
    $cardTypeImage.prop('src', path);
}

function validatePaymentDetailsElement(selector, config) {
    let $form = $('form#payment');
    if($form.length > 0) {
        return validateElement(selector, $form, config);
    }
}

function trackPaymetricInlineLifecycle(eventName, metadata = {}) {
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: eventName,
            paymentProvider: 'Paymetric',
            paymentRenderMode: 'inline',
            ...metadata
        });
    } catch (e) {
        console.error(e);
    }
}

function clearPaymetricIframeLoadTimeout() {
    if(paymetricIframeLoadTimeoutId) {
        clearTimeout(paymetricIframeLoadTimeoutId);
        paymetricIframeLoadTimeoutId = null;
    }
}

function togglePaymetricInlineLoader(isVisible) {
    const $loader = $('#paymetric-inline-loader');
    if(!$loader.length) return;

    $loader.toggleClass('d-none', !isVisible);
}

function isPaymetricMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
}

function clearPaymetricInlineError() {
    $('#div-paymetric-error-msg').removeClass('is--active');
    $('#spnErrorMessage').text('');
    $('.payment-message-text').text('');
    $('#verifyCVV-inline-error').remove();
    $('#verifyCVV').parent().removeClass('is--error');
    $('.btn-retry-paymetric').addClass('d-none');
}

function toggleInlineCvvContainer(isInline, clearValue = true) {
    const $cvvContainer = $('.verify-cvv-container');
    if(!$cvvContainer.length) return;

    if(isInline) {
        const $inlineSlot = $('#paymetric-inline-cvv-slot');
        if($inlineSlot.length) {
            $inlineSlot.append($cvvContainer);
        }
        $cvvContainer.addClass('d-flex').show();
    } else {
        const $defaultSlot = $('#verify-cvv-default-slot');
        if($defaultSlot.length) {
            $defaultSlot.after($cvvContainer);
        }
        if(clearValue) {
            clearAndHideCVV();
        } else {
            $('#verifyCVV-inline-error').remove();
            $('#verifyCVV').parent().removeClass('is--error');
        }
    }
}

function validatePaymentDetailsBeforeAddCard() {
    const $form = $(FORM_PAYMENT);
    if(!$form.length) return false;

    const originalSavedBillingInformationState = isSavedBillingInformation;
    const hasSavedPaymentContext = !!paymetricPreviousSavedPaymentId || isSavedCreditCardContext();
    const isBillingInformationHidden = $('#billingInformation').length > 0 && !$('#billingInformation').is(':visible');
    if(hasSavedPaymentContext) {
        isSavedBillingInformation = true;
    }

    const validationConfig = getPaymentValidationConfiguration();
    if(validationConfig && validationConfig.rules) {
        delete validationConfig.rules.cardPassed;
        delete validationConfig.rules.verifyCVV;
    }
    if(validationConfig && validationConfig.messages) {
        delete validationConfig.messages.verifyCVV;
    }
    if(isBillingInformationHidden && validationConfig && validationConfig.rules) {
        delete validationConfig.rules.firstNameBilling;
        delete validationConfig.rules.lastNameBilling;
        delete validationConfig.rules.cityInput;
        delete validationConfig.rules.stateInput;
        delete validationConfig.rules.address1Input;
        delete validationConfig.rules.address4Input;
        delete validationConfig.rules.zipCodeInput;
    }

    const paymentValid = validateForm($form, validationConfig);
    isSavedBillingInformation = originalSavedBillingInformationState;

    const cardPassedError = $('#cardPassed-error');
    if(cardPassedError) {
        cardPassedError.addClass('d-none');
    }

    if(!paymentValid) {
        $('.btn-add-card').prop('disabled', false);
        postPaymentSubmitCheck();
        $('html, body').animate({
            scrollTop: $('.cart-checkout__section').offset().top
        }, 800);
    }

    return paymentValid;
}

function restorePreviousSavedPaymentSelection() {
    if(!paymetricPreviousSavedPaymentId) {
        return false;
    }

    const $savedPayment = $('#savedPayment');
    if(!$savedPayment.length) {
        return false;
    }

    const restoreIndex = $savedPayment.find(`option[value="${paymetricPreviousSavedPaymentId}"]`).index();
    if(restoreIndex < 0) {
        return false;
    }

    $savedPayment.ddslick('select', { index: restoreIndex });
    setTimeout(function() {
        handleSavedPaymentChange($.Event('click'));
    }, 0);
    paymetricPreviousSavedPaymentId = null;
    return true;
}

function setCheckoutNextEnabledForPaymetric(isEnabled) {
    const $checkoutNext = $('.checkout-next');
    if(!$checkoutNext.length) return;

    const paymentType = $(FORM_PAYMENT).data('payment-type');
    const isInlineSectionVisible = $('#paymetric-inline-section').is(':visible');
    if(paymentType === PAYMENT_METHOD_CC || isInlineSectionVisible) {
        $checkoutNext.prop('disabled', !isEnabled);
    }
}

function handlePaymetricIframeLoadFailure(reason) {
    const isInlineFlowActive = $('#paymetric-inline-section').is(':visible');
    const isLegacyModalActive = $('#ccModal').is(':visible') || $('#ccModal').hasClass('show');

    clearPaymetricIframeLoadTimeout();
    togglePaymetricInlineLoader(false);
    $('.btn-add-card').prop('disabled', true);

    // Do not block checkout or show processor errors unless add-card flow is active.
    if(!isInlineFlowActive && !isLegacyModalActive) {
        return;
    }

    setCheckoutNextEnabledForPaymetric(false);

    const paymetricErrorMessage = $('#PaymentPaymetricErrorMessage').val();
    $('#div-paymetric-error-msg').addClass('is--active');
    $('#spnErrorMessage').text(paymetricErrorMessage);

    trackPaymetricInlineLifecycle('paymetric_iframe_load_failed', { reason: reason, attempt: paymetricIframeRetryCount + 1 });

    if(paymetricIframeRetryCount < PAYMETRIC_IFRAME_MAX_RETRIES) {
        paymetricIframeRetryCount += 1;
        trackPaymetricInlineLifecycle('paymetric_iframe_retrying', { attempt: paymetricIframeRetryCount, reason: reason });
        getPaymetricParams();
        return;
    }

    $('.btn-retry-paymetric').removeClass('d-none');
}

function setPaymetricIframeSource(url, reason = 'session-refresh') {
    const $iframe = $('#iPaymetric');
    if(!$iframe.length || !url) {
        handlePaymetricIframeLoadFailure('missing-iframe-url');
        return;
    }

    clearPaymetricInlineError();
    togglePaymetricInlineLoader(true);
    $('.btn-add-card').prop('disabled', true);
    $iframe.data('ready', false);
    $iframe.prop('src', url);

    trackPaymetricInlineLifecycle('paymetric_iframe_src_set', { reason: reason });

    clearPaymetricIframeLoadTimeout();
    paymetricIframeLoadTimeoutId = setTimeout(function() {
        handlePaymetricIframeLoadFailure('load-timeout');
    }, PAYMETRIC_IFRAME_LOAD_TIMEOUT_MS);
}

function onPaymetricIframeLoad() {
    clearPaymetricIframeLoadTimeout();
    togglePaymetricInlineLoader(false);
    $('.btn-add-card').prop('disabled', false);
    $('#iPaymetric').data('ready', true);
    paymetricIframeRetryCount = 0;

    const iframe = document.getElementById('iPaymetric');
    if(iframe) {
        const existingResizeHandler = $('#iPaymetric').data('resizeMessageHandler');
        if(existingResizeHandler) {
            window.removeEventListener('message', existingResizeHandler);
        }

        const resizeMessageHandler = function(event) {
            if(!event.origin.includes('worldpay.com') || event.source !== iframe.contentWindow) return;

            let message = event.data;
            if(typeof message === 'string') {
                try {
                    message = JSON.parse(message);
                } catch (error) {
                    return;
                }
            }

            if(message?.operation !== 'resize' || !message.data?.height) return;

            const reportedHeight = parseInt(message.data.height, 10);
            if(Number.isNaN(reportedHeight)) return;

            const minHeight = isPaymetricMobileViewport()
                ? `${Math.max(440, reportedHeight)}px`
                : `${Math.max(364, reportedHeight)}px`;
            iframe.style.setProperty('min-height', minHeight, 'important');
        };

        window.addEventListener('message', resizeMessageHandler, false);
        $('#iPaymetric').data('resizeMessageHandler', resizeMessageHandler);
    }

    // On mobile: Set the base min-height on initial load
    const isMobile = isPaymetricMobileViewport();
    if(isMobile) {
        const iframe = document.getElementById('iPaymetric');
        if(iframe) {
            iframe.style.setProperty('min-height', '440px', 'important');

            const existingObserver = $('#iPaymetric').data('heightObserver');
            if(existingObserver) {
                existingObserver.disconnect();
                $('#iPaymetric').removeData('heightObserver');
            }
        }
    }

    trackPaymetricInlineLifecycle('paymetric_iframe_ready');
}

function onPaymetricIframeError() {
    handlePaymetricIframeLoadFailure('iframe-error');
}

function setPaymetricIframeErrorMinHeight() {
    const iframe = document.getElementById('iPaymetric');
    if(iframe) {
        const minHeight = isPaymetricMobileViewport() ? '440px' : '426px';
        iframe.style.setProperty('min-height', minHeight, 'important');
    }
}

function resetPaymetricIframeMinHeight() {
    const iframe = document.getElementById('iPaymetric');
    if(iframe) {
        const minHeight = isPaymetricMobileViewport() ? '440px' : '364px';
        iframe.style.setProperty('min-height', minHeight, 'important');
    }
}

function showPaymetricInlineSection() {
    const $section = $('#paymetric-inline-section');
    if(!$section.length) return;

    if($('.checkout-v2').length > 0) {
        $('#saveCc, #savePayment').prop('checked', false);
    }
    clearPaymetricInlineError();
    if($('.checkout-v2').length > 0) {
        $('.paymetric-inline__body').removeClass('is--validating');
    }
    toggleInlineCvvContainer(true);
    $('.payment__providers').hide();
    $('.checkout__payment-block').hide();
    $('.form-block--change-payment').hide();
    $('.mod-payment-selection').hide();
    if($('.checkout-v2').length > 0) {
        $('#divBillingAddress, .mod-billing-address__divider, #divBillingAddressSecurity').hide();
        $('#savedBillingInformation').hide();
    }
    $section.show();
    $('#cardPassed').val(false);
    setCheckoutNextEnabledForPaymetric(false);
    $('#paymetricdata').data('requested', true);
    $('.mod-checkout__footer').not('.paymetric-inline-footer').hide();
    $('.paymetric-inline-footer').removeClass('d-none');
    $('.desktop-ctas').not('.paymetric-inline-footer').addClass('is--hidden-for-inline-card');

    trackPaymetricInlineLifecycle('paymetric_inline_started');
    getPaymetricParams();
}

function hidePaymetricInlineSection(resetCvv = true) {
    $('#paymetric-inline-section').hide();
    toggleInlineCvvContainer(false, resetCvv);
    togglePaymetricInlineLoader(false);
    clearPaymetricIframeLoadTimeout();
    $('.btn-add-card').prop('disabled', false);
    $('.btn-retry-paymetric').addClass('d-none');
    setCheckoutNextEnabledForPaymetric(true);
    $('.mod-checkout__footer').not('.paymetric-inline-footer').show();
    $('.paymetric-inline-footer').addClass('d-none');
    $('.desktop-ctas').not('.paymetric-inline-footer').removeClass('is--hidden-for-inline-card');
}

function cancelPaymetricInlineFlow() {
    hidePaymetricInlineSection(true);
    clearPaymetricInlineError();
    $('#cardPassed').val(false);
    const restoredSavedPayment = restorePreviousSavedPaymentSelection();

    if(!restoredSavedPayment) {
        const hasModernizedSavedPayments = $('.checkout-v2').length > 0 && $('.mod-saved-payments').length > 0;
        // In modernized checkout, restore both saved payments and the card selector.
        if(hasModernizedSavedPayments) {
            $('.payment__providers').hide();
            $('.mod-payment-selection').show();
            $('.mod-payment-method-card').removeClass('is--selected').attr('aria-pressed', 'false');
            $('.mod-saved-payments').show();
            $('.checkout_saved_payments').show();
            $('.checkout_saved_payments_label').show();
            $('.mod-payment-selection__change-wrap').show();
        } else if($('.mod-payment-method-card').length > 0) {
            $('.payment__providers').hide();
            $('.mod-payment-selection').show();
            $('.mod-payment-method-card').removeClass('is--selected').attr('aria-pressed', 'false');
        } else {
            $('.payment__providers').show();
        }
        $('.checkout__payment-block').hide();
        $('.checkout_save_payment').hide();
        $('.form-block--change-payment').hide();
        $('#savedBillingInformation').hide();
        $('#divBillingAddress, .mod-billing-address__divider, #divBillingAddressSecurity').hide();
    } else {
        if(isSavedCreditCardSelected()) {
            clearAndHideCVV();
        } else {
            const cardType = $('#verifyCVV').data('cardtype');
            if(cardType) {
                displayAndEnableCVV({ CardType: cardType });
            }
        }
    }
    updatePaymentContinueButtonVisibility();
    trackPaymetricInlineLifecycle('paymetric_inline_cancelled');
}

function normalizePaymetricSubmitResult(result) {
    if(!result) {
        return null;
    }

    if(typeof result === 'string') {
        try {
            return JSON.parse(result);
        } catch (e) {
            console.error('Failed to parse Paymetric submit result.', e, result);
            return null;
        }
    }

    return result;
}

async function submitPaymentCardSuccess(result, cvvContext) {
    togglePaymetricInlineLoader(false);
    $('.btn-add-card').prop('disabled', false);
    const message = normalizePaymetricSubmitResult(result);
    const hasPassed = !!(message && ((message.data && message.data.HasPassed) || message.HasPassed));
    if(hasPassed) {
        console.log('Card passed.');
        let $paymetricData = $('#paymetricdata');
        $paymetricData.data('requested', true);
        $('#cardPassed').val(true);
        const isModernizedCheckout = $('.checkout-v2').length > 0;
        let alreadyFetchedPaymentDetails = false;
        if(isModernizedCheckout) {
            // Paymetric's own fields (Card Number/Expiration/Name) all passed validation, since
            // tokenization succeeded - safe to restore the CVV slot's full pull-up margin now,
            // regardless of whether our own CVV-cardtype check below still finds an issue (that
            // error renders in its own space, not the one reserved for a Paymetric field error).
            $('.paymetric-inline__body').removeClass('is--validating');
        }
        if(isModernizedCheckout) {
            if(cvvContext) {
                // Card type is only known now (after tokenization, via the server) - enforce
                // the same per-card-type CVV length rule legacy's isCVV validator applies, since
                // displayAndEnableCVV() (which legacy uses to set $('#verifyCVV').data('cardtype')
                // for that shared validator) is a no-op for modernized by design - this is the
                // ONLY CVV/card-type check modernized has, so it must stay. Also covers a blank
                // CVV (isCvvFormatValidForCardType('') is always false), matching legacy's
                // "required" failure showing the same data-msg-required text as a format failure.
                // skipIframeRefresh=true: prevents a fire-and-forget getPaymetricParams() call
                // from refreshing the Paymetric iframe (which clears any inline error via
                // clearPaymetricInlineError()) and wiping out the CVV-mismatch error set below.
                const details = await getPaymentDetails(true, true);
                alreadyFetchedPaymentDetails = true;
                const actualCardType = details && details.CardType;
                if(actualCardType && !isCvvFormatValidForCardType(cvvContext.value, cvvContext.pattern, actualCardType)) {
                    $('#cardPassed').val(false);
                    setCheckoutNextEnabledForPaymetric(false);
                    // The card is ALREADY tokenized/saved at this point - only the CVV needs
                    // correcting, which is a field on our own page, not inside Paymetric's
                    // iframe. Remember the confirmed card type so a correction can be
                    // re-validated locally without resubmitting to Paymetric's single-use
                    // session (which would otherwise fail with a generic "already submitted"
                    // processor error).
                    $('#verifyCVV').data('confirmed-cardtype', actualCardType).data('confirmed-pattern', cvvContext.pattern);
                    const $cvv = $('#verifyCVV');
                    $cvv.parent().addClass('is--error');
                    let $cvvError = $('#verifyCVV-inline-error');
                    if(!$cvvError.length) {
                        $cvvError = $('<span class="error" id="verifyCVV-inline-error"></span>');
                        $cvv.parent().after($cvvError);
                    }
                    $cvvError.text($cvv.attr('data-msg-required') || 'A valid 3-4 digit CVV is required');
                    trackPaymetricInlineLifecycle('paymetric_tokenized_failed', { reason: 'cvv-cardtype-mismatch' });
                    return;
                }
            }
            hidePaymetricInlineSection(false);
            hideCvvContainerPreservingValue();
        } else {
            $('#ccModal').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
            displayAndEnableCVV({ CardType: $('#verifyCVV').data('cardtype') || '' });
        }
        finalizeCardAddSuccess(alreadyFetchedPaymentDetails);
    } else {
        $('#cardPassed').val(false);
        setCheckoutNextEnabledForPaymetric(false);
        setPaymetricIframeErrorMinHeight();
        validatePaymentDetailsElement('#cardPassed', getPaymentValidationConfiguration());
        var errorMsg = $('#paymetricdata').data('errormsg') || ($('.checkout-v2').length > 0 ? $('#PaymentPaymetricErrorMessage').val() : '');
        $('#spnErrorMessage').text(errorMsg);
        $('#div-paymetric-error-msg').addClass('is--active');
        trackPaymetricInlineLifecycle('paymetric_tokenized_failed', { reason: 'validation-failed' });
    }
}

// Shared tail of a successful Add New Card flow - called both right after Paymetric
// tokenizes/passes CVV validation on the first attempt, and after a corrected CVV is
// re-validated locally (see addPaymentCard()'s confirmed-cardtype branch) once the card was
// already tokenized on an earlier attempt.
function finalizeCardAddSuccess(alreadyFetchedPaymentDetails) {
    resetPaymetricIframeMinHeight();
    setCheckoutNextEnabledForPaymetric(true);
    validatePaymentDetailsElement('#cardPassed', getPaymentValidationConfiguration());
    if(!alreadyFetchedPaymentDetails) {
        getPaymentDetails();
    }
    showPaymentMethod('payment-cc');
    $(FORM_PAYMENT).data('payment-type', PAYMENT_METHOD_CC);
    if($('.checkout-v2').length > 0 && isPaymentManageAutoship()) {
        $('#paymentChanged').val('true');
        updatePaymentCTA({ show3DS: false });
    }
    trackPaymetricInlineLifecycle('paymetric_tokenized_success');
    isSavedBillingInformation = false;
    $('#savedBillingInformation').hide();
    // A brand-new card was just tokenized (not a saved payment) - the billing address
    // form fields are shown, so the security notice belongs here again in case a saved
    // payment selection had previously hidden it (see handleSavedPaymentChange()).
    $('#divBillingAddressSecurity').removeClass('d-none').show();
    if($('#isOrderNonShippable').val() !== 'true' || window.isUserAuthenticated) {
        if($('#billingInformation').length) {
            let isPickupDelivery = $('#billingInformation').data('is-pick-up') === 'True';
            if(!isPickupDelivery) {
                $('#useShippingAddressLabel').parent().parent().removeClass('d-none');
            } else {
                $('#billingInformation').show();
            }
        }

        let address = $('#shippingInformation').data('shippingaddress');
        if(!address.IsPickupDeliveryMethod) {
            $(SHIPPING_INFO).show();
            // pickup shipping option requires billing address.
            // should not use same address as pickup
            $('#useShippingAddress').prop('checked', true);
            $('#billingInformation').hide();
        }
    }
    $('#securityOnlineMessage').show();
    $('#securityOnlineMessage').removeClass('d-none');
    toggleSubscriptionOrderFormBlock('show');
}

function submitPaymentCardFailed(result) {
    togglePaymetricInlineLoader(false);
    $('.btn-add-card').prop('disabled', false);
    setPaymetricIframeErrorMinHeight();
    if($('.checkout-v2').length > 0) {
        setCheckoutNextEnabledForPaymetric(false);
    }
    console.dir(result);
    let $msg = $('#spnErrorMessage');
    $('#div-paymetric-error-msg').addClass('is--active');
    let paymetricErrorMessage = $('#PaymentPaymetricErrorMessage').val();
    $msg.text(paymetricErrorMessage);
    trackPaymetricInlineLifecycle('paymetric_tokenized_failed', { reason: 'iframe-submit-error' });
}

function addPaymentCard() {
    const $iframe = $('#iPaymetric');
    const src = $iframe.prop('src');
    const id = $iframe.prop('id');
    const isModernizedCheckout = $('.checkout-v2').length > 0;
    if(isModernizedCheckout) {
        // If the card was ALREADY tokenized by Paymetric and only flagged for a CVV/card-type
        // mismatch (see submitPaymentCardSuccess()), the card itself doesn't need resubmitting -
        // Paymetric's session is single-use and would reject a second submission with a
        // generic "already submitted" error. Just re-validate the corrected CVV locally against
        // the already-confirmed card type and finish the flow without contacting Paymetric again.
        const $cvv = $('#verifyCVV');
        const confirmedCardType = $cvv.data('confirmed-cardtype');
        if(confirmedCardType) {
            const cvvVal = ($cvv.val() || '').trim();
            const cvvPattern = $cvv.data('confirmed-pattern');
            if(cvvVal && isCvvFormatValidForCardType(cvvVal, cvvPattern, confirmedCardType)) {
                $cvv.parent().removeClass('is--error');
                $('#verifyCVV-inline-error').remove();
                $cvv.removeData('confirmed-cardtype').removeData('confirmed-pattern');
                $('#cardPassed').val(true);
                hidePaymetricInlineSection(false);
                hideCvvContainerPreservingValue();
                finalizeCardAddSuccess(true);
            } else {
                $cvv.parent().addClass('is--error');
                let $cvvError = $('#verifyCVV-inline-error');
                if(!$cvvError.length) {
                    $cvvError = $('<span class="error" id="verifyCVV-inline-error"></span>');
                    $cvv.parent().after($cvvError);
                }
                $cvvError.text($cvv.attr('data-msg-required') || 'A valid 3-4 digit CVV is required');
            }
            return;
        }
    }
    if($iframe.length > 0) {
        // On modernized checkout, skip billing-address validation here — that runs on the
        // main Continue button. The inline section only needs to tokenize the card.
        if(!isModernizedCheckout && !validatePaymentDetailsBeforeAddCard()) {
            setCheckoutNextEnabledForPaymetric(false);
            return;
        }

        if(isModernizedCheckout && !$iframe.data('ready')) {
            const paymetricErrorMessage = $('#PaymentPaymetricErrorMessage').val() || $('#paymetricdata').data('errormsg');
            $('#div-paymetric-error-msg').addClass('is--active');
            $('#spnErrorMessage').text(paymetricErrorMessage);
            togglePaymetricInlineLoader(false);
            $('.btn-add-card').prop('disabled', false);
            return;
        }

        if(isModernizedCheckout) {
            // Show "required" immediately on the FIRST submit attempt if CVV is blank, rather
            // than waiting for Paymetric's own fields to pass first (which would only surface
            // this in submitPaymentCardSuccess() post-tokenization). Does NOT return/skip the
            // submit below - Paymetric's own fields (Card Number/Expiration/Name) still need
            // that submit call to show THEIR OWN "Required" errors for whichever of them are
            // also empty, so all empty fields (CVV + Paymetric's) surface together.
            const $cvvPreCheck = $('#verifyCVV');
            if(!($cvvPreCheck.val() || '').trim()) {
                $cvvPreCheck.parent().addClass('is--error');
                let $cvvError = $('#verifyCVV-inline-error');
                if(!$cvvError.length) {
                    $cvvError = $('<span class="error" id="verifyCVV-inline-error"></span>');
                    $cvvPreCheck.parent().after($cvvError);
                }
                $cvvError.text($cvvPreCheck.attr('data-msg-required') || 'A valid 3-4 digit CVV is required');
            }
        }

        togglePaymetricInlineLoader(true);
        $('.btn-add-card').prop('disabled', true);
        if(isModernizedCheckout) {
            // Cancel the CVV slot's pull-up margin for this submit attempt - the only moment
            // Paymetric's cross-origin iframe could reveal an inline field error (e.g. Name on
            // Card) that would otherwise visually overlap the CVV field below it.
            $('.paymetric-inline__body').addClass('is--validating');
            // Match legacy exactly: no client-side CVV format pre-check here - legacy's own
            // validatePaymentDetailsBeforeAddCard() explicitly excludes the CVV rule too and
            // always submits, letting Paymetric/the post-tokenization card-type check below be
            // the only source of CVV validation errors.
            const $cvv = $('#verifyCVV');
            const cvvVal = ($cvv.val() || '').trim();
            const cvvPattern = $cvv.attr('pattern');
            let paymetricSubmitCallbackFired = false;
            const paymetricSubmitTimeoutId = setTimeout(function() {
                if(!paymetricSubmitCallbackFired) {
                    // Paymetric showed its own inline field validation without calling our
                    // callback — just re-enable the button; height is already expanded above.
                    togglePaymetricInlineLoader(false);
                    $('.btn-add-card').prop('disabled', false);
                }
            }, 8000);
            const wrappedSuccess = (result) => {
                paymetricSubmitCallbackFired = true;
                clearTimeout(paymetricSubmitTimeoutId);
                submitPaymentCardSuccess(result, { value: cvvVal, pattern: cvvPattern });
            };
            const wrappedError = (result) => {
                paymetricSubmitCallbackFired = true;
                clearTimeout(paymetricSubmitTimeoutId);
                submitPaymentCardFailed(result);
            };
            $XIFrame.submit({//eslint-disable-line
                iFrameId: id,
                targetUrl: src,
                onSuccess: wrappedSuccess,
                onError: wrappedError
            });
        } else {
            $XIFrame.submit({//eslint-disable-line
                iFrameId: id,
                targetUrl: src,
                onSuccess: submitPaymentCardSuccess,
                onError: submitPaymentCardFailed
            });
        }
    }
}

function onCreditCardButtonClick() {
    const $selectedSavedPayment = $('.dd-selected-value');
    paymetricPreviousSavedPaymentId = $selectedSavedPayment.length ? $selectedSavedPayment.val() : null;
    if(paymetricPreviousSavedPaymentId === 'default') {
        paymetricPreviousSavedPaymentId = null;
    }

    clearCreditCard();
    hideMainPaymentErrorMessage();
    hideMainErrorMessage();
    $(FORM_PAYMENT).data('payment-type', PAYMENT_METHOD_CC);

    const hasInlinePaymetricSection = $('#paymetric-inline-section').length > 0;
    if(hasInlinePaymetricSection) {
        showPaymetricInlineSection();
    } else if($('#ccModal').length) {
        $('#paymetricdata').data('requested', true);
        getPaymetricParams();
        $('#ccModal').modal('show');
    }
}

function initPaypal() {
    if(!window.braintree) {
        return;
    }
    let braintreeClient = braintree.client; // eslint-disable-line
    if(braintreeClient === undefined) {
        return;
    }

    let hdnIsAutoship = $('#hdnIsAutoship').val();
    let isAutoship = hdnIsAutoship && hdnIsAutoship === 'true';
    let isSubscription = $('#orderFlow').val() === 'New Member Rewards';
    let paypalToken = $('.payment-paypal-token').data('token');
    let paypalSubToken = $('.payment-paypal-token').data('subscription-token');
    if(!isAutoship) {
        if(!paypalToken) return;

        braintree.client.create({ // eslint-disable-line
            authorization: isSubscription ? paypalSubToken : paypalToken
        }, function (clientErr, clientInstance) {
            if(clientErr) {
                console.error('Error creating client:', clientErr);
                checkoutService.getBraintreeToken(isSubscription).then(token => {
                    console.log(token);
                    reCreateBraintreeClient(token);
                });
                return;
            }

            createPaypalCheckout(clientInstance);
        });
    } else {
        paypalVaultFlow();
    }
}

function initVenmo() {
    // Check for the Venmo lib and button container before initializing Venmo. If the container is not found, skip Venmo initialization.
    let $venmoContainer = $('#venmo-button-container');
    if(!window.braintree || !braintree.venmo || $venmoContainer.length === 0) { // eslint-disable-line
        return;
    }

    // Mirror PayPal token/mode selection logic exactly:
    // - isAutoship  → manage-autoship flow    → multi_use token,  multi_use usage
    // - isSubscription (NMR) → subscription  → sub token,        multi_use usage
    // - standard checkout                    → regular token,    single_use usage
    let isAutoship = $('#hdnIsAutoship').val() === 'true';
    let isSubscription = $('#orderFlow').val() === 'New Member Rewards';
    let venmoToken = $('.payment-venmo-token').data('token');
    let venmoSubToken = $('.payment-venmo-token').data('subscription-token');

    venmoToken = isSubscription ? venmoSubToken : venmoToken;
    if(!venmoToken) {
        return;
    }

    // enable multi-use save payment flow for Venmo just in case the user will be opting in to save payment method
    // this needs to be done ahead of time because Venmo needs to be initialized with the correct paymentMethodUsage, and
    // unfortunately, the UI only has the Save Payment checkbox after the Venmo payment is authorized, so we need to pass
    // this information to the Venmo SDK before the user authorizes the payment and even before the users uses the Save Payment checkbox.
    // This is a limitation of the Venmo SDK and a difference from the PayPal SDK
    let isSavePaymentEnabledFlow = $('.checkout_save_payment').data('savepayment') === 'True';
    let paymentMethodUsage = (isAutoship || isSubscription || isSavePaymentEnabledFlow) ? 'multi_use' : 'single_use';

    braintree.client.create({ // eslint-disable-line
        authorization: venmoToken
    }, function (clientErr, clientInstance) {
        if(clientErr) {
            console.error('Venmo: Braintree client creation failed:', clientErr);
            return;
        }

        let cartTotal = parseFloat($('#hdn-pp-amount').val()) || 0;

        braintree.venmo.create({ // eslint-disable-line
            client: clientInstance,
            collectCustomerBillingAddress: true,
            collectCustomerShippingAddress: true,
            allowDesktop: true, // QR code flow — do NOT set allowDesktopWebLogin here
            mobileWebFallBack: true,
            paymentMethodUsage: paymentMethodUsage, // mirrors PayPal: multi_use for autoship/NMR, single_use otherwise
            totalAmount: cartTotal.toFixed(2)
        }, function (venmoErr, venmoInstance) {
            if(venmoErr) {
                console.warn('Venmo init failed:', venmoErr.message);
                $('#paymentChanged').val('false');
                return;
            }

            let isVenmoSupported = venmoInstance.isBrowserSupported();
            if(!isVenmoSupported) {
                return;
            }

            // show venmo button container since its supported and venmoInstance is created successfully
            $venmoContainer.show();

            // Handle returning from Venmo app after mobile app-switch
            if(venmoInstance.hasTokenizationResult()) {
                venmoInstance.tokenize(function (tokenizeErr, payload) {
                    if(tokenizeErr && tokenizeErr.code !== 'VENMO_CANCELED' && tokenizeErr.code !== 'VENMO_APP_CANCELED') {
                        console.error('Venmo tokenize error:', tokenizeErr);
                        $('#paymentChanged').val('false');
                    }
                });
                return;
            }

            $('#venmo-button').on('click', function () {
                let $btn = $(this);
                $btn.prop('disabled', true);

                venmoInstance.tokenize(function (tokenizeErr, payload) {
                    $btn.prop('disabled', false);
                    if(tokenizeErr) {
                        if(tokenizeErr.code !== 'VENMO_CANCELED' && tokenizeErr.code !== 'VENMO_APP_CANCELED') {
                            console.error('Venmo tokenize error:', tokenizeErr);
                            $('#paymentChanged').val('false');
                        }
                        return;
                    }
                    console.log('venmo payload:', payload);

                    if(payload) {
                        venmoTokenizedPayment(payload, false);
                        $('#paymentChanged').val('true');
                        console.log('venmoData', venmoData);
                    }
                });
            });
        });
    });
}

function convertCountryCodeToAlpha2(countryCode) {
    const countryCodeMap = {
        'USA': 'US'
    };

    return countryCodeMap[countryCode] || countryCode;
}

function updateVenmoData(payload, isReturningCustomer) {
    venmoData.nonce = payload.nonce;
    venmoData.type = payload.type;
    venmoData.username = payload.details.username;
    venmoData.email = payload.details.payerInfo.email;
    venmoData.firstName = payload.details.payerInfo.firstName;
    venmoData.lastName = payload.details.payerInfo.lastName;
    venmoData.phoneNumber = payload.details.payerInfo.phoneNumber;
    venmoData.isReturningCustomer = isReturningCustomer;

    // if venmo billing address is available, use it. Otherwise, use shipping address as billing address.
    let billingAddress = payload.details.payerInfo.billingAddress;
    if(billingAddress) {
        venmoData.line1 = billingAddress.addressLine1;
        venmoData.line2 = billingAddress.addressLine2;
        venmoData.postalCode = billingAddress.postalCode;

        // Convert Venmo's adminArea1 and adminArea2 to city and state respectively
        // Venmo sandbox app returns adminArea1 as city and adminArea2 as state,
        // but production app returns them in reverse order. So we need to handle both cases.
        // testing shows that this is not based on merchant id and env settings

        // only sandbox app returns this username, so we can use it to determine if it's a sandbox app or not.
        // we cannot use fake nonce since its the same for both apps as long as env is set to sandbox.
        const sandboxAppUserName = '@test-venmo-username';
        let isSandboxApp = payload.details.username === sandboxAppUserName;

        if(isSandboxApp) {
            venmoData.city = billingAddress.adminArea1;
            venmoData.state = billingAddress.adminArea2;
        } else {
            venmoData.city = billingAddress.adminArea2;
            venmoData.state = billingAddress.adminArea1;
        }

        // Convert country code to alpha-2 format if necessary
        venmoData.countryCode = convertCountryCodeToAlpha2(billingAddress.countryCode);

        console.log('Venmo billing address available, using it as billing address.');
    } else {
        billingAddress = $('#shippingInformation').data('shippingaddress');

        venmoData.line1 = billingAddress.Address1;
        venmoData.line2 = billingAddress.Address2;
        venmoData.city = billingAddress.City;
        venmoData.state = billingAddress.StateCode;
        venmoData.postalCode = billingAddress.ZipCode;
        venmoData.countryCode = billingAddress.CountryCode;

        console.log('Venmo billing address not available, using shipping address as billing address.');
    }

    console.log('Venmo data updated:', venmoData);
}

function reCreateBraintreeClient(paypalToken) {
    braintree.client.create({ // eslint-disable-line
        authorization: paypalToken
    }, function (clientErr, clientInstance) {
        if(clientErr) {
            console.error('Error creating client:', clientErr);
            return;
        }
        createPaypalCheckout(clientInstance);
    });
}

function createPaypalCheckout(clientInstance) {
    const isreturningcustomer = ($('.payment-paypal-token').data('returningcustomer')).toLowerCase() === 'true';
    const isPayIn4Enabled = $('#hdn-pay-in-4').val();

    let create = {
        client: clientInstance
    };

    if(isreturningcustomer) {
        create.autoSetDataUserIdToken = true;
    }

    braintree.paypalCheckout.create(create, function (paypalCheckoutErr, paypalCheckoutInstance) {// eslint-disable-line
        let currencycode = $('#shippingInformation').data('currencycode');
        if(!currencycode) { currencycode = $('.payment-paypal-token').data('currencycode'); }
        paypalCheckoutInstance.loadPayPalSDK({
            components: 'buttons,messages',
            dataAttributes: {
                'data-page-type': 'product-details'
            },
            currency: currencycode,
            commit: 'false'
        }
        , function () {
                renderPaypalButton(paypal, paypalCheckoutInstance, currencycode, paypal.FUNDING.PAYPAL); // eslint-disable-line
            // Also render a transparent overlay button directly inside the PayPal card
            // so clicking the card opens PayPal with one click (mouse users).
            if($('#paypal-card-overlay').length) {
                renderPaypalButton(paypal, paypalCheckoutInstance, currencycode, paypal.FUNDING.PAYPAL, '#paypal-card-overlay'); // eslint-disable-line
            }
            if(isPayIn4Enabled && isPayIn4Enabled === 'true') {
                $('#paypal-button').css('height', '110px');
                    renderPaypalButton(paypal, paypalCheckoutInstance, currencycode, paypal.FUNDING.PAYLATER); // eslint-disable-line
            }
        }
        );
    });
}
function errorMessageWidth() {
    let $nextButton = $('.checkout__footer .checkout-next');
    if($nextButton) {
        var width = $nextButton.outerWidth();
        if(width) {
            $('.all-flow-checkout .cart-max-threshold-error').css('width', width + 'px');
        }
    }
}

function loadDeviceData() {
    if(!window.braintree) {
        return;
    }
    let braintreeClient = braintree.client; // eslint-disable-line
    if(braintreeClient === undefined) {
        return;
    }

    var paypalToken = $('.payment-paypal-token').data('token');
    if(paypalToken) {
        braintree.client.create({ // eslint-disable-line
            authorization: paypalToken
        }, function (clientErr, clientInstance) {
            braintree.dataCollector.create({ // eslint-disable-line
                client: clientInstance
            }, function (err, dataCollectorInstance) {
                if(err) {
                    console.log(err);
                    return;
                }
                $('#deviceData').val(dataCollectorInstance.deviceData);
            });
        });
    }

    let $btPaymentToken = $('.bt-payment-token');
    if(!$btPaymentToken || $btPaymentToken.length === 0) {
        // possible on review page with express checkout
        $btPaymentToken = $('.bt-payment-token-review');
        if(!$btPaymentToken || $btPaymentToken.length === 0) return;
    }

    let btToken = $btPaymentToken.data('token');
    if(!btToken) return;

    braintree.client.create({ // eslint-disable-line
        authorization: btToken
    }, function (clientErr, clientInstance) {
        braintree.dataCollector.create({ // eslint-disable-line
            client: clientInstance
        }, function (err, dataCollectorInstance) {
            if(err) {
                console.log(err);
                return;
            }
            $('#paymentDeviceData').val(dataCollectorInstance.deviceData);
            var $isReviewPage = $('#isReviewPage');
            if($isReviewPage && $isReviewPage.length >= 1) {
                var val = $isReviewPage.val();
                if(val && val.toLowerCase() === 'true') {
                    $('#deviceData').val(dataCollectorInstance.deviceData);
                }
            }
        });
    });
}

function paypalVaultFlow() {
    let paypalToken = $('.payment-paypal-token').data('token');
    if(!paypalToken) return;

    braintree.client.create({ // eslint-disable-line
        authorization: paypalToken
    }, function (clientErr, clientInstance) {
        if(clientErr) {
            console.error('Error creating client:', clientErr);
            return;
        }
        braintree.paypalCheckout.create({ // eslint-disable-line
            client: clientInstance
        }, function (paypalCheckoutErr, paypalCheckoutInstance) {
            paypalCheckoutInstance.loadPayPalSDK({
                components: 'buttons,messages',
                vault: true
            }, function () {
                const renderVaultButton = target => paypal.Buttons({ // eslint-disable-line
                    fundingSource: paypal.FUNDING.PAYPAL, // eslint-disable-line
                    style: {
                        color: 'white',
                        shape: 'rect',
                        height: 50
                    },
                    createBillingAgreement: function () {
                        let address = $('#shippingInformation').data('shippingaddress');
                        let shipAddressOverride;
                        if(address) {
                            shipAddressOverride = {
                                recipientName: `${address.FirstName} ${address.LastName}`,
                                line1: address.Address1,
                                line2: address.Address2,
                                city: address.City,
                                countryCode: address.CountryCode,
                                postalCode: address.ZipCode,
                                state: address.StateCode,
                                phone: address.PhoneNumber
                            };
                        }
                        return paypalCheckoutInstance.createPayment({
                            flow: 'vault',
                            billingAgreementDescription: 'Your agreement description',
                            enableShippingAddress: true,
                            shippingAddressEditable: false,
                            shippingAddressOverride: shipAddressOverride
                        });
                    },
                    onApprove: function (data, actions) {
                        $('#paymentChanged').val('true');
                        $('.checkout-error__message').addClass('d-none');
                        updatePaymentCTA({ show3DS: false });
                        return paypalCheckoutInstance.tokenizePayment(data, function (err, payload) { // eslint-disable-line
                            console.log('Paypal Payload :', payload);
                            paypalTokenizedPayment(payload);
                        });
                    },
                    onCancel: function (data) {
                        console.log('PayPal payment canceled', JSON.stringify(data, 0, 2));
                        clearSepaData(true);
                        clearBancontact();
                        clearIdealData();
                        $('#paymentChanged').val('false');
                    },
                    onError: function (err) {
                        console.error('PayPal error', err);
                        clearSepaData(true);
                        clearBancontact();
                        clearIdealData();
                        $('#paymentChanged').val('false');
                    }
                }).render(target).then(function () { });

                renderVaultButton('#paypal-button');
                if($('#paypal-card-overlay').length) {
                    renderVaultButton('#paypal-card-overlay');
                }
            });
        });
    });
}

function renderPaypalButton(paypal, paypalCheckoutInstance, currencycode, fundingSource, renderTarget) {
    let target = renderTarget || '#paypal-button';
    let style = {
        color: 'white',
        shape: 'rect',
        height: 50
    };

    const isreturningcustomer = ($('.payment-paypal-token').data('returningcustomer')).toLowerCase() === 'true';
    paypal.Buttons({ // eslint-disable-line
        fundingSource: fundingSource, // eslint-disable-line
        style: style,
        createOrder: function () {
            // When triggered via the card overlay, mark the PayPal card as selected
            if(target === '#paypal-card-overlay') {
                $('.mod-payment-method-card').removeClass('is--selected').attr('aria-pressed', 'false');
                $('.mod-payment-method-card[data-payment-method="paypal"]').addClass('is--selected').attr('aria-pressed', 'true');
                $(FORM_PAYMENT).data('payment-type', PAYMENT_METHOD_PAYPAL);
                updatePaymentContinueButtonVisibility();
            }
            let address = $('#shippingInformation').data('shippingaddress');
            let carttotal = parseFloat($('#hdn-pp-amount').val()) || 0;

            let shipAddressOverride;
            if(address) {
                shipAddressOverride = {
                    recipientName: `${address.FirstName} ${address.LastName}`,
                    line1: address.Address1,
                    line2: address.Address2,
                    city: address.City,
                    countryCode: address.CountryCode,
                    postalCode: address.ZipCode,
                    state: address.StateCode,
                    phone: address.PhoneNumber
                };
            }

            let createPayment = {
                flow: 'checkout',
                amount: carttotal.toFixed(2),
                currency: currencycode,
                enableShippingAddress: !(isreturningcustomer),
                shippingAddressEditable: false
            };

            if(!isreturningcustomer) {
                createPayment.requestBillingAgreement = true;
                createPayment.shippingAddressOverride = shipAddressOverride;
                createPayment.billingAgreementDetails = {
                    description: 'Description of the billng agreement to display to the customer'
                };
            }

            console.log(createPayment);
            uncheckUseSamePaymentCheckboxOnTodaysPayment('paypal-button');
            return paypalCheckoutInstance.createPayment(createPayment);
        },
        onApprove: function (data, actions) {
            if($('.checkout-error__message').length) {
                $('.checkout-error__message').addClass('d-none');
            }
            updatePaymentCTA({ show3DS: false });
            return paypalCheckoutInstance.tokenizePayment(data, function (err, payload) { // eslint-disable-line
                paypalTokenizedPayment(payload, isreturningcustomer);
            });
        },
        onCancel: function (data) {
            console.log('PayPal payment canceled', JSON.stringify(data, 0, 2));
            if(target === '#paypal-card-overlay') {
                $('.mod-payment-method-card[data-payment-method="paypal"]').removeClass('is--selected').attr('aria-pressed', 'false');
                updatePaymentContinueButtonVisibility();
            }
            clearSepaData(true);
            clearBancontact();
            clearIdealData();
        },
        onError: function (err) {
            console.error('PayPal error', err);
            if(target === '#paypal-card-overlay') {
                $('.mod-payment-method-card[data-payment-method="paypal"]').removeClass('is--selected').attr('aria-pressed', 'false');
                updatePaymentContinueButtonVisibility();
            }
            clearSepaData(true);
            clearBancontact();
            clearIdealData();
        }
    }).render(target).then(function () {
        if(target === '#paypal-card-overlay') {
            scalePaypalOverlayButtonToFillCard();
        }
    }).catch(function(e) {
        console.warn('PayPal button render failed for', target, ':', e);
    });
}

// PayPal's SDK always renders its actual clickable button graphic at the small height
// requested via the `style.height` render option (here 50px), regardless of how big the
// surrounding iframe element's CSS box is stretched to - so simply CSS-stretching the iframe
// to fill the picker card (as the overlay CSS does) only creates blank, non-clickable space
// around a small button, which is why only the area near the PayPal icon was clickable.
// `zoom` (unlike `transform: scale`) enlarges the button's actual rendered/hit-tested content
// while staying on the same input-coordinate-mapping path browsers use for real page zoom
// (which must work correctly for touch) - `transform: scale` on an ancestor of this
// cross-origin iframe was confirmed to break touch delivery into it entirely on mobile, so
// `zoom` is used here instead to keep full-card clicking working on both mouse and touch.
function scalePaypalOverlayButtonToFillCard() {
    const $overlay = $('#paypal-card-overlay');
    const $buttons = $overlay.find('.paypal-buttons').first();
    if(!$overlay.length || !$buttons.length) return;
    const overlayHeight = $overlay.height();
    const overlayWidth = $overlay.width();
    const buttonHeight = $buttons.height();
    if(!overlayHeight || !buttonHeight || overlayHeight <= buttonHeight) return;
    const scale = overlayHeight / buttonHeight;
    // `zoom` scales width and height uniformly, but .paypal-buttons is already CSS-stretched
    // to the overlay's full width - pre-shrink its width so the post-zoom result lands back
    // at the overlay's actual width instead of overshooting it.
    $buttons.css({
        width: (overlayWidth / scale) + 'px',
        zoom: scale
    });
}

function updatePaypalData(payload, isReturningCustomer) {
    paypalData.nonce = payload.nonce;
    paypalData.email = payload.details.email;
    paypalData.firstName = payload.details.firstName;
    paypalData.lastName = payload.details.lastName;
    paypalData.line1 = payload.details.billingAddress.line1;
    paypalData.line2 = payload.details.billingAddress.line2;
    paypalData.city = payload.details.billingAddress.city;
    paypalData.state = payload.details.billingAddress.state;
    paypalData.postalCode = payload.details.billingAddress.postalCode;
    paypalData.countryCode = payload.details.billingAddress.countryCode;
    paypalData.isReturningCustomer = isReturningCustomer;
}

function updateWithSavedPaypalData(data) {
    paypalData.firstName = data.FirstName;
    paypalData.lastName = data.LastName;
    paypalData.line1 = data.Address1;
    paypalData.line2 = data.Address2;
    paypalData.city = data.City;
    paypalData.state = data.StateCode;
    paypalData.postalCode = data.ZipCode;
    paypalData.countryCode = data.CountryCode;
}

function updateWithSavedVenmoData(data) {
    venmoData.firstName = data.FirstName;
    venmoData.lastName = data.LastName;
    venmoData.line1 = data.Address1;
    venmoData.line2 = data.Address2;
    venmoData.city = data.City;
    venmoData.state = data.StateCode;
    venmoData.postalCode = data.ZipCode;
    venmoData.countryCode = data.CountryCode;
}

async function checkout(payload, isReturningCustomer) {
    showSpinner('checkout started');
    try {
        let $this = $(this); //eslint-disable-line
        let couponCode = ''; //eslint-disable-line
        let isNoPaymentRequired = false; //eslint-disable-line

        let $isNoPaymentRequired = $('#isNoPaymentRequired');

        if($isNoPaymentRequired.length > 0) {
            isNoPaymentRequired = $isNoPaymentRequired.val();
        }

        if($this.data('nopaymentrequiredcouponcode')) {
            couponCode = $this.data('nopaymentrequiredcouponcode');
        }

        let contextItemId = $('#hidden-contextItem-id').val();
        let datasourceItemId = $('#hidden-datasource-id').val();

        let request = {
            CouponCode: couponCode,
            IsNoPaymentRequired: isNoPaymentRequired,
            ContextItemId: contextItemId,
            DatasourceItemId: datasourceItemId,
            IsReturningCustomer: isReturningCustomer
        };

        if(payload && payload.details) {
            request.Nonce = payload.nonce;
            request.Details = payload.details;
        }

        // subscription Setup
        let $nextSubscriptionDate = $('#subscription-order-datepicker');
        if($nextSubscriptionDate.length > 0) {
            let date = $nextSubscriptionDate.val();
            let format = $nextSubscriptionDate.attr('placeholder');
            request.NextSubscriptionDate = getDateFormatted(date, format);
        }
        let $frequency = $('#frequency');
        if($frequency.length > 0) {
            request.Frequency = $frequency.val();
        }

        let result = await cartService.startCheckout(request);
        if(result.IsSuccessful) {
            if(couponCode) {
                // remove no payment required widget
                $('.promo-caboSession').remove();
            }
            if(result.ShowMessageModal) {
                let modalData = $('.checkout').data('modal');
                modalData.title = result.Messages[1].MessageText;
                modalData.content = result.Messages[0].MessageText;
                modalData.hideCloseButton = true;

                modalUtil.showError(result, modalData, () => {
                    window.location = result.CheckoutNextPageUrl;
                });
            } else {
                window.location = result.Data;
            }
            hideSpinner('checkout succeeded');
        } else {
            hideSpinner('checkout failed');
        }
    } catch (ex) {
        console.error(ex);
        hideSpinner('checkout failed');
    }
}

function paypalTokenizedPayment(payload, isReturningCustomer) {
    let $cart = $('.cart');
    if($cart.length > 0) {
        checkout(payload, isReturningCustomer);
        return;
    }
    updatePaypalData(payload, isReturningCustomer);
    $('#paypalAuth').val(true);
    $('#paypalNonce').val(payload.nonce);
    $('#paypalEmail').val(payload.details.email);
    $('.paypal-masked-address').text(maskEmail(payload.details.email));
    $('.payment__providers').hide();
    clearVenmoData();
    clearSepaData(true);
    clearBancontact();
    clearIdealData();
    clearIsaWallet();
    $('.payment-cc').addClass('d-none');
    $('.form-block--paypal-info').removeClass('d-none').show();
    if(allFlowIsEnabled) toggleSubscriptionOrderFormBlock('show');
    $('.form-block--change-payment').show();
    revealPaypalSummaryModernized();
    isSavedBillingInformation = false;
    $('#savedBillingInformation').hide();
    $(SHIPPING_INFO).show();
    $('#useShippingAddressLabel').parent().parent().removeClass('d-none');
    $('#useShippingAddress').prop('checked', false);

    $(FORM_PAYMENT).data('payment-type', PAYMENT_METHOD_PAYPAL);

    let valid = validatePaymentDetailsElement('#paypalAuth', getPaypalPaymentValidationConfiguration());
    if(valid) {
        hidePaypalInformationMessage();
        const $savedPayment = $('.checkout_save_payment');
        if($savedPayment.data('issubscription').toString() === 'false') {
            $savedPayment.show();
        }
        $('.checkout_saved_payments').hide();
        $('.checkout_saved_payments_label').hide();
        $('.mod-saved-payments').hide();
    } else {
        showPaypalInformationAsValidationMessage();
        $('.checkout_save_payment').hide();
    }
}

function venmoTokenizedPayment(payload, isReturningCustomer) {
    let $cart = $('.cart');
    if($cart.length > 0) {
        checkout(payload, isReturningCustomer);
        return;
    }
    updateVenmoData(payload, isReturningCustomer);
    $('#venmoAuth').val(true);
    $('#venmoNonce').val(payload.nonce);
    $('#venmoUsername').val(payload.details.username);
    $('#venmoEmail').val(payload.details.payerInfo.email);
    $('.venmo-username').text(payload.details.username);
    $('.payment__providers').hide();
    clearPaypalData();
    clearSepaData(true);
    clearBancontact();
    clearIdealData();
    clearIsaWallet();
    $('.payment-cc').addClass('d-none');
    $('.form-block--venmo-info').removeClass('d-none').show();
    if(allFlowIsEnabled) toggleSubscriptionOrderFormBlock('show');
    $('.form-block--change-payment').show();
    revealVenmoSummaryModernized();
    isSavedBillingInformation = false;
    $('#savedBillingInformation').hide();
    $(SHIPPING_INFO).show();
    $('#useShippingAddressLabel').parent().parent().removeClass('d-none');
    $('#useShippingAddress').prop('checked', false);

    $(FORM_PAYMENT).data('payment-type', PAYMENT_METHOD_VENMO);

    let valid = validatePaymentDetailsElement('#venmoAuth', getVenmoPaymentValidationConfiguration());
    if(valid) {
        hideVenmoInformationMessage();
        const $savedPayment = $('.checkout_save_payment');
        if($savedPayment?.data('issubscription')?.toString() === 'false') {
            $savedPayment.show();
        }
        $('.checkout_saved_payments').hide();
        $('.checkout_saved_payments_label').hide();
        $('.mod-saved-payments').hide();
    } else {
        showVenmoInformationAsValidationMessage();
        $('.checkout_save_payment').hide();
    }
}

function onSepaButtonClick() {
    $('.form-block--sepa-info').removeClass('d-none').show();
    $('#divBillingAddress, .mod-billing-address__divider, #divBillingAddressSecurity').removeClass('d-none').show();
    clearBancontact();
    clearIdealData();
    clearIsaWallet();
    isSavedBillingInformation = false;
    $('#savedBillingInformation').hide();
    $(SHIPPING_INFO).show();
    $('#useShippingAddressLabel').parent().parent().removeClass('d-none');
    $('#useShippingAddress').prop('checked', true).trigger('change');
    $('.checkout__shipping-information').show();
    if($('.checkout_save_payment').data('issubscription')) {
        $('.checkout_save_payment').hide();
    } else {
        $('.checkout_save_payment').show();
    }
    $(FORM_PAYMENT).data('payment-type', PAYMENT_METHOD_SEPA);
    $('.checkout-error__message').addClass('d-none');
    updatePaymentCTA({ show3DS: false });
    uncheckUseSamePaymentCheckboxOnTodaysPayment('btn-sepa');
    if(allFlowIsEnabled) {
        $('.payment__providers').hide();
        $('.form-block--change-payment').show();
        $(`.form-block--sepa-info hr.sepa--divider, .form-block--sepa-info br`).hide();
        toggleSubscriptionOrderFormBlock('show');
    }
}

function onIsawalletButtonClick() {
    $('.payment__providers').hide();
    $('.payment-cc').addClass('d-none');
    $('.form-block--isawllet-info').removeClass('d-none').show();
    isSavedBillingInformation = false;
    $('#savedBillingInformation').hide();
    $(SHIPPING_INFO).show();
    clearSepaData(true);
    clearBancontact();
    clearIdealData();
    $('#useShippingAddressLabel').parent().parent().removeClass('d-none');
    $('#useShippingAddress').prop('checked', false);

    if($(FORM_PAYMENT).data('payment-type') !== 'isawallet') {
        $('#paymentChanged').val('true');
    }
    $('.checkout-error__message').addClass('d-none');
    $(FORM_PAYMENT).data('payment-type', ISAWALLET);
    $('#isIsawallet').val('true');
    $('.form-block--change-payment').show();
    $('.checkout_saved_payments').hide();
    $('.checkout_saved_payments_label').hide();
    $('.mod-saved-payments').hide();
    $('.checkout_save_payment').show();
    updatePaymentCTA({ show3DS: false });
    uncheckUseSamePaymentCheckboxOnTodaysPayment('btn-isawallet');
}

function onDebitcardButtonClick() {
    $('.payment__providers').hide();
    $('.payment-cc').addClass('d-none');
    $('.form-block--debitcard-info').removeClass('d-none').show();
    isSavedBillingInformation = false;
    $('#savedBillingInformation').hide();
    $(SHIPPING_INFO).show();
    clearSepaData(true);
    clearBancontact();
    clearIdealData();
    $('#debitcardPayment').val('true');
    $('#useShippingAddressLabel').parent().parent().removeClass('d-none');
    $('#useShippingAddress').prop('checked', false);

    $(FORM_PAYMENT).data('payment-type', DEBIT_CARD);
    $('#isIsawallet').val('false');
    $('#cashPayment').val('false');
    $('.form-block--change-payment').show();
    $('.checkout_saved_payments').hide();
    $('.checkout_saved_payments_label').hide();
    $('.mod-saved-payments').hide();
    uncheckUseSamePaymentCheckboxOnTodaysPayment('btn-debitcard');
}

function onCashButtonClick() {
    $('.payment__providers').hide();
    $('.payment-cc').addClass('d-none');
    $('.form-block--cash-info').removeClass('d-none').show();
    isSavedBillingInformation = false;
    $('#savedBillingInformation').hide();
    $(SHIPPING_INFO).show();
    clearSepaData(true);
    clearBancontact();
    clearIdealData();
    $('#cashPayment').val('true');
    $('#debitcardPayment').val('false');
    $('#useShippingAddressLabel').parent().parent().removeClass('d-none');
    $('#useShippingAddress').prop('checked', true).trigger('change');

    $(FORM_PAYMENT).data('payment-type', CASH);
    $('#isIsawallet').val('false');
    $('.form-block--change-payment').show();
    $('.checkout_saved_payments').hide();
    $('.checkout_saved_payments_label').hide();
    $('.mod-saved-payments').hide();
    uncheckUseSamePaymentCheckboxOnTodaysPayment('btn-cash');
}

function onBancontactButtonClick() {
    $('.payment-cc').addClass('d-none');
    $('.form-block--sepa-info').removeClass('d-none').show();
    clearSepaData(true);
    clearIdealData();
    clearIsaWallet();
    $('.form-block--bancontact').removeClass('d-none').show();
    $('.form-block--bancontact-info').removeClass('d-none').show();
    isSavedBillingInformation = false;
    $('#savedBillingInformation').hide();
    $(SHIPPING_INFO).show();
    $('#useShippingAddressLabel').parent().parent().removeClass('d-none');
    $('#useShippingAddress').prop('checked', false);

    $(FORM_PAYMENT).data('payment-type', BANCONTACT);
    $('#isBancontact').val('true');
    $('.checkout_saved_payments').hide();
    $('.checkout_saved_payments_label').hide();
    $('.mod-saved-payments').hide();
    uncheckUseSamePaymentCheckboxOnTodaysPayment('btn-bancontact');
    if(allFlowIsEnabled) {
        $('.payment__providers').hide();
        $('.form-block--change-payment').show();
        if(!$('.subscription-order-form-label').hasClass('d-none')) {
            toggleSubscriptionOrderFormBlock('hide');
        }
    }
}

function onIDealButtonClick() {
    $('.form-block--ideal-info').removeClass('d-none').show();
    clearBancontact();
    clearSepaData(true);
    clearIsaWallet();
    isSavedBillingInformation = false;
    $('#savedBillingInformation').hide();
    $(SHIPPING_INFO).show();
    $('#useShippingAddressLabel').parent().parent().removeClass('d-none');
    $('#useShippingAddress').prop('checked', false);
    $('.checkout_save_payment').hide();
    if($(FORM_PAYMENT).data('payment-type') !== IDEAL) {
        $('#paymentChanged').val('true');
    }
    $(FORM_PAYMENT).data('payment-type', IDEAL);
    updatePaymentCTA({ show3DS: false });
    $('.checkout-error__message').addClass('d-none');
    uncheckUseSamePaymentCheckboxOnTodaysPayment('btn-ideal');
    if(allFlowIsEnabled) {
        $('.payment__providers').hide();
        $('.form-block--change-payment').show();
        toggleSubscriptionOrderFormBlock('show');
    }
}

function checkPaypalPayment() {
    if(!!paypalData.nonce || $('#paypalNonce').val()) {
        updateBillingFormWithData(paypalData);
    }
}

function checkVenmoPayment() {
    if(!!venmoData.nonce || $('#venmoNonce').val()) {
        updateBillingFormWithData(venmoData);
    }
}

function updateBillingFormWithData(data) {
    let billingAddressData;
    billingAddressData = paypalData;

    if(data) {
        billingAddressData = data;
    }

    $('#firstNameBilling').val(billingAddressData.firstName);
    $('#lastNameBilling').val(billingAddressData.lastName);
    $('#address1Input').val(billingAddressData.line1);
    $('#cityInput').val(billingAddressData.city);
    $('#countryBilling').val(billingAddressData.countryCode);
    $('#stateInput').val(billingAddressData.state);
    $('#selectedState').val(billingAddressData.state);
    $('#zipCodeInput').val(billingAddressData.postalCode);
    if (!!billingAddressData.line2) {//eslint-disable-line
        $('#loadAddress2').val(billingAddressData.line2);
        loadAddress();
    }
}

function loadPaypalData() {
    let $paypalData = $('#loadPaypalData');
    if($paypalData.length > 0) {
        paypalData.firstName = $paypalData.data('firstname');
        paypalData.lastName = $paypalData.data('lastname');
        paypalData.line1 = $paypalData.data('address1');
        paypalData.line2 = $paypalData.data('address2');
        paypalData.city = $paypalData.data('city');
        paypalData.state = $paypalData.data('state');
        paypalData.postalCode = $paypalData.data('postalcode');
        paypalData.countryCode = $paypalData.data('countrycode');
    }
}

function loadVenmoData() {
    let $paypalData = $('#loadVenmoData');
    if($paypalData.length > 0) {
        venmoData.firstName = $paypalData.data('firstname');
        venmoData.lastName = $paypalData.data('lastname');
        venmoData.line1 = $paypalData.data('address1');
        venmoData.line2 = $paypalData.data('address2');
        venmoData.city = $paypalData.data('city');
        venmoData.state = $paypalData.data('state');
        venmoData.postalCode = $paypalData.data('postalcode');
        venmoData.countryCode = $paypalData.data('countrycode');
    }
}

function clearPaypalData() {
    paypalData = {};
    $('#paypalNonce').val('');
    $('#paypalEmail').val('');
    let $paypalInfo = $('.form-block--paypal-info');
    if(!$paypalInfo.hasClass('d-none')) {
        $paypalInfo.addClass('d-none');
    }
}

function clearVenmoData() {
    venmoData = {};
    $('#venmoNonce').val('');
    $('#venmoUsername').val('');
    $('#venmoEmail').val('');
    let $venmoInfo = $('.form-block--venmo-info');
    if(!$venmoInfo.hasClass('d-none')) {
        $venmoInfo.addClass('d-none');
    }
}

function clearCreditCard() {
    $('#cardPassed').val('');
    isSavedBillingInformation = false;
    if($('#savedCCId').length) {
        $('#savedCCId').val('');
    }
    hidePaymetricInlineSection();
    clearPaymetricInlineError();
    $('#securityOnlineMessage').hide();
}

function clearSepaData(clearUI) {
    let sepaNameInput = $('#sepaName');
    sepaNameInput.val('');
    sepaNameInput.trigger('input');
    let ibanInput = $('#iban');
    ibanInput.val('');
    ibanInput.trigger('input');
    $('#sepaNameHdn').val('');
    $('#sepaAgreement').prop('checked', false);
    if($('#selectedSepaId').length) {
        $('#selectedSepaId').val('');
    }
    isSavedBillingInformation = false;
    let $savedSepaInfo = $('.form-block--saved-sepa-info');
    if(!$savedSepaInfo.hasClass('d-none')) {
        $savedSepaInfo.addClass('d-none');
    }
    let $sepaInfo = $('.form-block--sepa-info');
    if(!$sepaInfo.hasClass('d-none')) {
        $sepaInfo.addClass('d-none');
    }
    if(clearUI) {
        $('.checkout_save_payment').hide();
        $('.form-block--change-payment').hide();
        if(!$('#divBillingAddress').hasClass('d-none')) {
            $('#divBillingAddress, .mod-billing-address__divider, #divBillingAddressSecurity').addClass('d-none');
        }
    }
}

function clearIdealData() {
    $('#isIDeal').val('false');
    let $savedIdealInfo = $('.form-block--saved-ideal-info');
    if(!$savedIdealInfo.hasClass('d-none')) {
        $savedIdealInfo.addClass('d-none');
    }
    let $idealInfo = $('.form-block--ideal-info');
    if(!$idealInfo.hasClass('d-none')) {
        $idealInfo.addClass('d-none');
    }
}

function clearBancontact() {
    $('#isBancontact').val('false');
    let $bancontactInfo = $('.form-block--bancontact-info');
    if(!$bancontactInfo.hasClass('d-none')) {
        $bancontactInfo.addClass('d-none');
    }
}

function clearIsaWallet() {
    $('#isIsawallet').val('false');
    if($('#selectedIsawalletId').length) {
        $('#selectedIsawalletId').val('');
    }
    let $isawalletInfo = $('.form-block--isawllet-info');
    if(!$isawalletInfo.hasClass('d-none')) {
        $isawalletInfo.addClass('d-none');
    }
}

// Cash/Debit Card review blocks have no client-side "add" flow of their own (no saved payment
// type ever needs to reveal them from handleSavedPaymentChange()) - only hides, mirroring
// clearIsaWallet()/clearBancontact() above, so switching to any OTHER saved payment method
// (e.g. a saved PayPal) doesn't leave a stale Cash/Debit Card review block visible alongside it.
// Modernized-only: legacy already handles this correctly via its own existing code paths.
function clearCashAndDebitCard() {
    if(!$('.checkout-v2').length) return;
    $('#cashPayment').val('false');
    $('#debitcardPayment').val('false');
    $('.form-block--cash-info').addClass('d-none').hide();
    $('.form-block--debitcard-info').addClass('d-none').hide();
}

function maskEmail(email) {
    let idx = email.indexOf('@');
    if(idx >= 0) {
        let username = email.substring(0, idx);
        if(username.length > 3) {
            let mask = '•'.repeat(username.length - 3);
            return `${username.substring(0, 3)}${mask}${email.substring(idx)}`;
        } else {
            return `•••${email.substring(idx)}`;
        }
    }
    return '';
}

function updateStateProvinceList(data) {
    if(data) {
        if(data.StatesProvinceList) {
            clearStateProvinceList();
            let $state = $('#stateInput');
            let oneOption = data.StatesProvinceList.length === 1;
            $.each(data.StatesProvinceList, function (key, value) {
                let $option = $('<option></option>');
                $option.prop('value', value.StateCode).text(value.StateName);
                if(!oneOption) {
                    $state.append($option);
                    $state.parent().removeClass('d-none');
                } else {
                    $('#selectedState').val(value.StateCode);
                    $option.prop('selected', true);
                    $state.append($option);
                    // $state.parent().addClass('d-none');
                }
            });
            if(oneOption) {
                $state.trigger('change');
                $state.prop('disabled', true);
                addressState.singleStateOptionSelected = true;
            } else {
                if(addressState.singleStateOptionSelected) {
                    $('#selectedState').val('');
                    addressState.singleStateOptionSelected = false;
                }
                $state.prop('disabled', false);
            }
        }
    }
}

function updateLanguageList(data) {
    if(!data || !data.LanguageList) return;

    clearLanguagesList();
    let $language = $('#language');
    let oneOption = data.LanguageList.length === 1;
    $.each(data.LanguageList, function (key, value) {
        let $option = $('<option></option>');
        $option.prop('value', value.LanguageCode).text(value.LanguageName);
        if(!oneOption) {
            $language.append($option);
            $language.parent().removeClass('d-none');
            if(data.LanguageCode && value.LanguageCode === data.LanguageCode) {
                $language.val(value.LanguageCode);
            }
        } else {
            $language.prop('selected', true);
            $language.append($option);
            $language.val(value.LanguageCode);
            // $state.parent().addClass('d-none');
        }
    });
    if(oneOption) {
        $language.trigger('change');
        $language.prop('disabled', true);
    } else {
        $language.prop('disabled', false);
    }
}

function updateMarketCheckoutAddressSettings(data) {
    if(!data || !data.MarketCheckoutAddressSettings) return;
    updateMarketCheckoutAddressLines(data);
    updateMarketCheckoutAddressByPostalCode(data);
}

function postPaymentSubmitCheck() {
    if(hasInvalidPostalCode) {
        displayInvalidPostalCode($('#zipCodeInput'));
    }
}

async function fetchAddressByPostalCode(element) {
    let target = element.target || element;
    let $postalCode = $(target);
    $postalCode.parent().removeClass('is--error');
    $('#zipCodeInput-error.error').remove();
    if($postalCode.data('useAPI') === false) return;
    let request = { PostalCode: $postalCode.val() };
    showSpinner('fetching address by postal code started');
    let result = await checkoutService.getAddressByPostalCode(request);
    if(result && result.IsSuccessful && result.Addresses && result.Addresses.length > 0) {
        hideSpinner('fetching address by postal code completed');
        hasInvalidPostalCode = false;
        populateCustomerAddressData(result);
    } else {
        hideSpinner('fetching address by postal code failed');
        hasInvalidPostalCode = true;
        displayInvalidPostalCode($postalCode);
        clearAddressInvalidPostalCode();
    }
}

function populateCustomerAddressData(data) {
    data.Addresses.forEach(function (item) {
        if(item.Language && item.Language === 'en') return;
        $('#address1Input').val(item.AddressLine1).trigger('input');
        $('#cityInput').val(item.CityOrWard).trigger('input');
        let $state = $('#stateInput');
        $state.val(item.StateCode);
        let $option = $state.find('option').filter(function () {
            return $(this).val().trim() === item.StateCode.trim();
        });
        $option.text(item.Prefecture);
        $option.prop('selected', true);
        $state.trigger('change');
        $state.prop('disabled', true);
        $('#selectedState').val(item.StateCode);
    });
}

function displayInvalidPostalCode($element) {
    $element.parent().addClass('is--error');
    $('#zipCodeInput-error.error').remove();
    let errorText = $element.attr('data-msg-required');
    let errorSpan = `<span id="zipCodeInput-error" class="error">${errorText}</span>`;
    $element[0].insertAdjacentHTML('afterend', errorSpan);
}

function clearAddressInvalidPostalCode() {
    $('#address1Input,#cityInput').val('');
    $('#stateInput').val('default');
}

function updateMarketCheckoutAddressByPostalCode(data) {
    if(!data || !data.MarketAddressCheckoutSettings) return;
    marketAddressCheckoutSettings = data.MarketAddressCheckoutSettings;
    let $postalCode = $('#zipCodeInput');
    if(marketAddressCheckoutSettings.UsesAPIToFetchAddressByPostalCode) {
        $postalCode.data('useAPI', true);
        $('#address1Input,#cityInput,#stateInput').prop('readonly', true);
        $('.zip-group').append($postalCode.parent());
        $('.city-state-zip-group').removeClass('form-group--third').addClass('form-group--half');
        $postalCode.on('blur', fetchAddressByPostalCode);
        $('.form-group__btn--remove').click();
        $('#addAddress').hide();
        $('#stateInput').prop('disabled', true);
        if($postalCode.val()) {
            checkSelectedState();
            fetchAddressByPostalCode($postalCode[0]);
        }
    } else {
        $postalCode.data('useAPI', false);
        $('#address1Input,#cityInput,#stateInput').prop('readonly', false);
        $('.city-state-zip-group').removeClass('form-group--half').addClass('form-group--third');
        $('.city-state-zip-group').append($postalCode.parent());
        $postalCode.off('blur', '**');
        $('#addAddress').show();
        $('#stateInput').prop('disabled', false);
    }
}

function updateMarketCheckoutAddressLines(data) {
    if(!data || !data.MarketCheckoutAddressSettings) return;
    let settings = data.MarketCheckoutAddressSettings;

    let $addAddress = $('#addAddress');
    $addAddress.text(settings.AddAddressLineButtonText);
    $addAddress.off();
    $addAddress.on('click', addAddressLine);
    $addAddress.data('settings', settings);

    let $removeAddress = $('.form-group__btn--remove');
    $removeAddress.off();
    $removeAddress.on('click', removeAddressLine);
    updateRequiredAddressLines(data.MarketCheckoutAddressSettings);
}

function updateRequiredAddressLines(settings) {
    if(!settings) return;
    if(settings.CountryCode === 'MX') {
        // mx is a special case
        nonDefaultAddressLines = nonDefaultAddressLines.filter((item) => !settings.InitialDisplayAddressLines.includes(item));
    }

    clearAddressLines();
    let pendingLines = getPendingAddressLines(settings);
    if(pendingLines && pendingLines.length > 0) {
        $('#addAddress').show();
        let $address1 = $('#address1Input');
        let requiredLines = settings.RequiredAddressLines.split(',');
        let requiredPendingLines = requiredLines.filter(x => pendingLines.includes(x));
        if(requiredPendingLines && requiredPendingLines.length > 0) {
            requiredPendingLines.forEach(function (nextLine) {
                if($(`#address${nextLine}Input`).length > 0) return;
                let isRequired = true;
                let lineProperty = `AddressLine${nextLine}Label`;
                let addressLineLabel = settings[lineProperty];
                if(addressLineLabel) {
                    let addressField = `<div class="form-block"><label for="address${nextLine}Input" class="form-label" >${addressLineLabel}</label><input id="address${nextLine}Input" name="address${nextLine}Input" maxlength="50" class="form-input" type="text" data-msg-required="${$address1.attr('data-msg-required')}" data-invalidchars="${$address1.data('invalidchars')}" data-msg-invalidchars="${$address1.data('msg-invalidchars')}" required="${isRequired}"><button id="remove${nextLine}" type="button" class="form-group__btn form-group__btn--remove btn btn-link d-none">Remove</button></div>`;
                    $(addressField).insertBefore('#addAddress');
                    $(`#remove${nextLine}`).on('click', removeAddress);
                }
            });
        }
    }
    // required for reloading addresslines 2,3 and 4 and revisiting page
    reloadAddressLines(settings);
}

function reloadAddressLines(settings) {
    let $address1 = $('#address1Input');
    nonDefaultAddressLines.forEach(function (lineToCheck) {
        let $loadedAddressLine = $(`#loadAddress${lineToCheck}`);
        let value = $loadedAddressLine.val();
        if(value) {
            let $addressLineElement = $(`#address${lineToCheck}Input`);
            if($addressLineElement.length > 0) {
                $addressLineElement.val(value).trigger('input');
            } else {
                let lineProperty = `AddressLine${lineToCheck}Label`;
                let addressLineLabel = settings[lineProperty];
                let addressField = `<div class="form-block"><label for="address${lineToCheck}Input" class="form-label" >${addressLineLabel}</label><input id="address${lineToCheck}Input" name="address${lineToCheck}Input" maxlength="50" class="form-input" type="text" data-msg-required="${$address1.attr('data-msg-required')}" data-invalidchars="${$address1.data('invalidchars')}" data-msg-invalidchars="${$address1.data('msg-invalidchars')}" required="false"><button id="remove${lineToCheck}" type="button" class="form-group__btn form-group__btn--remove btn btn-link">Remove</button></div>`;
                $('#addAddress').parent('.form-group').append(addressField);
                $(`#remove${lineToCheck}`).on('click', removeAddress);
                $(`#address${lineToCheck}Input`).val(value).trigger('input');
            }
        }
    });
}

function clearAddressLines() {
    nonDefaultAddressLines.forEach(function (lineToRemove) {
        let $addressLine = $(`#address${lineToRemove}Input`);
        if($addressLine.length > 0) {
            $addressLine.parents('.form-block').remove();
        }
    });
}

function getPendingAddressLines(settings) {
    let availableLines = settings.AvailableAddressLines.split(',');
    let linesForDisplay = settings.InitialDisplayAddressLines.split(',');
    let pendingLines = availableLines.filter(x => $(`#address${x}Input:not(:disabled)`).length === 0 && $(`#address${x}Input`).length === 0)
        .concat(linesForDisplay.filter(x => !availableLines.includes(x)));
    return pendingLines;
}

let $cancelSetupSub = $('#ContinueCancelSetUpSubBtn');
$cancelSetupSub.off();
$cancelSetupSub.on('click', DiscardSetupSubscription);

function addAddressLine(e) {
    e.preventDefault();
    let $this = $(this);
    let $address1 = $('#address1Input');
    let settings = $this.data('settings');
    let pendingLines = getPendingAddressLines(settings);
    if(pendingLines && pendingLines.length > 0) {
        let nextLine = '';
        pendingLines.forEach(function (lineNumber) {
            if(!nextLine && $(`#address${lineNumber}Input:not(:disabled)`).length === 0) {
                nextLine = lineNumber;
            }
        });
        if(nextLine) {
            let lineProperty = `AddressLine${nextLine}Label`;
            let addressLineLabel = settings[lineProperty];

            let newAddressLineHelpText = '';
            if($address1.data('msg-addfieldhelptext')) {
                newAddressLineHelpText = $address1.data('msg-addfieldhelptext');
            }

            let newAddressLineMaxLength = '50';
            if($address1.data('addfieldmaxlength')) {
                newAddressLineMaxLength = $address1.data('addfieldmaxlength');
            }

            // even if label is missing, should not stop adding additional lines
            let addressField = `<div class="form-block"><label for="address${nextLine}Input" class="form-label" >${addressLineLabel}</label><input id="address${nextLine}Input" name="address${nextLine}Input" maxlength="${newAddressLineMaxLength}" class="form-input" type="text" data-msg-required="${$address1.attr('data-msg-required')}" data-invalidchars="${$address1.data('invalidchars')}" data-msg-invalidchars="${$address1.data('msg-invalidchars')}" required="false">${newAddressLineHelpText}<button id="remove${nextLine}" type="button" class="form-group__btn form-group__btn--remove btn btn-link">Remove</button></div>`;

            $this.parent('.form-group').append(addressField);
            $(`#remove${nextLine}`).on('click', removeAddress);
            if(pendingLines.length === 1) {
                $this.hide();
            }
        }
    } else {
        $this.hide();
    }
}

function removeAddressLine(e) {
    e.preventDefault();
    let $this = $(this);
    let $addAddress = $('#addAddress');
    $this.parents('.form-block').remove();
    $addAddress.show();
}

function clearStateProvinceList() {
    $('#stateInput option:gt(0)').remove();
}

function clearLanguagesList() {
    $('#language option:gt(0)').remove();
}

async function updateBillingAddressForm(result) {
    try {
        let $countryBilling = $('#countryBilling');
        let $option = $countryBilling.find('option:selected');
        if(result && result.StatesProvinceList && result.StatesProvinceList.length > 0) {
            let $zipField = $('#zipCodeInput');

            if($zipField.length > 0 && result.LanguageList && result.LanguageList.length > 0) {
                updateLanguageList(result);
            }

            let validationMessage = $option.data('postalcodemsg');
            $zipField.prop('pattern', $option.data('postalcoderegex'));
            $zipField.attr('data-msg-required', validationMessage);
            $('#zipCodeInput-error').text(validationMessage);
            updateStateProvinceList(result);
            updateMarketCheckoutAddressSettings(result);
            checkSelectedState();
            checkForCountryFields();
        } else {
            clearStateProvinceList();
            console.dir(result);
        }
    } catch (e) {
        console.error(e);
    }
}

function checkSelectedState() {
    let $selectedState = $('#selectedState');
    if($selectedState.length > 0) {
        let value = $selectedState.val();
        if (!!value) {//eslint-disable-line
            $('#stateInput').val(value);
        }
    }
}

function checkSelectedShippingMethod() {
    let $selectedShipping = $('#selectedShippingMethod');
    if($selectedShipping.length > 0) {
        let value = $selectedShipping.val();
        if (!!value) {//eslint-disable-line
            $('#shippingOption').val(value);
        }
    }
}

function checkSelectedPaymentMethod() {
    // In the modernized checkout the new card-based payment selector handles
    // method selection — no default auto-selection per design spec.
    if($('.mod-payment-method-card').length > 0) return;

    let $formInputPayment = $('.form-input--payment');
    if($formInputPayment.length > 0) {
        let selected = false;
        $formInputPayment.each(function () {
            let $this = $(this);
            if($this.is(':checked')) {
                $this.trigger('click');
                selected = true;
            }
        });
        if(!selected) {
            $formInputPayment.first().trigger('click');
        }
    }
}

function checkCountrySelection() {
    let $countryBilling = $('#countryBilling');
    if($countryBilling.length > 0) {
        $countryBilling.on('change', loadBillingAddressPartialForCountry);
        // if($('#countryBilling option:selected').index() > 0) {
        //     $countryBilling.trigger('change');
        // } else {
        //     $countryBilling.val($('#selectedCountry').val());
        //     $countryBilling.trigger('change');
        // }
    }
}

async function loadBillingAddressPartialForCountry() {
    try {
        let $this = $(this);
        let selectedCountry = $this.val();

        let $datasourceItemId = $('#paymentDatasourceItemId');
        let datasourceItemId = $datasourceItemId.val();

        let data = {
            CountryCode: selectedCountry,
            PaymentDatasourceItemId: datasourceItemId
        };

        showSpinner('loading billing address details for country started');
        let result = await checkoutService.getBillingAddressView(data);
        console.log('Billing address partial result: ', result);
        if(result && result.Html) {
            let $billingAddressFormPartial = $('.billingAddressFormPartial');
            if($billingAddressFormPartial.length > 0) {
                $billingAddressFormPartial.html('');
                $billingAddressFormPartial.html(result.Html);
                if($('.checkout-v2').length > 0 && selectedCountry.toUpperCase() === 'MX') {
                    const $legacyTooltip = $billingAddressFormPartial.find('.form-group__btn--tooltip');
                    const $address2Label = $billingAddressFormPartial.find('label[for="address2Input"]');
                    if($legacyTooltip.length > 0 && $address2Label.length > 0) {
                        $legacyTooltip
                            .removeClass('form-group__btn form-group__btn--tooltip btn btn-link')
                            .addClass('mod-field__label-icon-btn')
                            .appendTo($address2Label);
                        $legacyTooltip.find('.tooltip20').removeClass('tooltip20').addClass('circle-info-custom');
                    }
                }
                updateBillingAddressForm(result);
                initAddressAutocomplete();

                let pendingLines = getPendingAddressLines(result.MarketCheckoutAddressSettings);
                if(!pendingLines || pendingLines.length <= 0) {
                    // hide "Add Address Line" if no pending remaining
                    $('#addAddress').hide();
                } else {
                    // show "Add Address Line" if pending remaining
                    $('#addAddress').show();
                }
                hideSpinner('loading billing address details for country completed');
            }
        } else {
            hideSpinner('loading billing address details for country failed');
        }
    } catch (e) {
        console.error(e);
        hideSpinner('loading billing address details for country failed');
    }
}

function checkForCountryFields() {
    let $countryBilling = $('#countryBilling option:selected');
    if($countryBilling.length === 0) return;

    let selectedCountry = $countryBilling.val();
    if(selectedCountry.length === 0) return;

    switch (selectedCountry.toLowerCase()) {
        case 'nz':
            $('.show-for-nz-only').show();
            if($('#address4Input').attr('disabled')) { $('#address4Input').removeAttr('disabled'); }
            $('.show-for-nz-only').removeClass('fullWidth');
            $('#stateInput').attr('disabled', 'disabled');
            $('.hide-for-nz').hide();
            $('#zipInputDiv').detach().insertAfter($('.hide-for-nz'));
            break;
        case 'bg':
            $('.show-for-nz-only').hide();
            $('#address4Input').attr('disabled', 'disabled');
            if($('#stateInput').attr('disabled')) { $('#stateInput').removeAttr('disabled'); }
            $('.hide-for-nz').show();
            break;
        case 'gb':
            $('.showHideAddress4Input').show();
            if($('#address4Input').attr('disabled')) { $('#address4Input').removeAttr('disabled'); }
            $('.showHideAddress4Input').addClass('fullWidth');
            $('.showHideStateInput').show();
            if($('#stateInput').attr('disabled')) { $('#stateInput').removeAttr('disabled'); }
            $('#zipInputDiv').detach().insertAfter($('.showHideStateInput'));
            break;
        case 'mx':
            $('.showHideAddress4Input').show();
            if($('#address4Input').attr('disabled')) { $('#address4Input').removeAttr('disabled'); }
            $('.showHideAddress4Input').addClass('fullWidth');
            $('.showHideStateInput').show();
            if($('#stateInput').attr('disabled')) { $('#stateInput').removeAttr('disabled'); }
            $('#zipInputDiv').detach().insertAfter($('.showHideStateInput'));
            break;
        case 'nl':
            // generic
            $('.showHideAddress4Input').hide();
            $('#address4Input').attr('disabled', 'disabled');
            $('.showHideStateInput').hide();
            $('#stateInput').attr('disabled', 'disabled');
            $('#zipInputDiv').detach().insertAfter($('.showHideStateInput'));
            break;
        default:
            $('.show-for-nz-only').hide();
            $('#address4Input').attr('disabled', 'disabled');
            if($('#stateInput').attr('disabled')) { $('#stateInput').removeAttr('disabled'); }
            if($('.checkout-v2').length > 0 && $('.showHideStateInput').length > 0 && $('#stateInput').length === 0) {
                $('.showHideStateInput').hide();
            } else {
                $('.hide-for-nz').show();
            }
            $('#zipInputDiv').detach().insertAfter($('.hide-for-nz'));
            break;
    }
}

function clearShippingTabValidationState() {
    let $shippingTabs = $('.checkout-v2 .checkout__shipping-tab');
    $shippingTabs.find('span.error').remove();
    $shippingTabs.find('.mod-field--error, .mod-checkbox--error, .is--error').removeClass('mod-field--error mod-checkbox--error is--error');
    $shippingTabs.find('input.error, select.error, textarea.error').removeClass('error');
    $shippingTabs.find('[aria-invalid="true"]').removeAttr('aria-invalid');
}

async function shippingTabSelected() {
    let $this = $(this);
    let currentShippingType = updateShippingType($this);
    let value;
    let $selectedShipping = $('#selectedShippingMethod');

    // cart may have shipping with delivery method selected
    if($selectedShipping.length > 0) {
        value = $selectedShipping.val();
    }
    // $('#shippingType') - cart may have pickup
    if(currentShippingType === SHIPPING_TYPE_SHIPPING) {
        if((CART_SHIPPING_TYPE !== SHIPPING_TYPE_SHIPPING || (!value))) {
            await getShippingOptions();
        }
    }
}

function triggerCheckoutUpdates() {
    checkSelectedState();
    checkSelectedShippingMethod();
    checkSelectedPaymentMethod();
    checkCountrySelection();
    loadAddress();
    loadSelectedAddress();
    showHideIsaDelivery();
    updateShippingFormValidator();
    updatePaymentFormValidator();
    updateReviewFormValidator();
    showHideCheckoutDisclaimers();
    updateCheckoutDisclaimersFormValidator();
    loadPaypalData();
    loadVenmoData();
    loadDeviceData();
    checkTimezone();
    // triggerInputEvent();
}

// function triggerInputEvent() {
//     let $input = $('.checkout__shipping input, .checkout__form input');
//     $input.each(function (idx, e) {
//         let $element = $(e);
//         if(!!$element.val()) {//eslint-disable-line
//             formInput.call(e);
//         }
//     });
// }

function checkTimezone() {
    let $timezoneOffset = $('#timezoneOffset');
    $timezoneOffset.val(new Date().getTimezoneOffset());
}

function toggleAddress(e) {
    e.preventDefault();
    let $this = $(this);
    let text = $this.text();
    $this.parents().find('.checkout__add-address').slideToggle();
    $this.text(text === '+ Add New Address' ? 'Cancel' : '+ Add New Address');
}

function subSaveContainers() {
    let $checkboxToggle = $('.form-input--toggle');
    if($checkboxToggle.prop('checked')) {
        $(CHECKOUT_SUBSCRIBE).hide();
    } else {
        $(CHECKOUT_SUBSCRIBE).show();
    }
}

function toggleContainer(e) {
    e.preventDefault();
    let $this = $(this);
    if($this.prop('checked')) {
        $this.parentsUntil(CHECKOUT_SAVE).siblings(CHECKOUT_SUBSCRIBE).hide();
    } else {
        $this.parentsUntil(CHECKOUT_SAVE).siblings(CHECKOUT_SUBSCRIBE).show();
    }
}

function toggleBillingAddress() {
    let $this = $(this);
    if($this.prop('checked')) {
        $this.parentsUntil(CREDIT_CARDS).siblings(BILLING_INFO).hide();
        $this.parentsUntil(CREDIT_CARDS).siblings(SHIPPING_INFO).show();
    } else {
        $this.parentsUntil(CREDIT_CARDS).siblings(BILLING_INFO).show();
        $this.parentsUntil(CREDIT_CARDS).siblings(SHIPPING_INFO).hide();
    }
}

function toggleBillingAddressFormValues() {
    if($('#useShippingAddress').is(':checked')) {
        let address = $('#shippingInformation').data('shippingaddress');
        $('#address1Input').val(address.Address1);
        if($('#address2Input').length > 0) {
            $('#address2Input').val(address.Address2);
        }
        if($('#address3Input').length > 0) {
            $('#address3Input').val(address.Address3);
        }
        if($('#address4Input').length > 0) {
            $('#address4Input').val(address.Address4);
        }
        $('#cityInput').val(address.City);
        $('#zipCodeInput').val(address.ZipCode);
    } else {
        if($('#billingInformation').not(':visible').length > 0) {
            if($('#savedBillingInformation').data('billingaddress') !== '') {
                let billingAddress = $('#savedBillingInformation').data('billingaddress');
                $('#addressError').hide();
                $('#address1Input').val(billingAddress.AddressLine1);
                if($('#address2Input').length > 0) {
                    $('#address2Input').val(billingAddress.AddressLine2);
                }
                if($('#address3Input').length > 0) {
                    $('#address3Input').val(billingAddress.AddressLine3);
                }
                if($('#address4Input').length > 0) {
                    $('#address4Input').val(billingAddress.AddressLine4);
                }
                $('#cityInput').val(billingAddress.City);
                $('#zipCodeInput').val(billingAddress.PostalCode);
                $('#address1Input').focusout();
            }
        }
    }
}

function showPaymentMethod(className) {
    $('.payment__providers').hide();
    $('.checkout__payment-block').addClass('d-none');
    let $target = $(`.${className}`).removeClass('d-none');
    if($('.checkout-v2').length > 0) {
        $target.css('display', '');
    } else {
        $target.show();
    }
    $('.form-block--change-payment').show();
    if($('#savedPayment').length) {
        $('.checkout_saved_payments').hide();
        $('.checkout_saved_payments_label').hide();
        $('.mod-saved-payments').hide();
    }
    // Modernized checkout: the "Select a payment type to get started" card grid is a
    // separate element from .payment__providers above, so it must be hidden explicitly
    // once a saved payment method (e.g. a saved credit card) has been selected - otherwise
    // it stays visible alongside the selected card's summary/billing address.
    if($('.mod-payment-method-card').length > 0) {
        $('.mod-payment-selection').hide();
    }
    // A payment method is now selected client-side (before any page reload) - reveal the
    // "Change Payment Method" link so it's available immediately, mirroring
    // revealPaypalSummaryModernized()'s equivalent reveal for the PayPal success path.
    $('.mod-payment-selection__change-wrap').show();
}

// =============================================================================
// PAYMENT METHOD CARD SELECTION (modernized checkout v2)
// Handles the new card-based payment method picker (.mod-payment-method-card).
// Each card maps to an existing underlying payment handler via data-payment-method.
// =============================================================================

// In modernized checkout, reveals payment__providers but shows only the direct
// child div containing the target button. Covers both .mod-form-group and
// non-standard containers like .venmo-option-container.
function showOnlyProviderButton($button) {
    const $providers = $('.payment__providers');
    $providers.show();
    $providers.children('div').hide();
    $button.closest($providers.children('div')).show();
}

// Hides the card selector, shows only the target provider button, and shows back button.
function showProviderInlineModernized($button) {
    $('.mod-payment-selection').hide();
    showOnlyProviderButton($button);
    $('#btnCancelPaypalFlow').show();
}

// Restores the card selector from PayPal inline mode.
function cancelPaypalInlineFlow() {
    $('.payment__providers').hide();
    $('#btnCancelPaypalFlow').hide();
    $('.mod-payment-selection').show();
    $('.mod-payment-method-card').removeClass('is--selected').attr('aria-pressed', 'false');
    $('#paymentChanged').val('false');
}

const PAYMENT_METHOD_HANDLER_MAP = {
    cc: () => {
        if($('#btnCreditCard').length) {
            onCreditCardButtonClick();
        }
    },
    paypal: () => {
        if($('.mod-payment-method-card').length > 0) {
            // Mouse users: the transparent overlay iframe inside the PayPal card handles
            // the click directly (no JS needed here). This handler runs for keyboard
            // activation (Enter/Space on the card) — show the PayPal button as fallback.
            showProviderInlineModernized($('#paypal-button'));
        } else {
            $('.payment__providers').show();
            $(FORM_PAYMENT).data('payment-type', PAYMENT_METHOD_PAYPAL);
        }
    },
    sepa: () => {
        if($('.mod-payment-method-card').length > 0) {
            showProviderInlineModernized($('#btn-sepa'));
        } else {
            $('.payment__providers').show();
        }
        if($('#btn-sepa').length) {
            $('#btn-sepa').trigger('click');
        }
    },
    ideal: () => {
        if($('.mod-payment-method-card').length > 0) {
            showProviderInlineModernized($('#btn-ideal'));
        } else {
            $('.payment__providers').show();
        }
        if($('#btn-ideal').length) {
            $('#btn-ideal').trigger('click');
        }
    },
    bancontact: () => {
        if($('.mod-payment-method-card').length > 0) {
            showProviderInlineModernized($('#btn-bancontact'));
        } else {
            $('.payment__providers').show();
        }
        if($('#btn-bancontact').length) {
            $('#btn-bancontact').trigger('click');
        }
    },
    applepay: () => {
        const $applePayBtn = $('.apple-pay-button');
        if($applePayBtn.length) {
            $applePayBtn.trigger('click');
        }
    },
    venmo: () => {
        if($('.mod-payment-method-card').length > 0) {
            // Show payment__providers off-screen so the button is clickable,
            // but keep the card selector visible in the background.
            const $providers = $('.payment__providers');
            $providers.css({ position: 'absolute', left: '-9999px', visibility: 'hidden' }).show();
            $providers.children('div').hide();
            $('#venmo-button').closest($providers.children('div')).show();
            const $venmoBtn = $('#venmo-button');
            if($venmoBtn.length) {
                $venmoBtn.trigger('click');
            }
            // Restore after click
            $providers.hide().css({ position: '', left: '', visibility: '' });
        } else {
            $('.payment__providers').show();
            const $venmoBtn = $('#venmo-button');
            if($venmoBtn.length) {
                $venmoBtn.trigger('click');
            }
        }
    },
    isawallet: () => {
        if($('.mod-payment-method-card').length > 0) {
            showProviderInlineModernized($('#btn-isawallet'));
        } else {
            $('.payment__providers').show();
        }
        if($('#btn-isawallet').length) {
            $('#btn-isawallet').trigger('click');
        }
    },
    cash: () => {
        if($('.mod-payment-method-card').length > 0) {
            showProviderInlineModernized($('#btn-cash'));
        } else {
            $('.payment__providers').show();
        }
        if($('#btn-cash').length) {
            $('#btn-cash').trigger('click');
        }
    },
    debitcard: () => {
        if($('.mod-payment-method-card').length > 0) {
            showProviderInlineModernized($('#btn-debitcard'));
        } else {
            $('.payment__providers').show();
        }
        if($('#btn-debitcard').length) {
            $('#btn-debitcard').trigger('click');
        }
    }
};

function onPaymentMethodCardClick() {
    const $card = $(this);
    const method = $card.data('payment-method');

    // Reset: hide legacy providers section and cancel PayPal back-button if active
    $('.payment__providers').hide();
    $('#btnCancelPaypalFlow').hide();

    // Single-select: deselect all other cards
    $('.mod-payment-method-card').removeClass('is--selected').attr('aria-pressed', 'false');

    // Select this card
    $card.addClass('is--selected').attr('aria-pressed', 'true');

    // Selecting a new payment method clears any previously selected saved payment method
    clearModSavedPaymentSelection();

    // Hide page-level error on new selection
    hideMainErrorMessage();
    hideMainPaymentErrorMessage();

    // Invoke the corresponding payment method handler
    const handler = PAYMENT_METHOD_HANDLER_MAP[method];
    if(typeof handler === 'function') {
        handler();
    }
}

// =============================================================================
// SAVED PAYMENT METHODS RADIO TABLE (modernized checkout v2)
// Drives the hidden, ddslick-enhanced #savedPayment <select> so all existing saved-
// payment processing logic (handleSavedPaymentChange, isSavedCreditCardContext, etc.)
// keeps working unmodified. Only the visual picker (.mod-saved-payments) is new.
// =============================================================================

function clearModSavedPaymentSelection() {
    $('.mod-saved-payments__radio').prop('checked', false);
    $('.mod-saved-payments__row').removeClass('is--selected');
    const $savedPayment = $('#savedPayment');
    if($savedPayment.length && $savedPayment.val() !== 'default') {
        $savedPayment.ddslick('select', { index: 0 });
    }
    if($('#savedCCId').length) {
        $('#savedCCId').val('');
    }
}

function onModSavedPaymentRadioChange() {
    const $radio = $(this);
    const $savedPayment = $('#savedPayment');
    if(!$savedPayment.length) { return; }

    // NOTE: ddslick replaces the <select> with a plain <div> and detaches its <option>
    // elements from the DOM, so the dropdown index can't be looked up here at runtime -
    // it's rendered server-side (data-option-index) since both partials iterate the
    // saved payments list in the same order.
    const matchedIndex = parseInt($radio.data('option-index'), 10);
    if(isNaN(matchedIndex) || matchedIndex < 0) { return; }

    // Selecting a saved payment method clears any previously selected new-method card
    $('.mod-payment-method-card').removeClass('is--selected').attr('aria-pressed', 'false');
    $('.mod-saved-payments__row').removeClass('is--selected');
    $radio.closest('.mod-saved-payments__row').addClass('is--selected');

    hideMainErrorMessage();
    hideMainPaymentErrorMessage();

    $savedPayment.ddslick('select', { index: matchedIndex });
    handleSavedPaymentChange($.Event('click'));
    updatePaymentContinueButtonVisibility();
}

function toggleSavedPaymentsShowMore() {
    const $btn = $(this);
    const isExpanded = $btn.attr('aria-expanded') === 'true';
    $btn.attr('aria-expanded', (!isExpanded).toString());
    $btn.closest('.mod-saved-payments').find('.mod-saved-payments__row--more').toggleClass('d-none');
    $btn.find('.mod-saved-payments__show-more-text--more, .mod-saved-payments__show-more-text--less').toggleClass('d-none');
    // NOTE: toggle 'flip' on the button itself (not on the FontAwesome-converted icon <svg>
    // directly) - matching the .cart__show-more convention. Toggling a class directly on an
    // element that FontAwesome's JS has already converted to an inline <svg> re-triggers its
    // MutationObserver, which re-processes the icon without its original style class (e.g. "fal")
    // and falls back to a broken "missing icon" glyph.
    $btn.toggleClass('flip');
}

function initModSavedPayments() {
    $(document).on('change', '.mod-saved-payments__radio', onModSavedPaymentRadioChange);
    $(document).on('click', '.mod-saved-payments__show-more', toggleSavedPaymentsShowMore);

    // NOTE: on modernized (.checkout-v2) pages, the "Add a new payment method" cards are
    // actually driven by checkout-modernized.js's own onPaymentMethodCardClick (a separate
    // module-scoped copy) - NOT the one in this file, which never binds there (see the
    // `.checkout-v2` early-return guard in initPaymentMethodCards below). Rather than reach
    // into that module, bind a second, independent delegated click handler here so selecting
    // a new-method card always clears any saved-payment radio selection, regardless of which
    // module's click handler also fires.
    $(document).on('click', '.mod-payment-method-card', clearModSavedPaymentSelection);
}

function initPaymentMethodCards() {
    if($('.checkout-v2').length > 0) return;

    const $cards = $('.mod-payment-method-card');
    if($cards.length === 0) return;
    if($cards.filter(function() { return $(this).data('checkout-modernized-bound') === true; }).length > 0) return;

    // Card selection is the entry point — hide provider buttons until a card is chosen
    $('.payment__providers').hide();

    $cards.each(function() {
        $(this).data('checkout-modernized-bound', true);
    });
    $cards.on('click', onPaymentMethodCardClick);
}

function validateReview() {
    let $cvvReview = $('#checkout');
    let $placeOrderReview = $('.place-order');
    let $isZDE = $('#isZDE');
    if($isZDE.length > 0 && $isZDE.val().toLowerCase() === 'true') {
        $placeOrderReview.prop('disabled', false);
        return;
    }
    $cvvReview.validate(validation);
    let hadDisabledBtns = false;
    $.each($placeOrderReview, function (idx, item) {
        hadDisabledBtns = hadDisabledBtns || $(item).prop('disabled') === true;
    });
    let isZeroDollarEnrollment = $('#isZeroDollarEnrollment').val();
    if(hadDisabledBtns && isZeroDollarEnrollment === 'false') {
        $placeOrderReview.prop('disabled', true);
    }
}

function completeBancontactFallbackOrder() {
    var token = $('#txt-bancontact-token').val();
    var orderNumber = $('#txt-bancontact-ordernumber').val(); // eslint-disable-line
    if(!window.braintree) {
        return;
    }
    showSpinner('Completing Bancontact order started');
    braintree.client.create({ // eslint-disable-line
        authorization: token
    }).then(function (clientInstance) {
        return braintree.localPayment.create({ // eslint-disable-line
            client: clientInstance
        });
    }).then(function (localPaymentInstance) {
        if(localPaymentInstance.hasTokenizationParams()) {
            localPaymentInstance.tokenize().then(function (payload) {
                console.log(payload);
                let request = {
                    Nonce: payload.nonce,
                    PaymentId: payload.correlationId,
                    OrderNumber: orderNumber
                };

                // creating sale transaction
                checkoutbancontact(request, true);
                hideSpinner('Completing Bancontact order completed');
            }).catch(function (tokenizeError) {
                hideSpinner('Completing Bancontact order failed');
                $('#pending-order-error-msg').show();
                console.log(tokenizeError);
            });
        } else {
            // if this page should only be reached when
            // recovering from a mobile app switch,
            // display an error for not having the
            // correct params in the query string
            $('#pending-order-error-msg').show();
        }
    });
}

function ccDropdown() {
    let $input = $('.cc-field__current');
    let $dropdown = $('.cc-dropdown');
    let $list = $('.cc-field__list');
    let $option = $('.cc-field__option');
    const DD_SELECTED = 'cc-field__selected';
    const DD_FOCUSED = 'cc-dropdown__is-focused ';

    $input.click(function () {
        if($list.is(':hidden')) {
            $list.show();
            $dropdown.addClass(DD_FOCUSED);
            return false;
        } else {
            $list.hide();
        }
    });

    $(document).click(function () {
        $dropdown.removeClass(DD_FOCUSED);
        $list.hide();
    });

    $(document).ready(function () {
        console.log('ready!');
        var applePaySession = window.ApplePaySession;
        if(applePaySession) {
            if(applePaySession.canMakePayments) {
                showApplePayButton();
                $('#apShippingHelperText').removeClass('d-none');
            }
        }

        var pendingOrderCompletion = $('#txt-bancontact-token').val();
        if(pendingOrderCompletion) {
            completeBancontactFallbackOrder();
        }
    });

    $(window).on('load', function () {
        console.log('window!');
    });

    $list.click(function (e) {
        $dropdown.addClass(DD_FOCUSED);
        e.stopPropagation();
    });

    $option.click(function () {
        let $this = $(this);
        $option.removeClass(DD_SELECTED);
        $this.addClass(DD_SELECTED);
    });
}

async function getMelissaAddresses() {
    try {
        hideMainErrorMessage();
        let $form = $('form#shipping');
        showSpinner('fetching address by postal code started');
        let result = await checkoutService.getMelissaAddress($form.serialize());
        updateEnteredAddress();
        updateSelectedAddressWithEnteredAddress();

        if(result && result.IsSuccessful) {
            updateEnteredAddressDefaultSelection(result.EnteredFormattedAddress);
            await updateMelissaAddresses(result);
            hideSpinner('fetching address by postal code completed');
        } else {
            displayMelissaAddressError(result);
            hideSpinner('fetching address by postal code failed');
        }
    } catch (e) {
        console.error(e);
        hideSpinner('fetching address by postal code failed');
    }
}

// Address Line 1 Autocomplete Functions
async function getAddressAutocomplete(searchText) {
    try {
        if(!searchText || searchText.length < addressAutocomplete.minChars) {
            hideAddressAutocomplete();
            return;
        }

        // Get state value and exclude if it's the default
        let stateValue = $('#stateInput').val();
        let stateCode = $('#selectedState').val();

        // Check if state is default value and exclude it
        if(stateValue === 'default' || stateCode === 'default') {
            stateValue = '';
            stateCode = '';
        }

        // Build request with current form data
        var countryCode = $('.checkout-v2').length
            ? $('form#shipping #countryCode').val()
            : $('#countryCode').val() || $('#countryBilling').val();
        let requestData = {
            CountryCode: countryCode,
            Address1: searchText,
            City: $('#cityInput').val(),
            StateInput: stateValue,
            StateCode: stateCode,
            ZipCode: $('#zipCodeInput').val()
        };

        let result = await checkoutService.getMelissaExpressAddressMatches(requestData);

        if(result && result.IsSuccessful && result.MelissaAddresses && result.MelissaAddresses.length > 0) {
            addressAutocomplete.suggestions = result.MelissaAddresses;
            showAddressAutocomplete(result.MelissaAddresses);
        } else {
            hideAddressAutocomplete();
        }
    } catch (e) {
        console.error('Address autocomplete error:', e);
        hideAddressAutocomplete();
    }
}

function showAddressAutocomplete(addresses) {
    try {
        if(!addresses || !Array.isArray(addresses) || addresses.length === 0) {
            hideAddressAutocomplete();
            return;
        }

        let $input = $('#address1Input');
        if(!$input.length) {
            console.warn('Address input field not found');
            return;
        }

        let $container = $('#address-autocomplete-container');
        $container.attr({ 'role': 'listbox', 'aria-label': 'Address suggestions' });

        $container.empty();
        let searchText = $input.val().trim();

        addresses.forEach((address, index) => {
            if(!address) return;

            let addressParts = [];
            if(address.Address1) addressParts.push(address.Address1);
            if(address.Address2 && address.Address2.trim() !== '') addressParts.push(address.Address2);
            if(address.City) addressParts.push(address.City);
            let stateZip = [];
            if(address.StateCode) stateZip.push(address.StateCode);
            if(address.ZipCode) stateZip.push(address.ZipCode);
            if(stateZip.length > 0) addressParts.push(stateZip.join(' '));
            let displayText = addressParts.join(', ');

            // Highlight matching text in bold (visual only, plain text in aria-label)
            let highlightedText = displayText;
            if(searchText) {
                try {
                    let regex = new RegExp('(' + searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
                    highlightedText = displayText.replace(regex, '<strong>$1</strong>');
                } catch (regexError) {
                    console.warn('Regex error in address highlighting:', regexError);
                    highlightedText = displayText;
                }
            }

            let optionId = 'address-autocomplete-option-' + index;
            let $item = $('<div class="address-autocomplete__item" data-index="' + index + '" id="' + optionId + '" role="option" aria-selected="false" aria-label="' + displayText.replace(/"/g, '&quot;') + '">' + highlightedText + '</div>');

            $item.on('mousedown', function(e) {
                e.preventDefault();
                selectAddressFromAutocomplete(index);
            });

            $container.append($item);
        });

        $container.show();
        $input.attr('aria-expanded', 'true');
        $input.removeAttr('aria-activedescendant');
        addressAutocomplete.isVisible = true;
        addressAutocomplete.selectedIndex = -1;

        // Announce to screen readers
        let count = addresses.length;
        let announceText = count + ' address suggestion' + (count !== 1 ? 's' : '') + ' available. Use up and down arrows to navigate.';
        announceToScreenReader(announceText);
    } catch (e) {
        console.error('Error showing address autocomplete:', e);
        hideAddressAutocomplete();
    }
}

function hideAddressAutocomplete() {
    try {
        $('#address-autocomplete-container').hide();
        let $input = $('#address1Input');
        $input.attr('aria-expanded', 'false');
        $input.removeAttr('aria-activedescendant');
        addressAutocomplete.isVisible = false;
        addressAutocomplete.selectedIndex = -1;
        addressAutocomplete.suggestions = [];
        announceToScreenReader('');
    } catch (e) {
        console.error('Error hiding address autocomplete:', e);
    }
}

function announceToScreenReader(text) {
    let $liveRegion = $('#address-autocomplete-live-region');
    if($liveRegion.length) {
        // Clear first to ensure repeated identical messages are announced
        $liveRegion.text('');
        setTimeout(function() { $liveRegion.text(text); }, 50);
    }
}

function selectAddressFromAutocomplete(index) {
    try {
        if(!addressAutocomplete.suggestions || index < 0 || index >= addressAutocomplete.suggestions.length) {
            hideAddressAutocomplete();
            return;
        }

        let selectedAddress = addressAutocomplete.suggestions[index];
        let announcementText = '';
        if(selectedAddress) {
            populateFormWithAutocompleteAddress(selectedAddress);

            // Build plain text for announcement
            let parts = [];
            if(selectedAddress.Address1) parts.push(selectedAddress.Address1);
            if(selectedAddress.City) parts.push(selectedAddress.City);
            if(selectedAddress.StateCode) parts.push(selectedAddress.StateCode);
            if(selectedAddress.ZipCode) parts.push(selectedAddress.ZipCode);
            announcementText = 'Selected address: ' + parts.join(', ');
        }
        hideAddressAutocomplete();
        // Announce after hide so the hide's empty announcement doesn't overwrite
        if(announcementText) {
            announceToScreenReader(announcementText);
        }
    } catch (e) {
        console.error('Error selecting address from autocomplete:', e);
        hideAddressAutocomplete();
    }
}

function populateFormWithAutocompleteAddress(address) {
    try {
        if(!address) return;

        let isShippingPage = $('form#shipping').length > 0;

        console.log('Populating form with selected autocomplete address:', address);
        if($('#address1Input').length) {
            $('#address1Input').val(address.Address1 || '');
        }

        // If Address2 is returned and not null/empty, ensure address2Input exists by triggering Add Address button if needed
        if(address.Address2 && address.Address2.trim() !== '') {
            if($('#address2Input').length === 0 && $('#addAddress').is(':visible')) {
                // Trigger the Add Address button programmatically
                $('#addAddress').trigger('click');
            }
            if($('#address2Input').length && $('#address2Input').is(':visible')) {
                $('#address2Input').val(address.Address2).trigger('input').trigger('keyup');
            }
        }

        if(address.Address3 && $('#address3Input').length && $('#address3Input').is(':visible')) {
            $('#address3Input').val(address.Address3).trigger('input').trigger('keyup');
        }

        if(address.Address4 && $('#address4Input').length && $('#address4Input').is(':visible')) {
            $('#address4Input').val(address.Address4).trigger('input').trigger('keyup');
        }

        if($('#cityInput').length) {
            $('#cityInput').val(address.City || '').trigger('input').trigger('keyup');
        }

        if(address.StateCode) {
            if($('#stateInput').length) {
                $('#stateInput').val(address.StateCode).trigger('keyup');
            }
            if($('#selectedState').length) {
                $('#selectedState').val(address.StateCode);
            }
        }

        if($('#zipCodeInput').length) {
            $('#zipCodeInput').val(address.ZipCode || '').trigger('input').trigger('keyup');
        }

        if(isShippingPage) {
            resetAddressVerification.call($('#address1Input')[0]);
            $('#zipCodeInput').trigger('blur');
        }

        $('#address1Input, #address2Input, #address3Input, #address4Input, #cityInput, #zipCodeInput').each(function() {
            if($(this).val()) {
                $(this).siblings('.form-label').addClass('is--active');
                $(this).addClass('is--active');
            }
        });
    } catch (e) {
        console.error('Error populating form with autocomplete address:', e);
    }
}

function handleAddressAutocompleteKeydown(e) {
    if(!addressAutocomplete.isVisible) return;

    let $items = $('.address-autocomplete__item');
    let maxIndex = $items.length - 1;

    switch (e.keyCode) {
        case 40: // Down arrow
            e.preventDefault();
            addressAutocomplete.selectedIndex = Math.min(addressAutocomplete.selectedIndex + 1, maxIndex);
            updateAutocompleteSelection();
            break;
        case 38: // Up arrow
            e.preventDefault();
            addressAutocomplete.selectedIndex = Math.max(addressAutocomplete.selectedIndex - 1, -1);
            updateAutocompleteSelection();
            break;
        case 13: // Enter
            if(addressAutocomplete.selectedIndex >= 0) {
                e.preventDefault();
                selectAddressFromAutocomplete(addressAutocomplete.selectedIndex);
            }
            break;
        case 27: // Escape
            e.preventDefault();
            hideAddressAutocomplete();
            $('#address1Input').focus();
            break;
        case 9: // Tab - allow natural focus movement, close listbox
            hideAddressAutocomplete();
            break;
    }
}

function updateAutocompleteSelection() {
    let $items = $('.address-autocomplete__item');
    let $input = $('#address1Input');
    $items.removeClass('active').attr('aria-selected', 'false');
    if(addressAutocomplete.selectedIndex >= 0) {
        let $active = $items.eq(addressAutocomplete.selectedIndex);
        $active.addClass('active').attr('aria-selected', 'true');
        $input.attr('aria-activedescendant', $active.attr('id'));

        // Scroll active item into view within the container
        let container = $('#address-autocomplete-container')[0];
        let activeItem = $active[0];
        if(container && activeItem) {
            if(activeItem.offsetTop < container.scrollTop) {
                container.scrollTop = activeItem.offsetTop;
            } else if(activeItem.offsetTop + activeItem.offsetHeight > container.scrollTop + container.clientHeight) {
                container.scrollTop = activeItem.offsetTop + activeItem.offsetHeight - container.clientHeight;
            }
        }

        // Announce the active suggestion
        let label = $active.attr('aria-label') || $active.text();
        let position = addressAutocomplete.selectedIndex + 1;
        let total = $items.length;
        announceToScreenReader(label + ', ' + position + ' of ' + total);
    } else {
        $input.removeAttr('aria-activedescendant');
    }
}

function initAddressAutocomplete() {
    try {
        let $address1Input = $('#address1Input');

        if(!$address1Input.length) return;

        // Set ARIA attributes for combobox pattern
        $address1Input.attr({
            'role': 'combobox',
            'aria-autocomplete': 'list',
            'aria-expanded': 'false',
            'aria-owns': 'address-autocomplete-container',
            'aria-haspopup': 'listbox',
            'autocomplete': 'off'
        });
        $address1Input.removeAttr('aria-activedescendant');

        // Create live region for screen reader announcements if not present
        if(!$('#address-autocomplete-live-region').length) {
            $('body').append('<div id="address-autocomplete-live-region" class="sr-only" aria-live="assertive" aria-atomic="true" role="status"></div>');
        }

        // Pre-create container as a sibling after the input (inside .form-block which has position:relative)
        if(!$('#address-autocomplete-container').length) {
            $address1Input.after('<div id="address-autocomplete-container" class="address-autocomplete" role="listbox" aria-label="Address suggestions"></div>');
        }

        $address1Input.off('input.autocomplete keydown.autocomplete blur.autocomplete');
        $(document).off('click.autocomplete');
        $('#cityInput, #stateInput, #zipCodeInput').off('change.autocomplete');

        $address1Input.on('input.autocomplete', function() {
            try {
                let searchText = $(this).val().trim();

                if(addressAutocomplete.timeout) {
                    clearTimeout(addressAutocomplete.timeout);
                }

                addressAutocomplete.timeout = setTimeout(function() {
                    getAddressAutocomplete(searchText);
                }, addressAutocomplete.debounceMs);
            } catch (e) {
                console.error('Error in address input handler:', e);
            }
        });

        $address1Input.on('keydown.autocomplete', function(e) {
            try {
                handleAddressAutocompleteKeydown(e);
            } catch (err) {
                console.error('Error in keydown handler:', err);
            }
        });

        // Close listbox on blur (delayed to allow mousedown on items)
        $address1Input.on('blur.autocomplete', function() {
            setTimeout(function() {
                if(!$('#address-autocomplete-container').is(':hover')) {
                    hideAddressAutocomplete();
                }
            }, 200);
        });

        $(document).on('click.autocomplete', function(e) {
            try {
                if(!$(e.target).closest('#address1Input, #address-autocomplete-container').length) {
                    hideAddressAutocomplete();
                }
            } catch (err) {
                console.error('Error in click outside handler:', err);
            }
        });

        $('#cityInput, #stateInput, #zipCodeInput').on('change.autocomplete', function() {
            try {
                hideAddressAutocomplete();
            } catch (err) {
                console.error('Error in field change handler:', err);
            }
        });
    } catch (e) {
        console.error('Error initializing address autocomplete:', e);
    }
}

async function updateMelissaAddresses(data) {
    melissa.sameAddress = data.SameAddress;
    if(data.SameAddress) {
        updateSelectedAddress();
        updateFormWithSelectedAddress(melissa.selectedAddress);
        closeMelissaModal();
        hideMainErrorMessage();
        await getShippingOptions();
    } else if(data.MelissaAddresses && data.MelissaAddresses.length > 0) {
        let $addressList = $('.melissa-address-list');
        $('.melissa-address-list li:gt(0)').remove();
        melissa.addresses = data.MelissaAddresses;
        addMelissaAddressesToList($addressList);
        $addressList.data('preselectedidx', -1);
        $addressList.data('selected', true);
        melissa.status = 'selected';
        let $addressVerification = $('.isa-modal--address-verification input[name="addressVerification"]');
        $addressVerification.on('input', setSelectedAddress);
        let $firstMelissaOption = $('.isa-modal--address-verification input[name="addressVerification"]:eq(0)');
        $firstMelissaOption.prop('checked', 'checked');
        $firstMelissaOption.trigger('input');
        setMelissaVerificationType(2);
        // Show modal as non-dismissible (no close on backdrop click or ESC)
        $('#melissaModal').modal({
            backdrop: 'static',
            keyboard: false
        });
    }
}

function addMelissaAddressesToList($addressList) {
    // Remove the entered address temporarily (it's the first/only LI initially)
    let $enteredAddressLi = $addressList.find('li[data-melissaidx="-1"]').detach();

    // Add recommended addresses in order (they will appear first)
    melissa.addresses.forEach(function (item, index) {
        let current = index + 2;
        let addressForDisplay = `${item.FormattedAddress}`;
        let isFirst = index === 0;

        let addressRow = `
            <li class="melissa-modal-new__address-option">
                <input type="radio" name="addressVerification" id="addr${current}" value="addr${current}" data-melissaidx="${index}" class="form-input form-input--radio">
                <label for="addr${current}" class="form-label form-label--radio melissa-modal-new__address-wrapper">
                    <div class="melissa-modal-new__address-box ${isFirst ? 'melissa-modal-new__address-box--recommended' : ''}">
                        <div class="isa-modal__address melissa-modal-new__address-text" tabindex="0">${addressForDisplay}</div>
                    </div>
                </label>
            </li>`;

        // Append to list in order
        $addressList.append(addressRow);
    });

    // Append entered address at the end and show it
    $addressList.append($enteredAddressLi);
    $enteredAddressLi.show();

    // Show/hide subtitles based on recommended address count
    if(melissa.addresses.length === 1) {
        $('#subtitle-single').show();
        $('#subtitle-multiple').hide();
    } else {
        $('#subtitle-single').hide();
        $('#subtitle-multiple').show();
    }
}

function displayMelissaAddressError(result) {
    if(result && result.Messages) {
        let responseMsg = result.Messages[0];
        let msg = responseMsg.MessageText;
        melissa.status = responseMsg.Code;
        setMainErrorMessage(msg);
    }
}

function setSelectedAddress() {
    let $this = $(this);
    if (!!melissa.addresses) {//eslint-disable-line
        let idx = $this.data('melissaidx');
        let $addressList = $('.melissa-address-list');
        $addressList.data('preselectedidx', idx);
        $addressList.data('selected', true);
    }
}

function updateEnteredAddress() {
    melissa.enteredAddress.FirstName = $('#firstName').val();
    melissa.enteredAddress.LastName = $('#lastName').val();
    melissa.enteredAddress.Address1 = $('#address1Input').val();
    melissa.enteredAddress.Address2 = $('#address2Input').val();
    melissa.enteredAddress.Address3 = $('#address3Input').val();
    melissa.enteredAddress.Address4 = $('#address4Input').val();
    melissa.enteredAddress.City = $('#cityInput').val();
    melissa.enteredAddress.StateCode = $('#stateInput').val();
    if(!($('#stateInput').val())) {
        melissa.enteredAddress.StateCode = $('#selectedState').val();
    }
    var zipValue = $('#zipCodeInput').val();
    melissa.enteredAddress.ZipCode = zipValue ? zipValue.replace(/\s+$/, '') : zipValue;
    melissa.enteredAddress.CountryCode = $('#countryCode').val();
}

function updateFormWithSelectedAddress(address) {
    $('#firstName').val(address.FirstName).trigger('input');
    $('#lastName').val(address.LastName).trigger('input');

    // populate addresslines and dynamically add/remove as needed
    for (let ctr = 1; ctr <= 4; ctr++) {
        var addressValue = address[`Address${ctr}`];
        if(addressValue) {
            var isAddressLineExisting = $(`#address${ctr}Input`).length === 1;
            if(!isAddressLineExisting) {
                $(`#addAddress`).triggerHandler('click');
            }

            $(`#address${ctr}Input`).val(addressValue).trigger('input');
            $(`#loadAddress${ctr}`).val(addressValue);
        } else {
            // Clear the field value first (handles required fields like address1Input)
            $(`#address${ctr}Input`).val('').trigger('input');
            // Then trigger remove button for optional fields (if button exists)
            $(`#remove${ctr}`).trigger('click');
        }
    }

    $('#cityInput').val(address.City).trigger('input');
    $('#stateInput').val(address.StateCode).trigger('input');
    $('#zipCodeInput').val(address.ZipCode).trigger('input');
    if(address.AddressPhone) {
        $('#phone').val(address.AddressPhone).trigger('input');
    }
}

function updateEnteredAddressDefaultSelection(formattedAddress) {
    let $enteredAddress = $('.entered-address');
    let addressForDisplay = `${formattedAddress}`;
    $enteredAddress.html(addressForDisplay);
}

function updateSelectedAddress() {
    let $addressList = $('.melissa-address-list');
    setMelissaVerificationType(2);
    if($addressList.data('selected')) {
        let preSelectedIdx = $addressList.data('preselectedidx');
        if(typeof preSelectedIdx === 'number' && preSelectedIdx >= 0) {
            setMelissaVerificationType(1);
            let address = melissa.addresses[preSelectedIdx];
            melissa.selectedAddress.FirstName = $('#firstName').val();
            melissa.selectedAddress.LastName = $('#lastName').val();
            melissa.selectedAddress.Address1 = address.Address1;
            melissa.selectedAddress.Address2 = address.Address2;
            melissa.selectedAddress.Address3 = address.Address3;
            melissa.selectedAddress.Address4 = address.Address4;
            melissa.selectedAddress.City = address.City;
            melissa.selectedAddress.StateCode = address.StateCode;
            melissa.selectedAddress.ZipCode = address.ZipCode;
        } else {
            updateSelectedAddressWithEnteredAddress();
        }
    } else {
        updateSelectedAddressWithEnteredAddress();
    }
}

function updateSelectedAddressWithEnteredAddress() {
    melissa.selectedAddress.FirstName = melissa.enteredAddress.FirstName;
    melissa.selectedAddress.LastName = melissa.enteredAddress.LastName;
    melissa.selectedAddress.Address1 = melissa.enteredAddress.Address1;
    melissa.selectedAddress.Address2 = melissa.enteredAddress.Address2;
    melissa.selectedAddress.Address3 = melissa.enteredAddress.Address3;
    melissa.selectedAddress.Address4 = melissa.enteredAddress.Address4;
    melissa.selectedAddress.City = melissa.enteredAddress.City;
    melissa.selectedAddress.StateCode = melissa.enteredAddress.StateCode;
    melissa.selectedAddress.ZipCode = melissa.enteredAddress.ZipCode;
}

function loadSelectedAddress() {
    let $selectedAddress = $('#selectedShippingAddress');
    let address2 = $selectedAddress.data('address2') ? $selectedAddress.data('address2') : undefined;
    let address3 = $selectedAddress.data('address3') ? $selectedAddress.data('address3') : undefined;
    let address4 = $selectedAddress.data('address4') ? $selectedAddress.data('address4') : undefined;
    melissa.selectedAddress.FirstName = melissa.selectedAddress.FirstName ? melissa.selectedAddress.FirstName : $selectedAddress.data('firstname');
    melissa.selectedAddress.LastName = melissa.selectedAddress.LastName ? melissa.selectedAddress.LastName : $selectedAddress.data('lastname');
    melissa.selectedAddress.Address1 = melissa.selectedAddress.Address1 ? melissa.selectedAddress.Address1 : $selectedAddress.data('address1');
    melissa.selectedAddress.Address2 = melissa.selectedAddress.Address2 ? melissa.selectedAddress.Address2 : address2;
    melissa.selectedAddress.Address3 = melissa.selectedAddress.Address3 ? melissa.selectedAddress.Address3 : address3;
    melissa.selectedAddress.Address4 = melissa.selectedAddress.Address4 ? melissa.selectedAddress.Address4 : address4;
    melissa.selectedAddress.City = melissa.selectedAddress.City ? melissa.selectedAddress.City : $selectedAddress.data('city');
    melissa.selectedAddress.StateCode = melissa.selectedAddress.StateCode ? melissa.selectedAddress.StateCode : $selectedAddress.data('state');
    melissa.selectedAddress.ZipCode = melissa.selectedAddress.ZipCode ? melissa.selectedAddress.ZipCode : $selectedAddress.data('zip');
    melissa.selectedAddress.ZipCode = melissa.selectedAddress.ZipCode ? melissa.selectedAddress.ZipCode.toString() : melissa.selectedAddress.ZipCode;
}

function IsSameAddressFieldsAndSelectedAddress() {
    let address2 = $('#address2Input').val() ? $('#address2Input').val() : undefined;
    let address3 = $('#address3Input').val() ? $('#address3Input').val() : undefined;
    let address4 = $('#address4Input').val() ? $('#address4Input').val() : undefined;
    let selectedAddress2 = melissa.selectedAddress.Address2 ? melissa.selectedAddress.Address2 : undefined;
    let selectedAddress3 = melissa.selectedAddress.Address3 ? melissa.selectedAddress.Address3 : undefined;
    let selectedAddress4 = melissa.selectedAddress.Address4 ? melissa.selectedAddress.Address4 : undefined;
    let statecode = $('#stateInput').val();
    if(!($('#stateInput').val())) {
        statecode = $('#selectedState').val();
    }
    if(melissa.selectedAddress &&
        melissa.selectedAddress.FirstName === $('#firstName').val() &&
        melissa.selectedAddress.LastName === $('#lastName').val() &&
        melissa.selectedAddress.Address1 === $('#address1Input').val() &&
        selectedAddress2 === address2 &&
        selectedAddress3 === address3 &&
        selectedAddress4 === address4 &&
        melissa.selectedAddress.City === $('#cityInput').val() &&
        melissa.selectedAddress.StateCode === statecode &&
        melissa.selectedAddress.ZipCode === ($('#zipCodeInput').val() || '').replace(/\s+$/, '')) {
        return true;
    }
    return false;
}

function resetAddressVerification() {
    let $this = $(this);
    if($this.parents('.checkout__shipping-information').length > 0) {
        melissa.status = undefined;
        let $addressList = $('.melissa-address-list');
        $addressList.data('selected', false);
        $addressList.data('preselectedidx', -1);
    }
}

async function verifyShippingAddress() {
    let resumeSave = checkMelissaAddressVerification();
    if(!resumeSave) return;
    hideAddNewAddressValidationMessage();
    await getShippingOptions();
    // After melissa verification, trigger the parent form submit
    $('.checkout-next').trigger('click');
}

function checkMelissaAddressVerification() {
    if(!checkValidationShippingData()) return false;
    if(isMelissaAddressEnabled()) {
        let $addressList = $('.melissa-address-list');
        let selectedAddress = $addressList.data('selected');
        if(!selectedAddress || !melissa.status) {
            getMelissaAddresses();
            return false;
        } else {
            updateSelectedAddress();
            updateFormWithSelectedAddress(melissa.selectedAddress);
            closeMelissaModal();
        }
    } else {
        setMelissaVerificationType(0);
        updateEnteredAddress();
        updateSelectedAddressWithEnteredAddress();
        closeMelissaModal();
    }
    hideMainErrorMessage();
    return true;
}

function checkValidationShippingData() {
    let $form = $('form#shipping');
    return validateForm($form, getFullShippingValidationConfiguration());
}

function isMelissaAddressEnabled() {
    if(isMelissaAddressEnabledForUser) {
        let $addressList = $('.melissa-address-list');
        return $addressList.length > 0;
    }
}

function setMelissaVerificationType(id) {
    $('#melissaAddressVerificationType').val(id);
}

function clearModalFieldErrors() {
    let $errorSpan = $('div.is--error span.error');
    $errorSpan.css('display', 'none');
    $errorSpan.text('');
    $('div.is--error').removeClass('is--error');
}

function openingMelissaModal() {
    hideMainErrorMessage();
    clearModalFieldErrors();
    // keep in case of rollback changes or selection to previous form values
    // loadSelectedAddress();
    // updateFormWithSelectedAddress();
}

function closeMelissaModal() {
    hideMainErrorMessage();
    $('#melissaModal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
}

function triggerCloseMelissaModal() {
    checkValidationShippingData();
}

function refreshCart(data, section = '') {
    let $cart = $('.cart');
    let cartData = $cart.data('cart-details', data); // eslint-disable-line
    if(data.CouponPromotionDetails) {
        refreshCartTotals(data, section);
        refreshCouponPromotions(data.CouponPromotionDetails, section);
        if(section !== '') {
            section = section + 'Lines';
        }
        refreshCartLines(data, section);
    }
    updateCartMessage(data);
    // show error msg for cart total amount over threshold
    if(data.IsCartTotalOverMaxLimit) {
        $('.carttotalovermaxlimiterrormsg').removeClass('d-none');
        $('.place-order').prop('disabled', true);
    } else {
        $('.carttotalovermaxlimiterrormsg').addClass('d-none');
        $('.place-order').prop('disabled', false);
    }
}
function updateCartMessage(result) {
    // toast messages are displayed for Managed Autoship flow
    if(result && (result.IsManageAutoship || ($('#isManageAutoship').val() && $('#isManageAutoship').val().toLowerCase() === 'true'))) {
        if(result.IsSuccessful) {
            toast.Success(getToastMessage(result));
        } else {
            toast.Error(getToastMessage(result));
        }
    }

    if(result && result.CartMaxThreshold && result.CartMaxThreshold.IsCartMaximumThreshold) {
        $('.cart-max-threshold-error').text(result.CartMaxThreshold.CartMaximumThresholdError);
        $('#cart-max-td-error').removeClass('d-none');
        $('#paypal-button').addClass('d-none');
    } else {
        $('#cart-max-td-error').addClass('d-none');
        $('#paypal-button').removeClass('d-none');
    }
}
function refreshCartTotals(data, section = '') {
    let $cartTotal = $('.cart__total');
    let cartSidebarTotalItems = '.cart_sidebar_total_items';
    let $cartSidebarSubtotal = $('.cart-sidebar__subtotal');
    let $cartSidebarShipping = $('.cart-sidebar__shipping');
    let $cartSidebarTaxes = $('.cart-sidebar__taxes');
    let $cartSidebarAlternateTaxes = $('.cart-sidebar__alternate-taxes');
    let $cartSidebarEstTotal = $('.cart-sidebar__estimated-total');
    let $cartSidebarDiscounts = $('.cart-sidebar__discounts');
    let $cartSidebarBV = $('.cart-sidebar__bv');
    let $cartSidebarQV = $('.cart-sidebar__qv');
    let $cartSidebarPIB = $('.cart-sidebar__pib');
    let $headerCartItemCount = $('.header__cart-items');
    let pp4Msg = $('#ppMsg');
    let hdnPPAmount = $('#hdn-pp-amount');
    if(section !== '') {
        $cartTotal = $(`.${section} .cart__total`);
        cartSidebarTotalItems = '.cart_sidebar_total_items';
        $cartSidebarSubtotal = $(`.${section} .cart-sidebar__subtotal`);
        $cartSidebarShipping = $(`.${section} .cart-sidebar__shipping`);
        $cartSidebarTaxes = $(`.${section} .cart-sidebar__taxes`);
        $cartSidebarAlternateTaxes = $(`.${section} .cart-sidebar__alternate-taxes`);
        $cartSidebarEstTotal = $(`.${section} .cart-sidebar__estimated-total`);
        $cartSidebarDiscounts = $('.cart-sidebar__discounts');
        $cartSidebarBV = $(`.${section} .cart-sidebar__bv`);
        $cartSidebarQV = $(`.${section} .cart-sidebar__qv`);
        $cartSidebarPIB = ($(`.${section} .cart-sidebar__pib`).length > 0) ? $(`.${section} .cart-sidebar__pib`) : $cartSidebarPIB;
        $headerCartItemCount = $(`.${section} .header__cart-items`);
    }

    $cartTotal.text(data.CartLineDetails.TotalItems);

    $(`${cartSidebarTotalItems}`).text(data.CartLineDetails.TotalItems);
    $headerCartItemCount.text(data.CartLineDetails.TotalItems);
    announceCartUpdate(data.CartLineDetails.TotalItems);
    $cartSidebarSubtotal.text(data.CartTotals.CartSubTotalForDisplay);
    $cartSidebarShipping.text(data.CartTotals.ShippingAmountForDisplay);
    $cartSidebarTaxes.text(data.CartTotals.TaxesAmountForDisplay);
    if(data.CartTotals.HasAlternateTax) {
        $cartSidebarAlternateTaxes.text(data.CartTotals.AlternateTaxesAmountForDisplay);
    }
    $cartSidebarEstTotal.text(data.CartTotals.EstimatedTotalForDisplay);
    $cartSidebarDiscounts.text(data.CartTotals.DiscountsAndCouponsAmountForDisplay);
    $cartSidebarBV.text(data.CartTotals.BusinessVolumeForDisplay);
    if(data.CartTotals.DisplayQV) {
        $cartSidebarQV.text(data.CartTotals.QualifyingVolumeForDisplay);
    }
    $cartSidebarPIB.text(data.CartTotals.PIBForDisplay);

    if(pp4Msg) {
        pp4Msg.attr('data-pp-amount', data.CartTotals.EstimatedTotal);
    }

    if(hdnPPAmount) {
        hdnPPAmount.val(data.CartTotals.EstimatedTotal);
    }
}

function refreshCartLines(data, section = '') {
    let lineDetails = data.CartLineDetails;
    const isModernized = $('.checkout-v2').length > 0;
    let $cartProductList = $('.cart__productlist');
    if(isModernized) {
        $cartProductList = $('.mod-review__product-list');
    }
    if(section !== '') {
        $cartProductList = $(`.${section}`);
    }
    $cartProductList.empty();
    let hasProp65Products = false;
    const productLineTemplate = isModernized ? cartReviewProductLineModernized : cartReviewProductLine;
    let properties = {
        QuantityText: $cartProductList.data('quantitytext'),
        IsCalifornia: $cartProductList.data('iscalifornia').toLowerCase() === 'true',
        Prop65Image: $cartProductList.data('prop65url'),
        ShowBV: $cartProductList.data('showbv').toLowerCase() === 'true',
        NextOrderOnlyTooltipMsg: $cartProductList.data('nextorderonlytooltipmsg'),
        NextOrderOnlyLabel: $cartProductList.data('nextorderonlytex'),
        BVLabel: $cartProductList.data('bvlabel'),
        ShowMoreButtonText: $cartProductList.data('showmoretext'),
        ShowLessButtonText: $cartProductList.data('showlesstext')
    };
    lineDetails.CartLines.forEach(function (item) {
        let extendedItemData = Object.assign({}, properties, item);
        extendedItemData.ShowProp65Warning = extendedItemData.IsCalifornia && extendedItemData.IsProp65;
        hasProp65Products = hasProp65Products || extendedItemData.ShowProp65Warning;
        const extendedItem = { ...extendedItemData, ShowFreeGiftBadge: item.IsFreeGift && item.OriginalPricePerUnit >= 1, PromotionalGiftText: data.PromotionalGiftText };
        if(extendedItem.ProductsInPack && extendedItem.ProductsInPack.length > 0) {
            extendedItem.ProductsInPack.forEach(function (productInPack) {
                productInPack.ShowProp65Warning = productInPack.IsProp65 && extendedItem.IsCalifornia;
                hasProp65Products = hasProp65Products || productInPack.ShowProp65Warning;
            });
        }
        if(allFlowIsEnabled) {
            const $checkoutParentContainer = $('#checkout-parent-container');
            extendedItem.ShowMoreButtonText = $checkoutParentContainer.data('showmoretext') || extendedItem.ShowMoreButtonText;
            extendedItem.ShowLessButtonText = $checkoutParentContainer.data('showlesstext') || extendedItem.ShowLessButtonText;
            let productLineHtml = productLineTemplate(extendedItem);
            $cartProductList.append(productLineHtml);
            let $cartShowMore = $cartProductList.find('.cart__show-more');
            let $cartPack = $cartProductList.find('.cart__item-meta--pack, .mod-review__product-pack');
            handleShowMoreFunctionality($cartShowMore, $cartPack);
        } else {
            let productLineHtml = productLineTemplate(extendedItem);
            $cartProductList.append(productLineHtml);
        }
        let $dataToggleTooltip = $('[data-toggle="tooltip"]');
        if($dataToggleTooltip.length) {
            $dataToggleTooltip.tooltip();
        }
    });
    if(hasProp65Products) {
        $('.prop65-disclaimer').removeClass('d-none');
    } else {
        $('.prop65-disclaimer').addClass('d-none');
    }
}

function refreshCouponPromotions(couponPromotionDetails, section = '') {
    let promotionList = (couponPromotionDetails && couponPromotionDetails.CouponPromotionList) || [];
    const isModernized = !!$('.checkout-v2').length;
    let $promotionList;
    if(section !== '') {
        $promotionList = isModernized
            ? $(`.mod-coupon-list.promo${section}`)
            : $(`.promo${section}`);
    } else if(isModernized) {
        $promotionList = $('.mod-coupon-list:not(.promosubscription):not(.promotodays)');
    } else {
        $promotionList = $('.cart-coupon__list');
    }

    $promotionList.empty();
    let $promoTitle = $('.cart-coupon__badges-title');
    if(promotionList.length > 0) {
        promotionList.forEach(function (item, index) {
            let $outerSpan;
            if(isModernized) {
                $outerSpan = $('<span>', { class: `mod-coupon mod-coupon--applied coupon-badge ${section}` });
                $outerSpan.data('coupon', item.CouponCode || '');
                $outerSpan.data('promotion', item.PromotionId || '');
                $outerSpan.append('<i class="fal fa-tag mod-coupon__icon" aria-hidden="true"></i>');
                $outerSpan.append($('<span>', { class: 'mod-coupon__code' }).text(item.DisplayName));
                if(item.IsRemovable) {
                    $outerSpan.append(`<button type="button" class="mod-coupon__remove removable-coupon" aria-label="Remove coupon ${item.DisplayName}"><i class="fal fa-xmark" aria-hidden="true"></i></button>`);
                }
            } else {
                let $innerSpan = $('<span></span>').text(item.DisplayName);
                $outerSpan = $('<span>', { class: `coupon-badge badge ${section}` });
                if(item.CouponCode) {
                    $outerSpan.data('coupon', item.CouponCode);
                }
                if(item.PromotionId) {
                    $outerSpan.data('promotion', item.PromotionId);
                }
                $outerSpan.append($innerSpan);
                if(item.IsRemovable) {
                    let $closeBtn = $(`<button type="button" class="removable-coupon" aria-label="Remove promo code ${item.DisplayName}"></button>`);
                    $outerSpan.append($closeBtn);
                }
            }
            $promotionList.append($outerSpan);
        });
        $promoTitle.removeClass('d-none');
        $promoTitle.show();
    } else {
        $promoTitle.addClass('d-none');
        $promoTitle.hide();
    }
}

function showCouponInputForm() {
    let $couponInput = $('.cart-coupon__input');
    if($couponInput.length > 0) {
        $couponInput.removeClass('d-none');
        $('.cart-coupon__container').removeClass('d-none');
    }
}

function ShowCouponApplyFailedMessage(result, isFromModal, couponBox) {
    let $couponInput = $(couponBox);
    let errorText = $couponInput.data('coupon-apply-failed');

    if(isFromModal) {
        errorText = $('.apply_coupon_failed').data('error-message');
    }

    if(result && result.Messages) {
        let msg = result.Messages.find(msg => msg.DisplayMessage === true);
        if(msg && msg.MessageText) errorText = msg.MessageText;
    }

    updateCartMessage(result);

    if(errorText) {
        if(isFromModal) {
            $('.apply_coupon_failed').text(errorText);
            $('.apply_coupon_failed').show();
            announceAssertive(errorText);
            return;
        }

        $couponInput.parent().addClass('is--error');
        // Modernized coupon markup wraps the input in .mod-field; add mod-field--error so the field gets the red-border error state.
        $couponInput.closest('.mod-field').addClass('mod-field--error');
        let errorClassText = couponBox.substring(1, couponBox.length);
        $('#coupon-error.error').remove();
        let errorSpan = `<span id="coupon-error" class="error ${errorClassText}-error" role="alert" aria-live="assertive">${errorText}</span>`;
        if($couponInput.length > 0) {
            $couponInput.after(errorSpan);
        }
    }
}

async function applyCouponFromModal() {
    let $this = $(this);
    let couponSection = $this.closest('#couponsModal').data('coupon-section') || '';
    if($this && $this.val()) {
        // Clear any previous error messages
        let $errorMsg = $('.apply_coupon_failed');
        $errorMsg.hide();
        $errorMsg.text('');

        let appliedText = $this.data('applied-text');
        let applyText = $this.data('apply-text');
        let couponCode = $this.val();

        if($this.hasClass('button-apply--applied')) {
            let $promotionBadges = couponSection
                ? $(`.promo${couponSection} .coupon-badge`)
                : $('.cart-coupon__list .coupon-badge, .mod-coupon-list .coupon-badge');
            let promotion = $promotionBadges.filter(function() {
                return $(this).data('coupon') === couponCode;
            }).data('promotion');
            let result = await removeCouponPromotionFromCart({ PromotionId: promotion, CartType: couponSection }, couponSection);
            if(result && result.IsSuccessful) {
                $this.text(applyText);
                $this.removeClass('button-apply--applied');
                $(`.coupon_${couponCode}`).removeClass('list-card--applied');
            }
            return;
        }

        let result = await addCouponToCart({ CouponCode: couponCode, IsCouponFromModal: true, CartType: couponSection });
        if(result && result.IsSuccessful) {
            refreshCart(result, couponSection);
            updatePageUrls(result);
            ShowHidePaymentRequired(result);
            toggleSaveDiscardChanges(result);
            $this.text(appliedText);
            $this.addClass('button-apply--applied');
            $(`.coupon_${couponCode}`).addClass('list-card--applied');
            announcePolite(`Coupon ${couponCode} applied.`);
        } else {
            ShowCouponApplyFailedMessage(result, true, '#coupon');
        }
    }
}

function updatePageUrls(result) {
    let pageUrl;
    if(result.IsNoPaymentRequired) {
        let $shippingEditBtn = $('.shipping-edit-button');
        if($shippingEditBtn.length > 0) {
            pageUrl = $shippingEditBtn.data('pageurl');
        }
    } else {
        let $paymentEditBtn = $('.payment-edit-button');
        if($paymentEditBtn.length > 0) {
            pageUrl = $paymentEditBtn.data('pageurl');
        }
    }
    let $previousBtn = $('.checkout__prev');
    if($previousBtn.length > 0 && pageUrl) {
        $previousBtn.data('previousurl', pageUrl);
    }
}

function toggleSaveDiscardChanges(result) {
    let $checkoutSaveChanges = $('.checkout-savechanges');
    let $checkoutDiscardChanges = $('.checkout-discardchanges');
    if(result.IsCartDirty) {
        $checkoutSaveChanges.show();
        $checkoutDiscardChanges.show();
    }

    // show error msg for cart total amount over threshold
    if(result.IsCartTotalOverMaxLimit) {
        $('.save-recommended-cart-btn').prop('disabled', true);
        $('.cancel-recommended-cart-btn').prop('disabled', true);
    } else {
        $('.save-recommended-cart-btn').prop('disabled', false);
        $('.cancel-recommended-cart-btn').prop('disabled', false);
    }
}

function ShowHidePaymentRequired(result) {
    let hasPaymentData = false;

    if($('.checkout__review-list--cvv').length > 0 || $('.checkout__review-list--iban').length > 0 || $('.checkout__review-list--ideal').length > 0) {
        hasPaymentData = true;
    }

    let $paymentData = $('.paymentData');
    let $noPaymentRequired = $('.noPaymentRequired');
    let $addPaymentInfo = $('.addPaymentInfo');
    let $paymentEditBtn = $('.payment-edit-button');

    if(result.CurrentCart === SUBSCRIPTION_CART) {
        $paymentData = $('.paymentDataSubscription');
        $noPaymentRequired = $('.noPaymentRequiredSubscription');
        $addPaymentInfo = $('.addPaymentInfoSubscription');
    }
    if(result.IsNoPaymentRequired) {
        // No Payment Required
        if($paymentData.length > 0) {
            $paymentData.hide();
        }
        if($addPaymentInfo.length > 0) {
            $addPaymentInfo.hide();
        }
        if($noPaymentRequired.length > 0) {
            $noPaymentRequired.show();
        }
        if($paymentEditBtn.length > 0) {
            $paymentEditBtn.hide();
        }
    } else {
        // Payment Required
        if(hasPaymentData) {
            // payment data present
            if($paymentData.length > 0) {
                $paymentData.show();
            }
            if($addPaymentInfo.length > 0) {
                $addPaymentInfo.hide();
            }
            if($noPaymentRequired.length > 0) {
                $noPaymentRequired.hide();
            }
        } else {
            // payment data NOT present
            if($paymentData.length > 0) {
                $paymentData.hide();
            }
            if($addPaymentInfo.length > 0) {
                $addPaymentInfo.show();
            }
            if($noPaymentRequired.length > 0) {
                $noPaymentRequired.hide();
            }
        }
        if($paymentEditBtn.length > 0) {
            $paymentEditBtn.show();
        }
    }
}

async function setAvailableCouponPromotionModal() {
    showSpinner('Fetching available coupons and promotions');
    let response = await cartService.getAvailableCouponsPromotions();
    if(!response || !response.IsSuccessful) {
        hideSpinner('Fetching available coupons and promotions failed');
        return;
    }
    hideSpinner('Fetching available coupons and promotions completed');
    let availableCoupons = response.AvailableCoupons || [];

    let $couponContainer = $(this).closest('.cart-coupon');
    let $modalData = $couponContainer.find('.coupon-modal-data');
    let promoType = $modalData.data('promo-type') || '';
    let couponSection = promoType === 'promotodays'
        ? 'todays'
        : promoType === 'promosubscription' ? 'subscription' : '';
    let item = {
        IsInCartPage: Boolean($modalData.data('in-cart-page').toLowerCase()),
        PromoType: $modalData.data('promo-type'),
        CurrentMarket: $modalData.data('current-market'),
        CurrentCultureName: $modalData.data('culture-name'),
        ApplyCouponsTitleText: $modalData.data('modal-header'),
        ApplyCouponErrorMessage: $modalData.data('error-message'),
        ExpiresLabelText: $modalData.data('expiration-label-text'),
        CouponCodeLabelText: $modalData.data('coupon-code-label-text'),
        DetailsButtonText: $modalData.data('details-button-text'),
        AppliedButtonText: $modalData.data('applied-text'),
        ApplyButtonText: $modalData.data('apply-text'),
        CancelButtonText: $modalData.data('cancel-button'),
        DoneButtonText: $modalData.data('done-button'),
        NoCouponsTitle: $modalData.data('no-coupons-title'),
        NoCouponsMessage: $modalData.data('no-coupons-message'),
        AvailableCoupons: availableCoupons
    };
    let modalHTML = availableCouponsModal(item);
    let $modalContainer = $couponContainer.find('.coupon-modal-container');
    $modalContainer.html(modalHTML);
    let $couponsModal = $modalContainer.find('#couponsModal');
    $couponsModal.data('coupon-section', couponSection);
    let $applyCouponModalBtn = $couponsModal.find('.applyCouponButton');
    $applyCouponModalBtn.on('click', applyCouponFromModal);
    checkCouponsModal('.checkout');
    $couponsModal.data('modal-trigger', document.activeElement);
    $couponsModal.modal('show');
}

window.disableApplyButtonOnInvalidCouponCode = function ($id) {
    const button = $(`#${$id}`).closest(`.cart-coupon__input-container, .mod-coupon-row`).find(`.apply-${$id}-btn`);
    button.prop('disabled', true);
};

window.resetCouponInputField = function (id) {
    if(!id) return;

    const $element = $('#' + id);

    if(!$element.length) return;

    $element.removeClass('is--active');
};

window.enableDisableApplyCouponButton = function (e) {
    let $this = $(e.target);
    let value = $this.val();
    const couponRegex = /^[\w\W]{4,32}$/;

    function validateCouponFieldValue(value) {
        return value.length >= 4 && value.length <= 32 && couponRegex.test(value);
    }

    let id = $this.attr('id');
    const button = $this.closest(`.cart-coupon__input-container, .mod-coupon-row`).find(`.apply-${id}-btn`);
    const isValidInput = validateCouponFieldValue(value);
    button.prop('disabled', !isValidInput);
    if(value === '' || isValidInput) {
        $this.parent().removeClass('is--error');
        $this.closest('.mod-field').removeClass('mod-field--error');
        $this.parent().find('.error').remove();
        $this.removeAttr('aria-invalid');
    }

    if(value === '') {
        $this.removeClass('is--active');
    }
};

async function applyCoupon(e) {
    e.preventDefault();
    let $couponInput = $('#coupon');
    const coupon = $couponInput.val();

    if(window.validateCoupon($('#coupon'))) {
        let result = await addCouponToCart({ CouponCode: coupon });
        if(result && result.IsSuccessful) {
            refreshCart(result);
            updatePageUrls(result);
            ShowHidePaymentRequired(result);
            toggleSaveDiscardChanges(result);
            clearCouponFieldOnSuccess($(this));
            window.resetCouponInputField('coupon');
        } else {
            ShowCouponApplyFailedMessage(result, false, '#coupon');
        }
        window.disableApplyButtonOnInvalidCouponCode('coupon');
    }
}

async function applyCouponToday() {
    const couponToday = $('#couponToday').val();
    if(window.validateCoupon($('#couponToday'))) {
        let result = await addCouponToCart({ CouponCode: couponToday, CartType: 'todays' });
        if(result && result.IsSuccessful) {
            refreshCart(result, 'todays');
            updatePageUrls(result);
            ShowHidePaymentRequired(result);
            toggleSaveDiscardChanges(result);
            clearCouponFieldOnSuccess($(this));
            window.resetCouponInputField('couponToday');
        } else {
            ShowCouponApplyFailedMessage(result, false, '#couponToday');
        }
        window.disableApplyButtonOnInvalidCouponCode('couponToday');
    }
}

async function applyCouponSubscription() {
    const couponSubscription = $('#couponSubscription').val();

    if(window.validateCoupon($('#couponSubscription'))) {
        let result = await addCouponToCart({ CouponSubscriptionCode: couponSubscription, CartType: 'subscription' });
        if(result && result.IsSuccessful) {
            refreshCart(result, 'subscription');
            updatePageUrls(result);
            ShowHidePaymentRequired(result);
            toggleSaveDiscardChanges(result);
            clearCouponFieldOnSuccess($(this));
            window.resetCouponInputField('couponSubscription');
        } else {
            ShowCouponApplyFailedMessage(result, false, '#couponSubscription');
            $('.modal-backdrop').hide();
        }
        window.disableApplyButtonOnInvalidCouponCode('couponSubscription');
    }
}

window.validateCoupon = function ($element) {
    const coupon = $element.val();
    const $couponParent = $element.parent();
    const $modField = $element.closest('.mod-field');
    $couponParent.find('#coupon-error').remove();

    if(!coupon) {
        $couponParent.addClass('is--error');
        // Modernized coupon markup wraps the input in .mod-field; add mod-field--error so the field gets the red-border error state.
        $modField.addClass('mod-field--error');

        const errorMessage =
            '<span id="coupon-error" class="error">' +
            $element.attr('data-msg-required') +
            '</span>';

        $couponParent.append(errorMessage);
        return false;
    }

    $couponParent.removeClass('is--error');
    $modField.removeClass('mod-field--error');
    return true;
};

function clearCouponPromotion(e) {
    e.preventDefault();
    e.stopPropagation();
    let $this = $(this);
    let section = '';
    if($(this).closest('.promosubscription').length > 0) {
        section = 'subscription';
    }
    if($(this).closest('.promotodays').length > 0) {
        section = 'todays';
    }
    const promotion = $this.parent().data('promotion');
    removeCoupon.call(this);

    removeCouponPromotionFromCart({ PromotionId: promotion, CartType: section }, section);
}

async function addCouponToCart(request) {
    try {
        hideMainErrorMessage();
        showSpinner('Adding coupon to cart started');
        const result = await cartService.addCouponToCart(request);
        hideSpinner('Adding coupon to cart completed');
        return result;
    } catch (e) {
        console.error(e);
        hideSpinner('Adding coupon to cart failed');
    }
}

async function removeCouponPromotionFromCart(request, section = '') {
    try {
        hideMainErrorMessage();
        showSpinner('Removing coupon from cart started');
        const result = await cartService.removeCouponPromotionFromCart(request);

        if(result && result.IsSuccessful) {
            refreshCart(result, section);
            updatePageUrls(result);
            ShowHidePaymentRequired(result);
            toggleSaveDiscardChanges(result);
            hideSpinner('Removing coupon from cart completed');
        } else {
            submitFailedCallback(result);
            hideSpinner('Removing coupon from cart failed');
        }
        return result;
    } catch (e) {
        console.error(e);
        hideSpinner('Removing coupon from cart failed');
    }
}

function changePaymentMethod() {
    clearCreditCard();
    hidePaymetricInlineSection();
    clearPaypalData();
    clearVenmoData();
    clearSepaData(false);
    clearBancontact();
    clearIdealData();
    clearIsaWallet();
    clearAndHideCVV();
    hideAddressError();
    $('.form-block--change-payment').hide();
    if(!$('#savedPayment').length) {
        $('.checkout__payment-block').hide();
    } else {
        $('.payment-selected').hide();
        $('.cash-payment-selected').hide();
        $('.checkout_saved_payments').show();
        $('.checkout_saved_payments_label').show();
        $('.mod-saved-payments').show();
    }
    $('#cardPassed').parent('.checkout__payment-block').show();
    // When the card-selection grid is present, show it instead of raw provider buttons
    if($('.mod-payment-method-card').length > 0) {
        $('.mod-payment-selection').show();
        $('.mod-payment-method-card').removeClass('is--selected').attr('aria-pressed', 'false');
    } else {
        $('.payment__providers').show();
    }
    $('.checkout_save_payment').hide();
    if($('.checkout-v2').length) {
        // hiding the checkbox doesn't clear its checked state - reset it so a stale "checked"
        // from a prior payment method doesn't silently carry over and save the next one without
        // consent (modernized-only, legacy is left untouched)
        $('#saveCc').prop('checked', false);
        $('#savePayment').prop('checked', false);
    }
    $('#divBillingAddress, .mod-billing-address__divider, #divBillingAddressSecurity').addClass('d-none').hide();
    $('#savedBillingInformation').addClass('d-none').hide();
    toggleSubscriptionOrderFormBlock('hide');
    // Back to the "browse saved payments / choose a payment type" state - nothing is
    // selected anymore, so the link that got here has no further action to perform.
    $('.mod-payment-selection__change-wrap').hide();
    updatePaymentContinueButtonVisibility();
}

function hideAddressError() {
    $('#addressError').hide();
}

function showShippingInfo() {
    $('.checkout__shipping-info-current').hide();
    $('.checkout__shipping-info-manual').hide();
    $('.checkout__saved-addresses').show();
}

// Design shows phone above the "save new address" checkbox; the checkbox markup is shared with
// the legacy address partials, so we move phone client-side instead of editing those partials.
function repositionPhoneAboveSaveAddressCheckbox() {
    if(!$('.checkout-v2').length) return;
    let $phoneGroup = $('#shippingPhoneGroup');
    if(!$phoneGroup.length) return;

    // Wholesale/Subscription: pin the field directly below the read-only saved-address card,
    // above the Change Address dropdown, instead of its default after-manual-form position.
    if($phoneGroup.attr('data-relocate-with-savedaddress') === 'true') {
        moveSavedAddressPhoneToAddressCard();
        return;
    }

    let $manualAddress = $('.checkout__shipping-info-manual').first();
    if($manualAddress.length && $('.checkout__enrollment-address-card').length) {
        $phoneGroup.insertAfter($manualAddress);
        return;
    }
    let $checkboxContainer = $('#saveShippingAddress').closest('.form-group, .mod-form-group--save-new-address');
    if($checkboxContainer.length) {
        $checkboxContainer.before($phoneGroup);
    }
}

// Moves the shared phone field to sit directly below the read-only saved-address card (above
// the Change Address dropdown). Excludes the enrollment address card, which has its own flow.
function moveSavedAddressPhoneToAddressCard() {
    let $phoneGroup = $('#shippingPhoneGroup');
    let $card = $('.checkout__shipping-info-current:not(.checkout__enrollment-address-card) .mod-checkout__address-card').first();
    if($phoneGroup.length && $card.length) {
        $phoneGroup.insertAfter($card);
    }
}

// Moves the shared phone field into the manual address form (above the "save new address"
// checkbox, matching the standard flow), so it stays visible even while
// .checkout__shipping-info-current (its usual neighbor) is hidden during manual entry.
function moveSavedAddressPhoneToManualEntry() {
    let $phoneGroup = $('#shippingPhoneGroup');
    if($phoneGroup.attr('data-relocate-with-savedaddress') !== 'true') return;
    if(!$phoneGroup.length) return;

    let $checkboxContainer = $('#saveShippingAddress').closest('.form-group, .mod-form-group--save-new-address');
    if($checkboxContainer.length) {
        $checkboxContainer.before($phoneGroup);
        $phoneGroup.show();
        return;
    }
    let $manualAddress = $('.checkout__shipping-info-manual').first();
    if($manualAddress.length) {
        $phoneGroup.insertAfter($manualAddress);
        $phoneGroup.show();
    }
}

// Wholesale/Subscription: true only when the saved-address phone field (visible below the
// read-only card) is the sole invalid field, so Continue can keep the card view instead of
// falling back to the full manual entry form.
function isOnlyPhoneInvalidForSavedAddress($form) {
    let $phoneGroup = $('#shippingPhoneGroup');
    if($phoneGroup.attr('data-relocate-with-savedaddress') !== 'true' || !$phoneGroup.is(':visible')) return false;
    let validator = $form.data('validator');
    if(!validator) return false;
    let invalidElements = validator.invalidElements();
    return invalidElements.length === 1 && invalidElements[0].id === 'phone';
}

async function handleSavedAddressChange() {
    var $this = $(this);
    if($this.val() === '-1') {
        isMelissaAddressEnabledForUser = true;
        let isSavedAddress = isExistsInSavedAddresses();
        if(isSavedAddress) {
            let addressObject = initAddressObject();
            updateFormWithSelectedAddress(addressObject);
        } else {
            // Always clear all address fields when "Add new address" is selected
            $('#firstName').val('').trigger('input');
            $('#lastName').val('').trigger('input');
            $('#address1Input').val('').trigger('input');
            $('#cityInput').val('').trigger('input');
            let $stateInput = $('#stateInput');
            let selectedState = $('#selectedState').val();
            let stateValue = $('.checkout-v2').length && $stateInput.prop('disabled') && selectedState && selectedState !== 'default'
                ? selectedState
                : 'default';
            $stateInput.val(stateValue).trigger('change');
            $('#selectedState').val(stateValue);
            $('#zipCodeInput').val('').trigger('input');
            $('#phone').val('').trigger('input');

            if($('.checkout-v2').length) {
                clearShippingOptions(true);
            }

            // Remove any additional address lines (2, 3, 4) if they exist
            $('#remove2, #remove3, #remove4').each(function () {
                if($(this).length) {
                    $(this).trigger('click');
                }
            });
        }
        // Modernized markup keeps the current-address card/dropdown visible alongside the manual form; legacy markup already hides it via showShippingInfo().
        $('.checkout-v2 .checkout__shipping-info-current').hide();
        $('.checkout-v2 .checkout__saved-addresses').hide();
        $('.checkout__shipping-info-manual').show();
        moveSavedAddressPhoneToManualEntry();
        // Neither visible dropdown has a "-1" option, so reset them to the "Choose..." placeholder.
        $('.mod-checkout__change-address-select').val('default');
    } else {
        // disable melissa for saved Address change.
        isMelissaAddressEnabledForUser = false;

        $('.checkout__shipping-info-manual').hide();
        let currentAddressIndex = $this.val();
        if(!currentAddressIndex) {
            currentAddressIndex = 0;
        }
        let currentAddress = savedAddresses[currentAddressIndex];
        updateCurrentAddress(currentAddress);
        let address = getCurrentAddressObject(currentAddress); //eslint-disable-line
        updateFormWithSelectedAddress(address);
        await getShippingOptions();
        $('.checkout__saved-addresses').hide();
        $('.checkout__shipping-info-current').show();
        moveSavedAddressPhoneToAddressCard();
    }
}

function handleSavedPaymentChange(e) {
    e.preventDefault();
    var selectedPaymentDisplayText = $('.dd-selected-text').text();
    var selectedPaymentId = $('.dd-selected-value').val();
    let originalPaymentId = $('#paymentHandleId').val();
    let isManageAutoship = $('#isManageAutoship').val();
    var savedPaymentsData = $('.checkout_saved_payments').data('saved-payments') || [];

    if(selectedPaymentId === 'default') {
        return;
    }

    if(isManageAutoship && isManageAutoship.toLowerCase() === 'true') {
        let $nextBtn = $('.checkout-next');
        if(originalPaymentId !== selectedPaymentId) {
            paymentFormDirty();
            $('#hidden-show-3ds').val('false');
            $('#paymentChanged').val('true');
        } else {
            $nextBtn.text($nextBtn.data('nexttext'));
            $('#hidden-show-3ds').val('false');
            $('#paymentChanged').val('false');
        }
    }

    // disable save for future
    $('#saveCc').prop('checked', false);
    $('#savePayment').prop('checked', false);

    // credit card
    if($('.dd-selected-image').length && !$('.dd-selected-image').prop('src').includes('paypal') && !$('.dd-selected-image').prop('src').includes('venmo') && !$('.dd-selected-image').prop('src').includes('sepa') && !$('.dd-selected-image').prop('src').includes('ideal')) {
        $('#paypalNonce').val('');
        $('#paypalEmail').val('');
        $('#selectedIdealId').val('');
        $('#sepaName').val('');
        $('#iban').val('');
        $('#selectedSepaId').val('');
        clearVenmoData();
        clearIsaWallet();
        var selectedPaymentLogoSrc = $('.dd-selected-image').prop('src');
        var selectedPaymentFullExpriy = $('.dd-selected-description').text().replace('(', '').replace(')', '');
        var selectedPaymentExpiryMonth = selectedPaymentFullExpriy.split('/')[0];
        var selectedPaymentExpiryYear = selectedPaymentFullExpriy.split('/')[1];
        let result = {
            ExpirationMonth: selectedPaymentExpiryMonth,
            ExpirationYear: selectedPaymentExpiryYear,
            CardType: selectedPaymentLogoSrc,
            CardLastDigits: selectedPaymentDisplayText
        };
        let expirationLabel = $('#paymetricdata').data('cardexpiration');
        $('#creditCardPayment').val(true);
        $('#cardPassed').val(true);
        $('#savedCCId').val(selectedPaymentId);
        validatePaymentDetailsElement('#cardPassed', getPaymentValidationConfiguration());
        let selectedPaymentData = savedPaymentsData.find(i => i.PaymentId === Number(selectedPaymentId));
        setCardInfo(result, expirationLabel, false, selectedPaymentData);
        clearAndHideCVV();
        clearCashAndDebitCard();
        showPaymentMethod('payment-cc');
        $(FORM_PAYMENT).data('payment-type', PAYMENT_METHOD_CC);
        $('#securityOnlineMessage').show();
        $('#securityOnlineMessage').removeClass('d-none');
        $('#divBillingAddress').removeClass('d-none').show();
        $('.mod-billing-address__divider').addClass('d-none').hide();
        $('#divBillingAddressSecurity').removeClass('d-none').show();
        $('#savedBillingInformation').removeClass('d-none').show();
    } else if($('.dd-selected-image').length && $('.dd-selected-image').prop('src').includes('paypal')) {
        // paypal
        $('#savedCCId').val('');
        $('#sepaName').val('');
        $('#selectedSepaId').val('');
        $('#iban').val('');
        $('#selectedIdealId').val('');
        var selectedPaypalNonce = $(`#savedPaypalNonce_${selectedPaymentId}`).val();
        var paypalEmail = $(`#savedPaypalEmail_${selectedPaymentId}`).val();
        $('#paypalAuth').val(true);
        $('#paypalNonce').val(selectedPaypalNonce);
        $('#paypalEmail').val(paypalEmail);
        $('.paypal-masked-address').text(selectedPaymentDisplayText);
        $('.payment__providers').hide();
        $('.payment-cc').addClass('d-none');
        $('.form-block--sepa-info').addClass('d-none');
        $('.form-block--saved-sepa-info').addClass('d-none').hide();
        $('.form-block--bancontact-info').addClass('d-none');
        clearVenmoData();
        clearIsaWallet();
        clearBancontact();
        clearIdealData();
        clearCashAndDebitCard();
        $('.form-block--paypal-info').removeClass('d-none').show();
        $('.form-block--change-payment').show();
        // Modernized-only reveal (self-guarded, no-op on legacy) - legacy's own reveal above
        // (.form-block--paypal-info) already handles the legacy markup correctly.
        revealPaypalSummaryModernized();
        $('.checkout_saved_payments').hide();
        $('.checkout_saved_payments_label').hide();
        $('.mod-saved-payments').hide();
        $(FORM_PAYMENT).data('payment-type', PAYMENT_METHOD_PAYPAL);
        $('#savedBillingInformation').hide();
        let valid = validatePaymentDetailsElement('#paypalAuth', getPaypalPaymentValidationConfiguration());
        if(valid) {
            hidePaypalInformationMessage();
        } else {
            showPaypalInformationAsValidationMessage();
        }
    } else if($('.dd-selected-image').length && $('.dd-selected-image').prop('src').includes('venmo')) {
        // venmo
        $('#paypalAuth').val(false);
        $('#paypalNonce').val('');
        $('#paypalEmail').val('');
        $('#savedCCId').val('');
        $('#sepaName').val('');
        $('#selectedSepaId').val('');
        $('#iban').val('');
        $('#selectedIdealId').val('');
        var selectedVenmoNonce = $(`#savedVenmoNonce_${selectedPaymentId}`).val();
        var venmoUsername = $(`#savedVenmoUsername_${selectedPaymentId}`).val();
        var venmoEmail = $(`#savedVenmoEmail_${selectedPaymentId}`).val();
        $('#venmoAuth').val(true);
        $('#venmoNonce').val(selectedVenmoNonce);
        $('#venmoEmail').val(venmoEmail);
        $('#venmoUsername').val(venmoUsername);
        $('.venmo-username').text(selectedPaymentDisplayText);
        $('.payment__providers').hide();
        $('.payment-cc').addClass('d-none');
        $('.form-block--sepa-info').addClass('d-none');
        $('.form-block--saved-sepa-info').addClass('d-none').hide();
        $('.form-block--bancontact-info').addClass('d-none');
        clearPaypalData();
        clearIsaWallet();
        clearBancontact();
        clearIdealData();
        clearCashAndDebitCard();
        $('.form-block--venmo-info').removeClass('d-none').show();
        $('.form-block--change-payment').show();
        // Modernized-only reveal (self-guarded, no-op on legacy) - legacy's own reveal above
        // (.form-block--venmo-info) already handles the legacy markup correctly.
        revealVenmoSummaryModernized();
        $('.checkout_saved_payments').hide();
        $('.checkout_saved_payments_label').hide();
        $('.mod-saved-payments').hide();
        $(FORM_PAYMENT).data('payment-type', PAYMENT_METHOD_VENMO);
        $('#savedBillingInformation').hide();
        let valid = validatePaymentDetailsElement('#venmoAuth', getVenmoPaymentValidationConfiguration());
        if(valid) {
            hideVenmoInformationMessage();
        } else {
            showVenmoInformationAsValidationMessage();
        }
    } else if($('.dd-selected-image').length && $('.dd-selected-image').prop('src').includes('sepa')) {
        // SEPA
        $('#paypalNonce').val('');
        $('#paypalEmail').val('');
        $('#selectedSepaId').val(selectedPaymentId);
        $('#selectedIdealId').val('');
        $('#savedCCId').val('');
        $('.payment__providers').hide();
        $('.payment-cc').addClass('d-none');
        $('.form-block--bancontact-info').addClass('d-none');
        clearIsaWallet();
        clearBancontact();
        clearIdealData();
        clearCashAndDebitCard();
        $('#divBillingAddress').removeClass('d-none').show();
        $('.mod-billing-address__divider').addClass('d-none').hide();
        $('#divBillingAddressSecurity').removeClass('d-none').show();
        $('#savedBillingInformation').removeClass('d-none').show();
        $('.form-block--sepa-info').addClass('d-none');
        $('.form-block--saved-sepa-info').removeClass('d-none').show();
        $('.form-block--change-payment').show();
        if($('.mod-payment-method-card').length > 0) {
            $('.mod-payment-selection').hide();
        }
        if($('#savedPayment').length) {
            $('.checkout_saved_payments').hide();
            $('.checkout_saved_payments_label').hide();
            $('.mod-saved-payments').hide();
        }
        let sepaName = $(`#savedSepaName_${selectedPaymentId}`).val();
        let maskedIban = $(`#savedSepaMaskedIban_${selectedPaymentId}`).val();
        let iban = $(`#savedSepaIban_${selectedPaymentId}`).val();
        $('#savedSepaName').text(sepaName);
        $('#savedSepaIban').text(maskedIban);
        $('#sepaName').val(sepaName);
        $('#iban').val(iban);
        $('#sepaNameHdn').val('true');
        $(FORM_PAYMENT).data('payment-type', PAYMENT_METHOD_SEPA);
    } else if(selectedPaymentDisplayText.length && selectedPaymentDisplayText.toLowerCase() === ISAWALLET) {
        $('#savedCCId').val('');
        $('#sepaName').val('');
        $('#selectedSepaId').val('');
        $('#iban').val('');
        $('#paypalNonce').val('');
        $('#paypalEmail').val('');
        $('#selectedIdealId').val('');

        $('.payment__providers').hide();
        $('.payment-cc').addClass('d-none');
        $('.form-block--bancontact-info').addClass('d-none');
        clearBancontact();
        clearIdealData();
        clearCashAndDebitCard();
        $('#divBillingAddress, .mod-billing-address__divider, #divBillingAddressSecurity').hide();
        $('#savedBillingInformation').hide();
        $('.form-block--sepa-info').addClass('d-none');
        $('.form-block--saved-sepa-info').addClass('d-none').hide();
        $('.form-block--change-payment').show();
        if($('.mod-payment-method-card').length > 0) {
            $('.mod-payment-selection').hide();
        }
        if($('#savedPayment').length) {
            $('.checkout_saved_payments').hide();
            $('.checkout_saved_payments_label').hide();
            $('.mod-saved-payments').hide();
        }

        $('#isIsawallet').val('true');
        $('.form-block--isawllet-info').removeClass('d-none').show();
        $('#selectedIsawalletId').val(selectedPaymentId);
        $(FORM_PAYMENT).data('payment-type', ISAWALLET);
    } else if($('.dd-selected-image').prop('src').includes('ideal')) {
        // IDEAL
        $('#paypalNonce').val('');
        $('#paypalEmail').val('');
        $('#sepaName').val('');
        $('#selectedSepaId').val('');
        $('#iban').val('');
        $('#selectedIdealId').val(selectedPaymentId);
        $('#savedCCId').val('');
        $('.payment__providers').hide();
        $('.payment-cc').addClass('d-none');
        $('.form-block--bancontact-info').addClass('d-none');
        clearIsaWallet();
        clearBancontact();
        clearCashAndDebitCard();
        $('#divBillingAddress').removeClass('d-none').show();
        $('.mod-billing-address__divider').addClass('d-none').hide();
        $('#divBillingAddressSecurity').removeClass('d-none').show();
        $('#savedBillingInformation').removeClass('d-none').show();
        $('.form-block--sepa-info').addClass('d-none');
        $('.form-block--saved-sepa-info').addClass('d-none').hide();
        $('.form-block--ideal-info').addClass('d-none');
        $('.form-block--saved-ideal-info').removeClass('d-none').show();
        $('.form-block--change-payment').show();
        if($('.mod-payment-method-card').length > 0) {
            $('.mod-payment-selection').hide();
        }
        if($('#savedPayment').length) {
            $('.checkout_saved_payments').hide();
            $('.checkout_saved_payments_label').hide();
            $('.mod-saved-payments').hide();
        }
        $(FORM_PAYMENT).data('payment-type', IDEAL);
    }
    $('.checkout_save_payment').hide();
    if(savedPaymentsData.length > 0) {
        isSavedBillingInformation = true;
        let selectedPayment = savedPaymentsData.filter(i => i.PaymentId === parseInt(selectedPaymentId));
        if(selectedPayment.length > 0) {
            selectedPayment = selectedPayment[0];
            updateCurrentAddress(selectedPayment.BillingAddress);
            let address = getCurrentAddressObject(selectedPayment.BillingAddress); //eslint-disable-line
            updateFormWithSelectedAddress(address);

            // to be used later
            updateCurrentBillingAddress(selectedPayment.billingAddress);

            if(selectedPayment.CardType.toLowerCase() !== 'paypalec' && selectedPayment.CardType.toLowerCase() !== 'paypal' && selectedPayment.CardType.toLowerCase() !== 'venmo') {
                $('#savedBillingInformation').show();
            } else {
                let address = getCurrentAddressObject(selectedPayment.BillingAddress);

                if(selectedPayment.CardType.toLowerCase() === 'venmo') {
                    updateWithSavedVenmoData(address);
                } else {
                    updateWithSavedPaypalData(address);
                }
            }
            $('.checkout__payment-block').show();
            $('.form-block--cash-info').addClass('d-none').hide();
            $('.form-block--debitcard-info').addClass('d-none').hide();

            $(SHIPPING_INFO).hide();
            $('#useShippingAddress').prop('checked', false);
            // For a saved payment method, the billing address is fixed to the card and must
            // not be editable, so the "Use shipping address" checkbox must always stay hidden.
            $('#useShippingAddressLabel').parent().parent().addClass('d-none');
            if($('#billingInformation').length) {
                let isPickupDelivery = $('#billingInformation').data('is-pick-up') === 'True';
                if(isPickupDelivery) {
                    $('#billingInformation').hide();
                    $('#savedBillingInformation').show();
                }
            }
            $('#billingInformation').hide();
        }
    }
    // A saved payment method is now selected client-side (before any page reload) -
    // reveal the "Change Payment Method" link for every saved-payment-type branch above
    // (CC/PayPal/Venmo/SEPA/IsaWallet/iDEAL), mirroring showPaymentMethod()'s equivalent reveal.
    $('.mod-payment-selection__change-wrap').show();
}

function updateCurrentBillingAddress(address) {
    if(!address) return;
    var $currentBillingAddressE = $('.current-address-details2');
    $currentBillingAddressE.text('');

    let addressMain = `<strong>${address.AddressName}</strong><br/>${address.AddressLine1}`;
    if(address.AddressLine2) {
        addressMain += `<br/>${address.AddressLine2}`;
    }
    addressMain += `&nbsp;`;
    if(address.AddressLine3) {
        addressMain += `<br/>${address.AddressLine3}`;
    }
    if(address.AddressLine4) {
        addressMain += `<br/>${address.AddressLine4}`;
    }
    if(address.CountryCode.toLowerCase() !== 'bg') {
        addressMain += `<br/>${address.City}, ${address.State}, ${address.PostalCode}`;
    } else {
        addressMain += `<br/>${address.PostalCode} ${address.City}<br/>${address.CountryCode}`;
        if(address.AddressPhone) {
            addressMain += `<br/>${address.AddressPhone}`;
        }
    }

    $currentBillingAddressE.append(addressMain);
}

function isRequireddAddressLine(addressLine) {
    let requiredAddressLines = $('#requiredAddressLines').val();
    if(!requiredAddressLines) return false;

    if(requiredAddressLines.indexOf(addressLine) >= 0) {
        return true;
    }
    return false;
}

function isPickupOptionSelectionRequired() {
    let $requirePickupOption = $('#requirePickupOption');
    if(!$requirePickupOption || $requirePickupOption.length === 0) return false;

    return ($requirePickupOption.val() === 'true');
}

function isExistsInSavedAddresses() {
    let result = false;
    let state = '';
    if($('#stateInput').val()) {
        state = $('#stateInput').val().toUpperCase();
    } else if($('#selectedState').val()) {
        state = $('#selectedState').val().toUpperCase();
    }
    savedAddresses.forEach((address) => {
        if(address.AddressLine1.toUpperCase() === $('#address1Input').val().toUpperCase() &&
            address.City.toUpperCase() === $('#cityInput').val().toUpperCase() &&
            address.State.toUpperCase() === state &&
            address.PostalCode.toUpperCase() === ($('#zipCodeInput').val() || '').replace(/\s+$/, '').toUpperCase()) {
            result = true;
        }
    });
    return result;
}

function updateCurrentAddress(address) {
    if(!address) return;

    var $strong = $('<strong></strong');
    $strong.text(address.AddressName);
    $('.current-addressdetails-name').html($strong);
    $('.current-addressdetails-address1').text(address.AddressLine1);
    if(address.AddressLine2.length > 0) {
        let $currentAddressLine2 = $('.currentAddressDetailsLine2');
        $currentAddressLine2.show();
        $('.current-addressdetails-address2').text(address.AddressLine2);
    } else {
        let $currentAddressLine2 = $('.currentAddressDetailsLine2');
        $currentAddressLine2.hide();
        $('.current-addressdetails-address2').text('');
    }

    if(address.AddressLine3.length > 0) {
        let $currentAddressLine3 = $('.currentAddressDetailsLine3');
        $currentAddressLine3.show();
        $('.current-addressdetails-address3').text(address.AddressLine3);
    } else {
        let $currentAddressLine3 = $('.currentAddressDetailsLine3');
        $currentAddressLine3.hide();
        $('.current-addressdetails-address3').text('');
    }

    if(address.AddressLine4.length > 0) {
        let $currentAddressLine4 = $('.currentAddressDetailsLine4');
        $currentAddressLine4.show();
        $('.current-addressdetails-address4').text(address.AddressLine4);
    } else {
        let $currentAddressLine4 = $('.currentAddressDetailsLine4');
        $currentAddressLine4.hide();
        $('.current-addressdetails-address4').text('');
    }
    $('.current-addressdetails-city').text(address.City);
    $('.current-addressdetails-state').text(address.State);
    $('.current-addressdetails-postal').text(address.PostalCode);
    handleCountryChange(address.CountryCode);
}

function handleCountryChange(countryCode) {
    try {
        if(!countryCode || typeof countryCode !== 'string' || !countryCode.trim()) {
            console.warn('Invalid country code provided:', countryCode);
            return;
        }

        const $dropdown = $('#alternateCountryDd');
        if($dropdown.length === 0) {
            return;
        }

        const $optionToSelect = $dropdown.find(`option[value="${countryCode}"]`);
        if($optionToSelect.length === 0) {
            console.warn(`No option found in #alternateCountryDd for country code: ${countryCode}`);
            return;
        }
        window.donotClearTheFields = true;
        $dropdown.val(countryCode);
        $dropdown.trigger('change');
    } catch (error) {
        console.error('Error in handleCountryChange:', error);
    }
}

function getCurrentAddressObject(currentAddress) {
    if(!currentAddress) return;
    let lastName = '';
    if(currentAddress.AddressName.length > 0) {
        if(currentAddress.AddressName.split(' ').length > 1) {
            lastName = currentAddress.AddressName.split(' ')[currentAddress.AddressName.split(' ').length - 1];
        }
    }
    let addressObject = {
        FirstName: currentAddress.AddressName.split(' ')[0],
        LastName: lastName,
        Address1: currentAddress.AddressLine1,
        Address2: currentAddress.AddressLine2,
        Address3: currentAddress.AddressLine3,
        Address4: currentAddress.AddressLine4,
        City: currentAddress.City,
        StateCode: currentAddress.State,
        ZipCode: currentAddress.PostalCode,
        AddressPhone: currentAddress.AddressPhone,
        CountryCode: currentAddress.CountryCode
    };
    return addressObject;
}

function initAddressObject() {
    let addressObject = {
        FirstName: null,
        LastName: null,
        Address1: null,
        Address2: null,
        Address3: null,
        Address4: null,
        City: null,
        StateCode: 'default',
        ZipCode: null
    };
    return addressObject;
}

async function processManageSubscription($element) {
    var manageSubscriptionData = '';
    if($element.length > 0) {
        manageSubscriptionData = $element.data('shoppingcontextinfo');
    }
    if(!manageSubscriptionData) {
        let $this = $(this);
        manageSubscriptionData = $this.data('shoppingcontextinfo');
    }

    if(manageSubscriptionData.length <= 0) return;

    let request = {
        Market: manageSubscriptionData.Market,
        IsNfr: manageSubscriptionData.IsNfr
    };

    try {
        showSpinner('Setting up manage autoship started');
        const result = await autoshipService.setupManageAutoship(request);
        if(result) {
            hideSpinner('Setting up manage autoship completed');
            window.location = result;
        }
    } catch (ex) {
        console.log(ex);
        hideSpinner('Setting up manage autoship failed');
    }
    hideSpinner('Setting up manage autoship failed');
}

function trimExtraSpace() {
    // trim leading, trailing, and multiple spaces
    var $dest = $(this);
    $dest.val(jQuery.trim($dest.val()));
    $dest.val($dest.val().replace(/[ ]{2,}/, ' '));
}

const prop65HandleShowMoreFunctionality = ($cartShowMoreBtn, $cartPackList) => {
    const contentTobeToggled = 'li:nth-child(n+3):not(.qty)';
    $cartPackList.each(function() {
        let $this = $(this);
        const listItemCondition = $this.children('li:not(.qty)').length >= 3;

        if(listItemCondition) {
            $this.find(contentTobeToggled).show();
            $this.find($cartShowMoreBtn).removeClass('d-none');
            $this.find('.cart__show-more').removeClass('flip');
            $this.find('.show-text--more').addClass('d-none');
            $this.find('.show-text--less').removeClass('d-none');
        }
    });
};

const handleShowMoreFunctionality = ($cartShowMoreBtn, $cartPackList) => {
    const contentTobeToggled = 'li:nth-child(n+3):not(.qty)';
    $cartPackList.each(function() {
        let $this = $(this);
        const listItemCondition = $this.children('li:not(.qty)').length >= 3;
        if(listItemCondition) {
            $this.find(contentTobeToggled).hide();
            $this.find($cartShowMoreBtn).removeClass('d-none');
        }
    });
};

function showMoreLess() {
    let $this = $(this);
    const contentTobeToggled = 'li:nth-child(n+3):not(.qty)';
    $this.parents('.cart__item-meta--pack').find(contentTobeToggled).toggle();
    $this.toggleClass('flip');
    $this.children('.show-text--more, .show-text--less').toggleClass('d-none');
}

function updateCartItemsCount() {
    const input = $('#hidden-unique-CartTotalProductsCount');

    if(input.length) {
        let value = parseInt(input.val(), 10) || 0;
        const span = $('.header__cart-items');
        span.text(value);
        if(value === 0) {
            span.addClass('d-none');
        } else {
            span.removeClass('d-none');
        }
    }
}

function initEventHandlers() {
    let $formInput = $('.form-input');
    let $addAddress = $('#addAddress');
    let $removeInput = $('.form-group__btn--remove');
    let $placeOrder = $('.place-order');
    let $checkoutPrev = $('.checkout-prev');
    let $checkoutNext = $('.checkout-next');
    let $checkoutConfirmSubscription = $('.checkout-confirmsubsription');
    let $checkoutDiscardSubscription = $('.checkout-cancelsubscription');
    let $checkoutSaveChanges = $('.checkout-savechanges');
    let $checkoutDiscardChanges = $('.checkout-discardchanges');
    let $demoNext = $('.checkout__next');
    let $demoPrev = $('.checkout__prev');
    let $cartShowMore = $('.cart__show-more');
    let $cartPack = $('.cart__item-meta--pack');
    let $editButton = $('.checkout__review .form-group__btn.edit-button');
    let $editButtonModern = $('.cart-checkout__section .mod-review__edit-btn');
    let $subscriptionEditButton = $('.subscription-edit-button');
    let $formToggleAddress = $('.form__toggle-address');
    let $addCard = $('.btn-add-card');
    let $checkboxToggle = $('.form-input--toggle');
    let $useShippingAddress = $('.form-input--use-address');
    let $checkoutErrorMsgs = $('.checkouterrormessages');

    let $checkoutReviewStep = $('.checkout__review .form-group__btn');
    let $checkoutPlaceOrder = $('.checkout__place-order');
    let $acceptAddressBtn = $('.accept-address-btn');
    let $addressVerification = $('.isa-modal--address-verification input[name="addressVerification"]');
    let $melissaModal = $('#melissaModal');
    let $shippingOption = $('#shippingOption');
    let $pickupOption = $('#pickupOption');
    let $shippingTab = $('.checkout__tab-link, .mod-tabs__link');

    let $dataToggleTooltip = $('[data-toggle="tooltip"]');
    let $zipCodeField = $('#zipCodeInput');
    let $applyCouponBtn = $('.apply-coupon-btn');
    let $applyCouponTodayBtn = $('.apply-couponToday-btn');
    let $applyCouponSubscriptionBtn = $('.apply-couponSubscription-btn');
    let $manageSubscriptionBtn = $('.manage-subscription-btn');
    let $sepaNameHdn = $('#sepaName');

    let $cartEmptyZeroDollarCta = $('.cartEmptyZeroDollarCta');
    let $cancelSetupSub = $('#cancelSetupSubBtn');
    let $cancelSetupSubFooter = $('#cancelSetupSubBtnFooter');
    $cancelSetupSub.on('click', cancelSetUpSubscriptionButton);
    $cancelSetupSubFooter.on('click', cancelSetUpSubscriptionButton);
    $cartEmptyZeroDollarCta.on('click', cartEmptyZeroDollarRedirection);
    $sepaNameHdn.on('input', changeSepaNameHiddenFieldHandler);
    updateCartItemsCount();
    if($cartEmptyZeroDollarCta.length > 0) {
        $('#hidden-3ds-verified').val('true'); // Bypass 3DS for Today's cart if Zero dollar Enrollment
    }

    if($('.view-my-coupons-modal').length > 0 && $('.cart').length === 0) {
        $('.view-my-coupons-modal').on('click', setAvailableCouponPromotionModal);
    }
    if($('.cart-coupon__input-container, .mod-coupon-row').length > 0) {
        $('#coupon, #couponToday, #couponSubscription').on('input', window.enableDisableApplyCouponButton);
    }
    let $phonenumber = $('#phoneCountryCode');
    $phonenumber.on('change', changePhoneNumberCode);

    let $pickupPhoneNumber = $('#phonePickupCountryCode');
    $pickupPhoneNumber.on('change', changePickupPhoneNumberCode);

    let $threeDSHandler = $('.three-ds-handler');
    $threeDSHandler.on('click', confirmPaymentChanges);

    initDdSlick();
    initModSavedPayments();

    $addAddress.on('click', addAddress);
    $removeInput.on('click', removeAddress);

    $editButton.on('click', editStep);
    $editButtonModern.on('click', editStep);
    $subscriptionEditButton.on('click', editStep);

    // Initialize address autocomplete
    initAddressAutocomplete();

    // Initialize legacy payment method card selection only when the modernized layout is not active.
    if($('.checkout-v2').length === 0) {
        initPaymentMethodCards();
    }

    let $copyBundleLinkBtn = $('.bundle-Copybtn');

    if($copyBundleLinkBtn) {
        $copyBundleLinkBtn.on('click', handleCopyLinkButtonClick);
    }

    $addCard.on('click', addPaymentCard);
    let $cancelAddCard = $('.btn-cancel-add-card');
    $cancelAddCard.on('click', cancelPaymetricInlineFlow);
    $('#btnCancelPaypalFlow').on('click', cancelPaypalInlineFlow);
    let $retryPaymetric = $('.btn-retry-paymetric');
    $retryPaymetric.on('click', function() {
        paymetricIframeRetryCount = 0;
        $('#paymetricdata').data('requested', true);
        trackPaymetricInlineLifecycle('paymetric_iframe_manual_retry');
        getPaymetricParams();
    });
    $('#iPaymetric').on('load', onPaymetricIframeLoad);
    $('#iPaymetric').on('error', onPaymetricIframeError);
    $('#verifyCVV').on('input', function() {
        $('#verifyCVV-inline-error').remove();
        $('#verifyCVV-error').remove();
        $(this).parent().removeClass('is--error');
    });
    $(FORM_PAYMENT).find('input, select, textarea').on('input change', function() {
        if($('#paymetric-inline-section').is(':visible') && $('#iPaymetric').data('ready')) {
            $('.btn-add-card').prop('disabled', false);
        }
    });
    $('#btnCreditCard').on('click', onCreditCardButtonClick);
    $('#btnCreditCard').on('click', clearSepaData.bind(this, true));
    $('#btnCreditCard').on('click', clearBancontact.bind(this));
    $('#btnCreditCard').on('click', clearIdealData.bind(this));
    $('#btnCreditCard').on('click', function () {
        uncheckUseSamePaymentCheckboxOnTodaysPayment('btnCreditCard');
    });
    $('#btnCreditCard').on('click', clearIdealData.bind(this));

    $formToggleAddress.on('click', toggleAddress);
    $checkboxToggle.on('change', toggleContainer);
    $useShippingAddress.on('change', toggleBillingAddress);
    $acceptAddressBtn.on('click', verifyShippingAddress);
    $formInput.on('input', resetAddressVerification);
    $addressVerification.on('input', setSelectedAddress);
    $melissaModal.on('hidden.bs.modal', triggerCloseMelissaModal);
    $melissaModal.on('show.bs.modal', openingMelissaModal);
    $shippingOption.on('change', shippingOptionChanged);
    $pickupOption.on('change', pickupOptionChanged);
    $('.checkout-v2 .mod-tabs__link').on('show.bs.tab', clearShippingTabValidationState);
    $shippingTab.on('click', shippingTabSelected);
    allFlowIsEnabled = $('#checkout-parent-container').hasClass('all-flow-checkout') || $('#checkout-parent-container').hasClass('mod-checkout__review');

    if(allFlowIsEnabled && $cartShowMore && $cartPack) {
        var iscaliforniaProp65 = $('.cart__productlist').data('iscalifornia');
        var calProp65 = $('.cart__productlist').data('prop65url');

        if(iscaliforniaProp65 && calProp65) {
            prop65HandleShowMoreFunctionality($cartShowMore, $cartPack);
            $(document).on('click', '.cart__show-more', showMoreLess);
        } else {
            handleShowMoreFunctionality($cartShowMore, $cartPack);
            $(document).on('click', '.cart__show-more', showMoreLess);
        }
    }

    // Trim trailing spaces from zipCodeInput on all pages
    $zipCodeField.on('blur', function() {
        var value = $(this).val();
        if(value) {
            $(this).val(value.replace(/\s+$/, ''));
        }
    });

    let $shippingForm = $('form#shipping');
    if($shippingForm && $shippingForm.length > 0) {
        $('#firstName').on('focusout', trimExtraSpace);
        $('#lastName').on('focusout', trimExtraSpace);
        $('#firstNamePickup').on('focusout', trimExtraSpace);
        $('#lastNamePickup').on('focusout', trimExtraSpace);
        // only needed for shipping page
        $zipCodeField.on('blur', function() {
            getShippingOptions();
        });
        $('#cityInput').on('blur', getShippingOptions);
        $('#stateInput').on('change', getShippingOptions);
        if(isRequireddAddressLine(2)) {
            $('#address2Input').on('blur', getShippingOptions);
        }
        if(isRequireddAddressLine(4)) {
            $('#address4Input').on('blur', getShippingOptions);
        }
    }

    if(isPaymentManageAutoship()) {
        $formInput.on('blur', paymentFormDirty);
        $useShippingAddress.on('change', paymentFormDirty);
    }

    if($('.cart').length === 0) {
        // not cart page
        $applyCouponBtn.on('click', applyCoupon);
        $applyCouponTodayBtn.on('click', applyCouponToday);
        $applyCouponSubscriptionBtn.on('click', applyCouponSubscription);
        const couponInputBtnMap = [
            { input: '#coupon', $btn: $applyCouponBtn },
            { input: '#couponToday', $btn: $applyCouponTodayBtn },
            { input: '#couponSubscription', $btn: $applyCouponSubscriptionBtn }
        ];
        couponInputBtnMap.forEach(function({ input, $btn }) {
            $(document).on('keydown', input, function(e) {
                if(e.which === 13) {
                    e.preventDefault();
                    if(!$btn.prop('disabled')) {
                        $btn.trigger('click');
                    }
                }
            });
        });
        $(document).on('click', '.cart-coupon__list .removable-coupon, .mod-coupon-list .removable-coupon', clearCouponPromotion);
    }
    $('.change-payment-method').on('click', changePaymentMethod);
    $('.shipping-change-address').on('click', showShippingInfo);
    $('#savedAddresses').on('change', handleSavedAddressChange);
    $('.apple-pay-button').on('click', onApplePayButtonClicked);
    $('#btn-set-shipping-apple-pay').on('click', setAppleShippingMock);
    $('.save-recommended-cart-btn').on('click', saveRecommendedCart);
    $('.cancel-recommended-cart-btn').on('click', loadRecommendedCart);
    $('.edit-my-recommended-cart-link').on('click', editRecommendedCart);
    $('.confirm-save-modal-btn').on('click', confirmSaveRecommendedCart);
    $('#btn-sepa').on('click', onSepaButtonClick);
    $('#btn-isawallet').on('click', onIsawalletButtonClick);
    $('#btn-bancontact').on('click', onBancontactButtonClick);
    $('#btn-ideal').on('click', onIDealButtonClick);
    $('#btn-cash').on('click', onCashButtonClick);
    $('#btn-debitcard').on('click', onDebitcardButtonClick);
    if($('#btn-editBundle')) {
        $('#btn-editBundle').on('click', editProductBundle);
    }
    $('#submitorder').submit(function (e) {
        // Stop the form submitting
        e.preventDefault();
    });
    $manageSubscriptionBtn.on('click', processManageSubscription);

    if($checkoutErrorMsgs.length > 0) {
        let errorMsgs = $checkoutErrorMsgs.data('errormessages');
        let msgText;
        let isManage = $checkoutErrorMsgs.data('ismanage');
        if(errorMsgs && errorMsgs.length > 0 && isManage) {
            let msgs = errorMsgs.filter(msg => msg.DisplayMessage === true);
            if(msgs && msgs.length > 0) {
                msgs.forEach(function (item) {
                    if(msgText) {
                        msgText = msgText + `<br/>${item.MessageText}`;
                    } else {
                        msgText = item.MessageText;
                    }
                });
                if(msgText) {
                    toast.Error(msgText);
                }
            } else {
                let msg = errorMsgs[0];
                toast.Error(msg.MessageText);
            }
        }
    }

    savedAddresses = $('.checkout__saved-addresses').data('saved-addresses') || [];

    if(savedAddresses.length > 0) {
        isMelissaAddressEnabledForUser = false;
        let $selectedShipping = $('#selectedShippingMethod');
        // cart has no saved shipping delivery method. First request/Pickup
        if($selectedShipping.length > 0) {
            let value = $selectedShipping.val();
            let currentShippingType = updateShippingType();
            if(currentShippingType === SHIPPING_TYPE_SHIPPING && (CART_SHIPPING_TYPE !== SHIPPING_TYPE_SHIPPING || (!value))) {
                getShippingOptions();
            }
        }
    }
    addGtmTag();
    // showBillingAddress();
    subSaveContainers();
    triggerCheckoutUpdates();
    repositionPhoneAboveSaveAddressCheckbox();
    validateReview();
    ccDropdown();
    initPaypal();
    initVenmo();
    initBancontact();
    changePhoneNumberCode();
    changePickupPhoneNumberCode();
    errorMessageWidth();
    showItemsRemovedWarning();

    let $patternlabBody = $('body');
    if($patternlabBody.hasClass('patternlab__body')) {
        $demoNext.on('click', nextStep);
        $demoPrev.on('click', prevStep);
        $checkoutReviewStep.on('click', goToStep);
        $checkoutPlaceOrder.on('click', orderError);
    } else {
        $checkoutPrev.on('click', checkoutPrev);
        $checkoutNext.on('click', checkoutNext);
        $placeOrder.on('click', placeOrder);
        $checkoutConfirmSubscription.on('click', placeOrder);
        $checkoutDiscardSubscription.on('click', DiscardSubscription);
        $checkoutSaveChanges.on('click', SaveChanges);
        $checkoutDiscardChanges.on('click', DiscardChanges);
    }

    if($dataToggleTooltip.length) {
        $dataToggleTooltip.tooltip();
    }

    $('body').on('click', '#closeModal, #modalBtnClose', closeGenericModal);
    checkCouponsModal('.checkout');
}

function cancelSetUpSubscriptionButton() {
    $('.cancelSetUpSubscriptionModalBackdrop').show();
}

function changeSepaNameHiddenFieldHandler() {
    $('#sepaNameHdn').val($(this).val());
}

async function cartEmptyZeroDollarRedirection() {
    try {
        let result = await cartService.cartEmptyZeroDollarRedirection();
        if(result) {
            let $this = $(this);
            window.location.href = $this.data('ctaurl');
        }
    } catch (ex) {
        console.error(ex);
    }
}

function changePhoneNumberCode() {
    let $option = $('#phoneCountryCode').find('option:selected');
    let $phone = $('#phone');
    $phone.prop('pattern', $option.data('phonenumberregex'));
}
function changePickupPhoneNumberCode() {
    let $selected = $('#phonePickupCountryCode').find('option:selected');
    let $pickupphone = $('#phonePickup');
    $pickupphone.prop('pattern', $selected.data('pickupphoneregex'));
}

function closeGenericModal(e) {
    $(e.currentTarget).closest('.modal-backdrop').hide();
    window.location = saveChangesRedirectUrl;
}

function initDdSlick() {
    let $savedPayment = $('#savedPayment');
    if(!$savedPayment.length) return;

    $savedPayment.ddslick({
        width: 350,
        embedCSS: false,
        background: '#fff'
    });

    $('.dd-option').on('click', handleSavedPaymentChange);

    if($('#savedBillingInformation').length) {
        isSavedBillingInformation = $('#savedBillingInformation').css('display') !== 'none';
    }
}

function addGtmTag() {
    if(document.baseURI.indexOf('paymentfallback') > 0) {
        return;
    }
    if(document.baseURI.indexOf('shipping') > 0) {
        addGtmTagToFlowSteps('2');
    } else if(document.baseURI.indexOf('payment') > 0) {
        addGtmTagToFlowSteps('');
    } else if($('#hidden-gtn-checout-review-page').length) {
        addGtmTagToFlowSteps('4');
    } else if(document.baseURI.indexOf('thank-you') > 0 || document.referrer.indexOf('thank-you') > 0) {
        var emptyCart = $('#hdnEmptyCart').val();
        if(emptyCart !== 'true') {
            console.log('Pushing to gtm');
            addGtmTagToPurchaseStep();
        }
    }
}

function addGtmTagToFlowSteps(step) {
    let $products = [];
    let catalog = window.ga_props[0].CatalogName;
    let category = '';
    window.ga_props[0].Products.forEach(function (item) {
        let product = {
            'name': item.ProductName,
            'id': item.Sku,
            'price': item.Price,
            'brand': item.Brand,
            'category': item.ProductFamilyName,
            'quantity': item.Quantity
        };
        if(item.QueryId && item.QueryId !== null && item.QueryId.trim() !== '') {
            product.queryId = item.QueryId;
        }
        if(product.queryId && product.queryId !== null && product.queryId.trim() !== '') {
            loadIndexNameIfExists();
            if(INDEX_NAME !== undefined && INDEX_NAME !== null) {
                product.indexName = INDEX_NAME;
            }
        }
        $products.push(product);
    });

    let memberId = window.ga_props[0].MemberId;
    let memberType = window.ga_props[0].MemberType;
    let currency = window.ga_props[0].Currency;
    let cultureCode = window.ga_props[0].CultureCode;
    let marketingCloudUserId = window.ga_props[0].MarketingCloudUserId;
    let isagenixMemberSubType = window.ga_props[0].IsagenixMemberSubType;
    let preferredCultureCode = window.ga_props[0].PreferredCultureCode;
    let hasAutoship = window.ga_props[0].HasAutoship;
    let canEnroll = window.ga_props[0].CanEnroll;
    let hasIsaDelivery = window.ga_props[0].HasIsaDelivery;
    let daysSinceEnrollment = window.ga_props[0].DaysSinceEnrollment;
    setDataForAllProducts(catalog, category, currency, memberType, memberId, cultureCode, marketingCloudUserId, isagenixMemberSubType, preferredCultureCode, hasAutoship, canEnroll, hasIsaDelivery, daysSinceEnrollment);
    if(step === '') {
        addGtmTagForPaymentInfo($products);
    } else if(step === '4') {
        addGtmTagForReviewPage(step, $products);
    } else {
        addGtmTagTocheckout(step, $products);
    }
}

function addGtmTagToPurchaseStep() {
    let $products = [];
    let catalog = window.ga_props[0].CatalogName;
    let category = '';
    console.log(window.ga_props);
    window.ga_props[0].Products.forEach(function (item) {
        let product = {
            'name': item.ProductName,
            'id': item.Sku,
            'price': item.Price,
            'brand': item.Brand,
            'category': item.ProductFamilyName,
            'quantity': item.Quantity
        };
        if(item.QueryId && item.QueryId !== null && item.QueryId.trim() !== '') {
            product.queryId = item.QueryId;
        }

        if(product.queryId && product.queryId !== null && product.queryId.trim() !== '') {
            loadIndexNameIfExists();
            if(INDEX_NAME !== undefined && INDEX_NAME !== null) {
                product.indexName = INDEX_NAME;
            }
        }

        $products.push(product);
    });
    let purchaseType;
    if(window.algoliaData && window.algoliaData.purchaseType && !purchaseType) {
        purchaseType = window.algoliaData.purchaseType;
    }
    let memberId = window.ga_props[0].MemberId;
    let memberType = window.ga_props[0].MemberType;
    let currency = window.ga_props[0].Currency;
    let cultureCode = window.ga_props[0].CultureCode;
    let marketingCloudUserId = window.ga_props[0].MarketingCloudUserId;
    let isagenixMemberSubType = window.ga_props[0].IsagenixMemberSubType;
    let preferredCultureCode = window.ga_props[0].PreferredCultureCode;
    let hasAutoship = window.ga_props[0].HasAutoship;
    let canEnroll = window.ga_props[0].CanEnroll;
    let hasIsaDelivery = window.ga_props[0].HasIsaDelivery;
    let daysSinceEnrollment = window.ga_props[0].DaysSinceEnrollment;
    setDataForAllProducts(catalog, category, currency, memberType, memberId, cultureCode, marketingCloudUserId, isagenixMemberSubType, preferredCultureCode, hasAutoship, canEnroll, hasIsaDelivery, daysSinceEnrollment);

    let transactionId = window.ga_props[0].TransactionId;
    let flow = '';
    let total = window.ga_props[0].CartTotal;
    let tax = window.ga_props[0].TaxTotal;
    let shipping = window.ga_props[0].ShippingTotal;
    let coupon = window.ga_props[0].CouponCode;
    console.log(window.ga_props);
    let purchaseData;
    if(window.algoliaData && window.algoliaData.purchaseData) {
        try {
            purchaseData = window.algoliaData.purchaseData;
        } catch (e) {
            purchaseData = null;
        }
    }
    addGtmTagToPurchase(transactionId, flow, total, tax, shipping, coupon, $products, purchaseType, purchaseData);
}

function showApplePayButton() {
    var buttons = document.getElementsByClassName('apple-pay-button');
    for (let button of buttons) {
        button.className += ' visible';
        button.classList.remove('d-none');
    }
}

function onApplePayButtonClicked() {
    if(!window.ApplePaySession) {
        return;
    }

    applePayMsgVM = JSON.parse($('#hdn-apple-msg-vm').val());
    applePayDetailVM = JSON.parse($('#hdn-apple-detail-vm').val());

    var request = {
        'countryCode': applePayDetailVM.CountryCode || 'US',
        'currencyCode': applePayDetailVM.CurrencyCode || 'USD',
        'merchantCapabilities': [
            'supports3DS'
        ],
        'shippingType': 'shipping',
        'supportedNetworks': [
            'visa',
            'masterCard',
            'amex',
            'discover'
        ],
        'requiredBillingContactFields': [
            'postalAddress',
            'name'
        ],
        'requiredShippingContactFields': [
            'postalAddress',
            'name',
            'phone',
            'email'
        ],
        'total': {
            'label': getMessage('PaymentOffice'),
            'amount': $('.cart-sidebar__estimated-total-value').text() || '0.00',
            'type': 'final'
        }
    };

    if(applePayDetailVM) {
        request.lineItems = [
            {
                'label': 'Subtotal',
                'amount': applePayDetailVM.CartSubTotal || '0.00'
            },
            {
                'label': 'Shipping',
                'amount': applePayDetailVM.ShippingAmount || '0.00'
            }
        ];

        if(!applePayDetailVM.IsTaxInclusive) {
            if(applePayDetailVM.HasAlternateTax) {
                request.lineItems.push({ 'label': applePayDetailVM.TaxLabel, 'amount': applePayDetailVM.TaxesAmount || '0.00' });
                request.lineItems.push({ 'label': applePayDetailVM.AlternateTaxLabel, 'amount': applePayDetailVM.AlternateTaxesAmount || '0.00' });
            } else {
                request.lineItems.push({ 'label': 'Tax', 'amount': applePayDetailVM.TaxesAmount || '0.00' });
            }
        }
    }

    // Create ApplePaySession
    var session = new window.ApplePaySession(6, request);

    // Setup handler for validation the merchant session.
    session.onvalidatemerchant = function (event) {
        console.log('validate merchant hit');

        // Create the payload.
        var data = {
            validationUrl: event.validationURL
        };

        // Post the payload to the server to validate the
        // merchant session using the merchant certificate.
        cartService.validateApplePayMerchant(data).then(function (merchantSession) {
            var result = JSON.parse(merchantSession);
            session.completeMerchantValidation(result);
        });
    };

    session.onshippingmethodselected = event => {
        // Define ApplePayShippingMethodUpdate based on the selected shipping method.
        // No updates or errors are needed, pass an empty object.
        console.log('on shipping method selected');
        console.log(event);
        var request = event.shippingMethod;
        setShippingMethodForApplePay(request).then(result => {
            $('#txt-apple-shipping-id').val(request.identifier);
            var update = applePayUpdatePayload(result.cartTotals, result.isTaxInclusive);

            session.completeShippingMethodSelection(update);
        });
    };

    session.onshippingcontactselected = event => {
        // Define ApplePayShippingContactUpdate based on the selected shipping contact.
        console.log('on shipping contact selected');
        console.log(event);
        var shippingData = event.shippingContact;
        var errors = validateShippingData(shippingData);
        if(errors && errors.length) {
            var update = applePayUpdatePayload(null, false, null, null, errors);

            session.completeShippingContactSelection(update);
        } else {
            shippingData.administrativeArea = shippingData.countryCode === 'PR' || shippingData.countryCode === 'NZ' ? shippingData.countryCode : shippingData.administrativeArea;
            getShippingOptionsForApplePay(shippingData).then(result => {
                var backendErrors = validateResponse(result);
                var defaultShippingOption = result.shippingOptions.find(x => x.Id === result.selectedShippingMethodId);

                var serviceName = defaultShippingOption ? defaultShippingOption.ServiceName : undefined;
                var serviceDisplayName = defaultShippingOption ? defaultShippingOption.ServiceDisplayName : undefined;

                if(serviceName === undefined || serviceDisplayName === undefined) {
                    console.error('Shipping option is undefined');
                    console.log(result.shippingOptions);
                }

                $('#txt-apple-shipping-id').val(result.selectedShippingMethodId + '|' + serviceName + '|' + serviceDisplayName);

                var update = applePayUpdatePayload(result.cartTotals, result.isTaxInclusive, result.shippingOptions, result.selectedShippingMethodId, backendErrors, result.isOrderNonShippable);

                session.completeShippingContactSelection(update);
            });
        }
    };

    session.onpaymentauthorized = event => {
        console.log('on payment authorized');

        var paymentResponse = event.payment;
        const errors = validateAppleAuthRequest(paymentResponse.billingContact, paymentResponse.shippingContact);

        if(errors && errors.length) {
            var result = {
                'status': window.ApplePaySession.STATUS_FAILURE,
                'errors': errors
            };

            session.completePayment(result);
            console.log('remove shipping party');
            cartService.removeShippingParty();
        } else {
            paymentResponse.billingContact.administrativeArea = paymentResponse.billingContact.countryCode === 'PR' || paymentResponse.billingContact.countryCode === 'NZ' ? paymentResponse.billingContact.countryCode : paymentResponse.billingContact.administrativeArea;
            paymentResponse.shippingContact.administrativeArea = paymentResponse.shippingContact.countryCode === 'PR' || paymentResponse.shippingContact.countryCode === 'NZ' ? paymentResponse.shippingContact.countryCode : paymentResponse.shippingContact.administrativeArea;
            paymentResponse.selectedShippingMethod = $('#txt-apple-shipping-id').val();
            paymentResponse.dataSourceId = $('#hidden-datasource-id').val();
            $('#txt-apple-response').val(JSON.stringify(paymentResponse));
            $('#btn-process-apple-pay').click();

            window.addEventListener('beforeunload', (event) => {
                console.log('beforeunload called');
                var result = {
                    'status': 0
                };

                session.completePayment(result);
            });
        }
    };

    session.oncancel = event => {
        console.log('on cancel called');

        cartService.removeShippingParty();
        // Payment cancelled by WebKit
        window.removeEventListener('beforeunload', (event) => {
            console.log('removeEventListener called');
        });
    };

    session.begin();
}

function validateAppleAuthRequest(billingContact, shippingContact) {
    let errors = [];

    // these errors need to use code: shippingContactInvalid
    const shippingErrors = validateAddress(shippingContact, 'shippingContactInvalid');
    const billingErrors = validateAddress(billingContact, 'billingContactInvalid');
    const contactDetails = validateContactDetails(shippingContact, 'shippingContactInvalid');
    errors = [...shippingErrors, ...billingErrors, ...contactDetails];

    return errors;
}

function validateAddress(address, type) {
    let errors = [];
    var postalRegex = new RegExp(applePayMsgVM.find(m => m.Code === 'postalCode').Expression);

    if(!address.familyName) { errors.push(new window.ApplePayError(type, 'name', getMessage('familyName'))); }

    if(!address.givenName) { errors.push(new window.ApplePayError(type, 'name', getMessage('givenName'))); }

    if(address.addressLines && address.addressLines.length && !address.addressLines[0]) { errors.push(new window.ApplePayError(type, 'addressLines', getMessage('addressLines'))); }

    if(!address.locality) { errors.push(new window.ApplePayError(type, 'locality', getMessage('locality'))); }

    if(!address.administrativeArea) { errors.push(new window.ApplePayError(type, 'administrativeArea', getMessage('administrativeArea'))); }

    if(!address.postalCode || (type === 'shippingContactInvalid' && !postalRegex.test(address.postalCode))) { errors.push(new window.ApplePayError(type, 'postalCode', getMessage('postalCode'))); }

    if(!address.countryCode) { errors.push(new window.ApplePayError(type, 'country', getMessage('country'))); }

    return errors;
}

function validateContactDetails(shippingContact, type) {
    let errors = [];
    var emailRegex = new RegExp(applePayMsgVM.find(m => m.Code === 'emailAddress').Expression);
    var phoneNumberRegex = new RegExp(applePayMsgVM.find(m => m.Code === 'phoneNumber').Expression);
    if(!shippingContact.emailAddress || !emailRegex.test(shippingContact.emailAddress)) { errors.push(new window.ApplePayError(type, 'emailAddress', getMessage('emailAddress'))); }

    if(!shippingContact.phoneNumber || !phoneNumberRegex.test(shippingContact.phoneNumber)) { errors.push(new window.ApplePayError(type, 'phoneNumber', getMessage('phoneNumber'))); }

    return errors;
}

function validateShippingData(shippingData) {
    var errors = [];

    if(!shippingData.countryCode) { errors.push(new window.ApplePayError('shippingContactInvalid', 'country', getMessage('countryCode'))); }

    if(!shippingData.administrativeArea) { errors.push(new window.ApplePayError('shippingContactInvalid', 'administrativeArea', getMessage('administrativeArea'))); }

    if(!shippingData.postalCode) { errors.push(new window.ApplePayError('shippingContactInvalid', 'postalCode', getMessage('postalCode'))); }

    if(shippingData.countryCode !== applePayDetailVM.CountryCode) { errors.push(new window.ApplePayError('shippingContactInvalid', 'country', getMessage('ShippingCountry'))); }

    return errors;
}

function validateResponse(response) {
    var errorList = response.messages.filter(m => m.Code === 'ValidationError');
    var applePayError = [];

    if(errorList && errorList.length > 0) {
        errorList.forEach(e => {
            applePayError.push(new window.ApplePayError('shippingContactInvalid', 'postalCode', e.MessageText.includes('APO/FPO/DPO and military bases are prohibited') ? getMessage('ShippingZipRestriction') : e.MessageText));
        });
    }
    return applePayError;
}

function getMessage(field) {
    return applePayMsgVM.find(m => m.Code === field).Message;
}

async function getShippingOptionsForApplePay(shippingContact) {
    try {
        let datasourceItemId = $('#hidden-datasource-id').val();
        let request = {
            Contact: 'on',
            SelectedShippingAddress: 'true',
            Address4Input: shippingContact.countryCode === 'NZ' ? shippingContact.locality : '',
            Address1Input: '', // Adding this one only to bypass validation for apple pay beacause we get shipping address post authorization.
            CityInput: shippingContact.locality,
            SelectedState: shippingContact.administrativeArea,
            StateInput: shippingContact.administrativeArea,
            ZipCodeInput: shippingContact.postalCode,
            CountryCode: shippingContact.countryCode,
            PhoneCountryCode: shippingContact.countryCode,
            PhonePickupCountryCode: shippingContact.countryCode,
            ShippingType: 'shipping',
            MelissaAddressVerificationType: '0',
            DatasourceItemId: datasourceItemId
        };

        let response = await checkoutService.getShippingOptionsForApplepay(request);
        if(response) {
            console.log(response);
            var shippingInfo = response.ShippingOptions;
            var result = {
                shippingOptions: (shippingInfo) ? shippingInfo.ShippingOptionsList : [],
                cartTotals: response.CartTotals,
                selectedShippingMethodId: response.ShippingMethodId,
                messages: response.Messages,
                isOrderNonShippable: response.IsOrderNonShippable,
                isTaxInclusive: response.IsTaxInclusive
            };

            return result;
        } else {
            return '';
        }
    } catch (e) {
        console.error(e);
    }
}

async function setShippingMethodForApplePay(shippingMethod) {
    try {
        let datasourceItemId = $('#hidden-datasource-id').val();
        let request = {
            SelectedShippingAddress: 'true',
            SelectedShippingMethod: shippingMethod.identifier,
            ShippingOption: shippingMethod.identifier,
            PhonePickupCountryCode: '',
            ShippingType: 'shipping',
            MelissaAddressVerificationType: '0',
            DatasourceItemId: datasourceItemId
        };

        let response = await checkoutService.setShippingMethodForApplepay(request);
        if(response) {
            var appleCartDetails = {
                shippingOptions: response.ShippingOptions.ShippingOptionsList,
                cartTotals: response.CartTotals,
                isOrderNonShippable: response.IsOrderNonShippable,
                isTaxInclusive: response.IsTaxInclusive
            };
            return appleCartDetails;
        } else {
            return '';
        }
    } catch (e) {
        console.error(e);
    }
}

async function setAppleShippingMock() {
    let request = {
        administrativeArea: 'AZ',
        country: 'United States',
        countryCode: 'US',
        familyName: '',
        givenName: '',
        locality: 'Gilbert',
        phoneticFamilyName: '',
        phoneticGivenName: '',
        postalCode: '85237',
        subAdministrativeArea: '',
        subLocality: ''

    };

    getShippingOptionsForApplePay(request).then(result => {
        const response = result;
        console.log(response);
    });
}

async function editRecommendedCart(e) {
    e.preventDefault();
    await loadRecommendedCart($(this));
}

function showRecommendedCartEditModeView() {
    $('.cart__save-recommended-cart, .cart__cancel-recommended-cart, .cancel-recommended-cart-btn,.recommended-cart-change-image,.recommended-cart-delete-btn,.placement-selection-btn,.checkout__review-header .edit-button,.cart-sidebar__header .edit-button,.checkout-prev, .view-all-my-recommended-carts-link').removeClass('d-none');
    $('.cart__view-recommended-cart,.cart__share-recommended-cart,.cart__enroll-member-cart,.edit-my-recommended-cart-link, .view-all-my-recommended-carts-link-view').addClass('d-none');
    $('#confirmPlacement').prop('checked', false).prop('readonly', false);
    $('#recommendedCartName').prop('readonly', false).prop('disabled', false);
    $('#confirmPlacement').parent().removeClass('rc-view-disable');
    var $reviewCartHeader = $('.review-cart-header-title-value');
    if($reviewCartHeader.length > 0) {
        var readonlyTitle = $reviewCartHeader.data('edit-title');
        $reviewCartHeader.text(readonlyTitle);
    }
}

function showRecommendedCartReadOnlyView() {
    $('.cart__save-recommended-cart, .cart__cancel-recommended-cart, .cancel-recommended-cart-btn,.recommended-cart-change-image,.recommended-cart-delete-btn,.placement-selection-btn,.checkout__review-header .edit-button,.cart-sidebar__header .edit-button,.checkout-prev, .view-all-my-recommended-carts-link').addClass('d-none');
    $('.cart__view-recommended-cart,.cart__share-recommended-cart,.cart__enroll-member-cart,.edit-my-recommended-cart-link,.cart__view-recommended-cart-nav-divider,.mod-checkout__header-rc-divider, .view-all-my-recommended-carts-link-view').removeClass('d-none');
    $('#confirmPlacement').prop('checked', true).prop('disabled', true);
    $('#confirmPlacement').parent().addClass('rc-view-disable');
    $('#recommendedCartName').prop('readonly', true).prop('disabled', true);
    $('.coupon-badge.badge svg').remove();
    hideNewMemberPlacementEditBtn();
    var $reviewCartHeader = $('.review-cart-header-title-value');
    if($reviewCartHeader.length > 0) {
        var readonlyTitle = $reviewCartHeader.data('view-title');
        $reviewCartHeader.text(readonlyTitle);
    }
}

function getDateFormatted(date, format) {
    if(date.indexOf('.') !== -1) {
        date = date.replace(/\./g, '-');
    } else {
        date = date.replace(/\//g, '-');
    }
    format = format.replace(/\//g, '-');
    const dateParts = date.split('-');
    const formatParts = format.split('-');
    let dayKey, monthKey, yearKey;
    for (let i = 0; i < formatParts.length; i++) {
        if(formatParts[i].includes('d')) {
            dayKey = formatParts[i];
        }
        if(formatParts[i].includes('m')) {
            monthKey = formatParts[i];
        }
        if(formatParts[i].includes('y')) {
            yearKey = formatParts[i];
        }
    }

    const day = parseInt(dateParts[formatParts.indexOf(dayKey)]);
    const month = parseInt(dateParts[formatParts.indexOf(monthKey)]);
    const year = parseInt(dateParts[formatParts.indexOf(yearKey)]);

    let strDay = day < 10 ? '0' + day : day;
    let strMonth = month < 10 ? '0' + month : month;
    return strMonth + '-' + strDay + '-' + year;
}

const hideNewMemberPlacementEditBtn = () => {
    const $editBtn = $(".form-group__btn.btn.btn-link.edit-button.shipping-edit-button[data-target='#editPlacementModal']");
    $('.cart-checkout__placement-list').addClass('mt-4');
    $editBtn.hide();
};

async function saveRecommendedCart() {
    if(!validateOnlyReviewForm()) return;
    const rcName = $('#recommendedCartName').val();
    hideMainErrorMessage();
    showSpinner('Saving recommended cart started');
    let result = await recommendedCartService.saveRecommendedCart($('form#submitorder').serialize());
    if(result && result.IsSuccessful) {
        hideSpinner('Saving recommended cart completed');
        $('#recommendedCartId').val(result.ShareLinkId);
        const shareCode = result.ShareLinkCode !== null && result.ShareLinkCode !== '' ? result.ShareLinkCode : $('#bundleShareCode').val();
        $('#recommendedCartShareCode').val(shareCode);
        updateAnchorsToCultureCode(result.CurrentCultureCode, result.CultureCodeToRestore);
        $('#confirmSaveRecommendedModal.modal-backdrop').hide();
        showRecommendedCartReadOnlyView();
        if($('#isBundleReview').length) {
            $('.checkout__footer--review.bundle').hide();
        }
        toast.Success(getToastMessage(result));
        showBundleReadOnlyMode(shareCode, result.ShareLinkId, rcName);
        $('html, body').animate({ scrollTop: 0 }, 300);
    } else {
        hideSpinner('Saving recommended cart failed');
        $('#confirmSaveRecommendedModal.modal-backdrop').hide();
        let errorMsg = $(this).data('save-failed-msg');
        if(result && result.Messages) {
            let msg = result.Messages.find(msg => msg.DisplayMessage === true);
            if(msg && msg.MessageText) errorMsg = msg.MessageText;
        } else {
            showRecommendedCartEditModeView();
        }
        setMainErrorMessage(errorMsg);
    }
}

function showBundleReadOnlyMode(sharecode, shareLinkId, rcName) {
    const isBundleFlow = $('#hidden-isBundleFlow');
    if($(isBundleFlow).length && $(isBundleFlow).val() === 'true') {
        $('.bundleReviewPageTitle').text($('#hidden-viewBundleTitle').val());
        $('.cart__view-recommended-cart-nav-divider').removeClass('d-none');
        $('#btn-editBundle').removeClass('d-none');
        $('#view-product-bundle-review-page').removeClass('d-none');
        $('#bundleDetailsSection').text($('#bundleDetailsSection').data('section-name'));
        let baseUrl = $('.bundle-Copybtn').data('base-url');
        let shareUrl = baseUrl + '/share/' + sharecode;
        $('#copy-btton-share').removeAttr('data-sharelinkurl');
        $('#copy-btton-share').attr('data-sharelinkurl', shareUrl);
        $('#recommendedCartNameLabel').addClass('d-none');
        $('#bundleViewModeSection').removeClass('d-none');
        $('#bundleViewName').text(rcName);
        $('#recommendedCartName').addClass('d-none');
        $('#bundleNameFieldTooltipText').addClass('d-none');
        $('#CheckoutChangeShareImageModal').addClass('d-none');
        $('.recommended-cart-change-image').addClass('d-none');
        $('#bundleShareLinkId').val(shareLinkId);
        $('#bundleShareCode').val(sharecode);
        $('#ItemsRemovedFromRecommendedCartError').addClass('d-none');
        $('.checkout-items-warning-alert').addClass('d-none');
    }
}

async function confirmSaveRecommendedCart() {
    if($('#cart-max-td-error').length && !$('#cart-max-td-error').hasClass('d-none')) { return; }
    if(!validateOnlyReviewForm()) return;
    hideMainErrorMessage();
    $('#confirmSaveRecommendedModal.modal-backdrop').removeClass('fade')
        .addClass('show')
        .show();
}

async function loadRecommendedCart(element) {
    hideMainErrorMessage();
    showSpinner('Loading recommended cart started');
    let $isEdit = false;
    if(element.hasClass('edit-my-recommended-cart-link')) {
        $isEdit = true;
    }
    let request = {
        RecommendedCartId: $('#recommendedCartId').val(),
        ShareCode: $('#recommendedCartShareCode').val(),
        Market: $('#recommendedCartMarket').val(),
        IsEdit: $isEdit
    };
    let result = await recommendedCartService.loadRecommendedCart(request);
    if(result && result.IsSuccessful) {
        hideSpinner('Loading recommended cart completed');
        window.location.reload();
    } else {
        hideSpinner('Loading recommended cart failed');
        let errorMsg = $(this).data('cancel-failed-msg');
        setMainErrorMessage(errorMsg);
    }
}

function applePayUpdatePayload(cartTotals, isTaxInclusive, shippingOptions, selectedShippingMethodId, errors, isOrderNonShippable) {
    var update = {
        'newTotal': {
            'label': getMessage('PaymentOffice'),
            'amount': cartTotals ? cartTotals.EstimatedTotal : '0.00'
        }
    };

    if(cartTotals) {
        update.newLineItems = [
            {
                'label': 'Subtotal',
                'amount': cartTotals.CartSubTotal
            },
            {
                'label': 'Shipping',
                'amount': cartTotals.ShippingAmount
            }
        ];

        console.log(cartTotals);
        console.log($('#lbl-regular-tax'));

        if(!isTaxInclusive) {
            if(cartTotals.HasAlternateTax) {
                update.newLineItems.push({ 'label': applePayDetailVM.TaxLabel, 'amount': cartTotals.TaxesAmount });
                update.newLineItems.push({ 'label': applePayDetailVM.AlternateTaxLabel, 'amount': cartTotals.AlternateTaxesAmount });
            } else {
                update.newLineItems.push({ 'label': 'Tax', 'amount': cartTotals.TaxesAmount });
            }
        }
    }

    if(shippingOptions && isOrderNonShippable === false) {
        var lineItems = shippingOptions.map(x => {
            return {
                label: x.ServiceDisplayName,
                detail: '',
                amount: x.ShippingCharge,
                identifier: x.Id + '|' + x.ServiceName + '|' + x.ServiceDisplayName,
                selected: x.Id === selectedShippingMethodId
            };
        });

        if(lineItems) {
            update.newShippingMethods = lineItems;
        }
    }

    if(errors && errors.length) {
        update.errors = errors;
    }

    console.log(update);
    return update;
}

function initBancontact() {
    if($('#hdnbancontactToken').val() !== undefined && $('#hdnbancontactToken').val() !== '') {
        bancontactClick();
    }
}

function bancontactClick() {
    bancontactErrorInfo();
    var token = $('#hdnbancontactToken').val();
    let paymentId;
    braintree.client.create({ // eslint-disable-line
        authorization: token
    }, function (clientErr, clientInstance) {
        // Stop if there was a problem creating the client.
        // This could happen if there is a network error or if the authorization
        // is invalid.
        if(clientErr) {
            alert('Error creating client: ' + clientErr); // eslint-disable-line
            return;
        }

        braintree.localPayment.create({ // eslint-disable-line
            client: clientInstance
        }, function (localPaymentErr, localPaymentInstance) {
            // Stop if there was a problem creating local payment component.
            // This could happen if there was a network error or if it's incorrectly
            // configured.
            if(localPaymentErr) {
                alert('Error creating local payment: ' + localPaymentErr); // eslint-disable-line
                return;
            }

            // Create a local payment component.
            function createLocalPaymentClickListener(type) {
                return function (event) {
                    let orderInfo = jQuery.parseJSON($('#hdnbancontactorderdetails').val());
                    showSpinner('Starting Bancontact payment');
                    localPaymentInstance.startPayment({
                        paymentType: type.toLowerCase(),
                        amount: orderInfo.Amount,
                        // Research more on these params that can be used for mobile integration.
                        fallback: {
                            url: orderInfo.FallBackURL,
                            buttonText: BancontactFallBackButtonText
                        },
                        currencyCode: orderInfo.Currencycode,
                        givenName: orderInfo.FirstName,
                        surname: orderInfo.LastName,
                        address: {
                            countryCode: orderInfo.CountryCode
                        },
                        onPaymentStart: function (data, start) {
                            // NOTE: It is critical here to store data.paymentId on your server
                            //       so it can be mapped to a webhook sent by Braintree once the
                            //       buyer completes their payment. See Start the payment
                            //       section for details.
                            // We store it on our hidden field to serialize it later with all PayPal returned information.
                            console.log(data.paymentId);

                            // savePaypalId
                            paymentId = data.paymentId;
                            let paymentrequest = { Nonce: '', PaymentId: paymentId, OrderNumber: orderInfo.OrderNumber, OrderAmount: orderInfo.Amount };

                            // saving paymentId
                            updatePaymentPending(paymentrequest);
                            // Call start to initiate the popup
                            start();
                        }
                    }, function (startPaymentError, payload) {
                        // Log the StartPayment call
                        console.log(payload);
                        if(startPaymentError) {
                            hideSpinner('Starting Bancontact payment failed');
                            console.log('Payment error: ' + startPaymentError);
                        } else {
                            // We've initially stored our PaymentId on our hidden field, so we retrieve it and add it to PayPal received payload (nonce, payment details, etc.).

                            // call our callback function (usually PlaceOrder).
                            let request = { Nonce: payload.nonce, PaymentId: paymentId, OrderNumber: orderInfo.OrderNumber };

                            // creating sale transaction
                            checkoutbancontact(request, false);
                        }
                    });
                };
            }

            var bancontactButton = $('#btn-bancontactpopup');
            bancontactButton.on('click', createLocalPaymentClickListener(BANCONTACT));
        });
    });
}

function bancontactErrorInfo() {
    let $bancontactErrorInfo = $('#bancontact-error');
    if(!$bancontactErrorInfo.hasClass('d-none')) {
        $bancontactErrorInfo.addClass('d-none');
    }
}

async function checkoutbancontact(request, isFallBack) {
    showSpinner('Processing Bancontact payment started');
    var result = await checkoutService.processBancontact(request);
    if(result.Status === 'Success') {
        if(isFallBack) {
            $('#pending-order-success-msg').show();
            $('#pending-order-success-button').show();
        } else {
            $('#bancontact-container').hide();
            $('#confirmation-container').removeClass('d-none');
        }
        hideSpinner('Processing Bancontact payment completed');
    } else {
        if(isFallBack) {
            $('#pending-order-error-msg').show();
        } else {
            $('#hdnbancontacterror').text(result.Message);
            $('#bancontact-error').removeClass('d-none');
        }

        hideSpinner('Processing Bancontact payment failed');
    }
}

function updatePaymentPending(request) {
    checkoutService.updatePaymentPending(request);
}

function uncheckUseSamePaymentCheckboxOnTodaysPayment(paymentProviderButtonId) {
    let elementId = '#' + paymentProviderButtonId;
    let userSamePaymentValue = $(elementId).data('use-same-payment');
    let subHeader = $('#shippingSubHdr');
    let subscriptionSubHeaderDiv = $(subHeader).closest('.form-block.form-block--full');
    let isAssistedEnrollmentWithSubscription = $('#is-assisted-enrollment').val();
    let dataCopyPaymentBlock = $(subscriptionSubHeaderDiv).attr('data-copy-payment-block');
    if(userSamePaymentValue && userSamePaymentValue === 'True') {
        if(isAssistedEnrollmentWithSubscription && isAssistedEnrollmentWithSubscription === 'true') {
            if(dataCopyPaymentBlock && dataCopyPaymentBlock === 'True') {
                $('#copyPayment').prop('checked', false);
                $(subscriptionSubHeaderDiv).hide();
            }
        }
    } else {
        if(isAssistedEnrollmentWithSubscription && isAssistedEnrollmentWithSubscription === 'true') {
            if(dataCopyPaymentBlock && dataCopyPaymentBlock === 'True') {
                $('#copyPayment').prop('checked', true);
                $(subscriptionSubHeaderDiv).show();
            }
        }
    }
}

async function handleCopyLinkButtonClick() {
    const shareLinkUrl = $(this).data('sharelinkurl');
    const notificationText = $(this).data('notificationtext');
    const errorNotificationText = $(this).data('errornotificationtext');
    const hasItemsRemoved = $(this).data('has-items-removed');
    const shareCode = $('#bundleShareCode').val();
    if(hasItemsRemoved) {
        let hasUnavailableProducts = await validateBundleProductsBeforeCopyingLink(shareCode, BUNDLE_REVIEW_PAGE, $(this));
        if(hasUnavailableProducts) {
            return;
        }
    }

    // Add URL validation
    if(!shareLinkUrl || shareLinkUrl.trim() === '') {
        console.error('Share link URL is empty or invalid');
        toast.Error(errorNotificationText, ERROR_TOAST_EXPIRATION_MS);
        return;
    }

    try {
        navigator.clipboard
            .writeText(shareLinkUrl)
            .then(() => {
                const originalText = $(this).text();
                $(this).text(notificationText);
                $(this).addClass('copied');

                setTimeout(() => {
                    $(this).text(originalText);
                    $(this).removeClass('copied');
                }, 4000);
            })
            .catch((err) => {
                console.error('Failed to copy text: ', err);
                toast.Error(errorNotificationText, ERROR_TOAST_EXPIRATION_MS);
            });
    } catch (ex) {
        console.error('error while copying share link:', ex);
        toast.Error(errorNotificationText, ERROR_TOAST_EXPIRATION_MS);
    }
}

async function validateBundleProductsBeforeCopyingLink(sharecode, action, $this) {
    let request = {
        ShareCode: sharecode,
        Action: action,
        IsBundle: true
    };
    try {
        showSpinner('Validating bundle products started');
        let result = await recommendedCartService.validateRecommendedCartProducts(request);

        if(!result.IsSuccessful) {
            hideSpinner('Validating bundle products failed');
            let modalData = $($this).data('validate');
            modalData.hideCloseButton = false;
            modalData.className = 'bundle';
            let errorList = '';
            $.each(result.Messages, function () {
                errorList += '<div>' + this.MessageText + '</div>';
            });
            modalData.content = errorList;
            modalUtil.showError(result, modalData, editProductBundle);
            return true;
        }
    } catch (e) {
        hideSpinner('Validating bundle products failed');
        console.log(e);
    }
    hideSpinner('Validating bundle products completed');
    return false;
}

async function editProductBundle() {
    showSpinner('editing product bundle started');
    let request = null;
    if($('#bundleShareLinkId').length && $('#bundleShareCode').length) {
        request = {
            ShareLinkId: Number($('#bundleShareLinkId').val()),
            IsView: false,
            IsDuplicate: false,
            IsEdit: true,
            IsBundle: true,
            ShareCode: $('#bundleShareCode').val(),
            Market: $('#bundleMarket').val()
        };
    }
    if(request != null) {
        const result = await recommendedCartService.LoadBundle(request);
        if(result && result.IsSuccessful) {
            hideSpinner('editing product bundle completed');
            window.location.reload();
        } else {
            hideSpinner('editing product bundle failed');
            if(result && result.Messages) {
                const message = result.Messages.find(m => m.MessageText !== null);
                if(message) {
                    console.log(message.MessageText);
                    toast.Error(message.MessageText);
                }
            }
        }
    }
    hideSpinner('editing product bundle completed');
}

function loadIndexNameIfExists() {
    INDEX_NAME = window.algoliaData.searchIndexName;
}

$(function () {
    initEventHandlers();
    checkForCountryFields();
    initCvvOnPaymentLoad();
    // Run once more after event-driven UI initialization settles.
    setTimeout(syncCvvVisibilityForSavedCardContext, 0);
});

$(window).on('load', function () {
    if($('#recommendedCartName').length) {
        const value = $('#recommendedCartName').val();
        if(value && value !== null) {
            $('#recommendedCartName').trigger('input');
        }
    }
});
